import React, { useState, useEffect, useContext, useMemo, useCallback, useRef } from "react";
import { rangoFechasValido, ESPERA_CAMBIO_FECHA_MS } from "../../../../utils/rangoFechasValido";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";

import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import {
  createTicketPDF,
  THERMAL_PAPER_SIZES,
  setFontStyle,
  formatCurrency,
  formatNumber,
  calculateTicketHeight,
  applyStyle,
  openTicketPDF,
} from "../../../../utils/pdfTicketUtils";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import StatusMultiple from "../../StatusMultiple";
import fmtFecha from "../../../../utils/fmtFecha";
import StatusMultipleSurtido from "../../StatusMultipleSurtido";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import moment from "moment";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";

// Formateadores constantes fuera del componente — se crean una sola vez (no en cada render)
const fmtCurrency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});
const fmtNumber = new Intl.NumberFormat("en-US");

function ListadoPedidos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_ARTICULOS = import.meta.env.VITE_URL_ARTICULOS;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;
  const URL_PEDIDOS = import.meta.env.VITE_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = import.meta.env.VITE_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_PROPORCION = import.meta.env
    .VITE_URL_ARTICULOS_PROPORCION;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;
  const PASSWORD_CAMBIA_PRECIO = import.meta.env.VITE_PASSWORD_CAMBIA_PRECIO;
  const PASSWORD_CANCELAR_PRENDAS = import.meta.env.VITE_PASSWORD_CANCELAR_PRENDAS;
  const URL_PAQUETERIAS = import.meta.env.VITE_URL_PAQUETERIAS;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;
  const URL_ABONOS = import.meta.env.VITE_URL_ABONOS;
  const URL_ANTICIPOS = import.meta.env.VITE_URL_ANTICIPOS;
  const URL_BANCOS = import.meta.env.VITE_URL_BANCOS;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;
  const URL_INVENTARIOS_BODEGA_PEDIDO = import.meta.env.VITE_URL_INVENTARIOS_DISPONIBLE_BODEGA_PEDIDO;
  const URL_FILEPOST = import.meta.env.VITE_URL_UPPROFILE_ABONO;
  const VITE_URL_GETMEDIA = import.meta.env.VITE_URL_GETMEDIA;
  const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;

  // Fechas calculadas una sola vez al montar (no en cada render)
  const endDate = useMemo(() => moment(new Date()).format("YYYY-MM-DD"), []);
  const startDate = useMemo(() => {
    const inicio = new Date();
    inicio.setDate(inicio.getDate() - 90);
    return moment(inicio).format("YYYY-MM-DD");
  }, []);

  const [articulos, setArticulos] = useState([]);
  const [inventarios, setInventarios] = useState([]);
  const [cargandoInventarios, setCargandoInventarios] = useState(false);
  const [paqueterias, setPaqueterias] = useState([]);
  const [bancos, setBancos] = useState([]);
  
  // Estado para rastrear incrementos acumulados desde carga inicial
  const [incrementosAcumulados, setIncrementosAcumulados] = useState({});

  // Estado para manejar precios especiales seleccionados
  const [selectedSpecialPrices, setSelectedSpecialPrices] = useState({});

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [paqueteria, setPaqueteria] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [fecha, setFecha] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [numero_pedido, setNumeroPedido] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [selectedClienteEdit, setSelectedClienteEdit] = useState("");
  const [selectedColaboradorEdit, setSelectedColaboradorEdit] = useState("");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);
  const [iva, setIva] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [surtido, setSurtido] = useState("");
  const [areaSurtido, setAreaSurtido] = useState("");
  const [nombreClienteEdit, setNombreClienteEdit] = useState("");
  const [fechaModificado, setFechaModificado] = useState("");

  const [articulosPedido, setArticulosPedido] = useState([]);
  const [cargandoArticulosPedido, setCargandoArticulosPedido] = useState(false);
  const [expandedTables, setExpandedTables] = useState({});

  // Helper function to sort articles by insertion order (createdAt ascending)
  const sortArticulosPedido = (articles) => {
    return [...articles].sort((a, b) => {
      const aDate = a.createdAt ? new Date(a.createdAt) : new Date(0);
      const bDate = b.createdAt ? new Date(b.createdAt) : new Date(0);
      return aDate - bDate;
    });
  };

  const [inputArticulos, setInputArticulos] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cajas: 0,
      precio: 0,
      precioOriginal: 0,
      articulosNombre: "",
      colores: [],
      tallas: [],
      EAN: "",
      precioEsp: "No",
    },
  ]);

  // Ref y estado para el scanner con debounce (pistolas con/sin enter automático)
  const scannerTimeoutRef = useRef(null);
  const [scannerInput, setScannerInput] = useState("");

  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  const [total_cantidad_edit, setTotalCantidadEdit] = useState(0);
  const [selectedAreaEditVieja, setSelectedAreaEditVieja] = useState("");
  const [selectedAreaEdit, setSelectedAreaEdit] = useState("");
  const [descuentoEdit, setDescuentoEdit] = useState("");
  const [descuentoNumeroEdit, setDescuentoNumeroEdit] = useState(0);
  const [descuentoImporteEdit, setDescuentoImporteEdit] = useState(0);
  // Refs para evitar ciclo de re-cálculo entre % y $
  const descuentoEditRef = useRef(0);
  const descuentoImporteEditRef = useRef(0);
  const discountModeEditRef = useRef('percent'); // 'percent' | 'amount'
  const [saldoEdit, setSaldoEdit] = useState(0);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);

  const [inputFields, setInputFields] = useState([]);

  // Move comments state here BEFORE ActualizaTotales useCallback to avoid "Cannot access before initialization" error
  const [comments, setComments] = useState([]);
  // Ref para acceder a comments y idEdit dentro de ActualizaTotales sin ponerlos en los deps
  const commentsRef = useRef([]);
  const idEditRef = useRef("");
  // Valores originales de los renglones al abrir el pedido, para registrar correcciones en la bitácora
  const articulosPedidoOriginalRef = useRef([]);
  useEffect(() => { commentsRef.current = comments; }, [comments]);
  useEffect(() => { idEditRef.current = idEdit; }, [idEdit]);

  // Define ActualizaTotales as useCallback BEFORE the useEffect that uses it
  const ActualizaTotales = useCallback(() => {
    // Filter only active items (not cancelled)
    let activos = articulosPedido.filter((e) => e.is_active === "Si");
    let activos2 = activos.concat(inputFields);

    let cantidadActivos = activos2.map((c) => parseFloat(c.cantidad));
    let TA = cantidadActivos.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TA);

    let totalActivos = activos2.map((c) => parseFloat(c.total));
    let TG = totalActivos.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG.toFixed(2));

    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }

    // Calcular descuento según modo activo, usando refs para evitar ciclos
    let descImporte;
    if (discountModeEditRef.current === 'amount') {
      descImporte = descuentoImporteEditRef.current;
      if (TG > 0) {
        const newPct = parseFloat(((descImporte / TG) * 100).toFixed(2));
        setDescuentoEdit(newPct);
        descuentoEditRef.current = newPct;
      }
    } else {
      descImporte = parseFloat(((TG * descuentoEditRef.current) / 100).toFixed(2));
      setDescuentoImporteEdit(descImporte);
      descuentoImporteEditRef.current = descImporte;
    }

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      descImporte;

    setTotalGeneralEdit(totTemp.toFixed(2));

    // Calculate saldo — usa refs para no depender de comments/idEdit y evitar re-creaciones innecesarias
    const pedidoEnEdicion = commentsRef.current.find((p) => p._id === idEditRef.current);
    const abonosActuales = pedidoEnEdicion ? pedidoEnEdicion.abonos || 0 : 0;
    const nuevoSaldo = totTemp - parseFloat(abonosActuales);
    setSaldoEdit(nuevoSaldo.toFixed(2));

    setFechaModificado(endDate);
  }, [articulosPedido, inputFields, selectedImpuesto, comisionTDC, comisionFlete, endDate]);

  useEffect(() => {
    ActualizaTotales();
  }, [inputFields, ActualizaTotales]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [status, setStatus] = useState("Abierto");
  const [autorizadoApartado, setAutorizadoApartado] = useState("");
  const [autorizadoSurtido, setAutorizadoSurtido] = useState("");

  const [cambiarPrecio, setCambiarPrecio] = useState(false);
  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  // Estados para autorización de cancelar prendas
  const [cancelarPrendas, setCancelarPrendas] = useState(false);
  const [modalCancelarPrendas, setModalCancelarPrendas] = useState(false);
  const toggleCancelarPrendas = () => setModalCancelarPrendas(!modalCancelarPrendas);
  const [passwordCancelar, setPasswordCancelar] = useState("");
  const [itemToCancelId, setItemToCancelId] = useState(null);

  // Estados para modal de abonos
  const [modalAbonos, setModalAbonos] = useState(false);
  const toggleAbonos = () => setModalAbonos(!modalAbonos);
  const [totalGeneralAbono, setTotalGeneralAbono] = useState(0);
  const [totalAbono, setTotalAbono] = useState(0);
  const [saldoAbono, setSaldoAbono] = useState(0);
  const [abonoData, setAbonoData] = useState({
    importe: 0,
    formaPago: "",
    concepto: "Abono a Pedido",
    observaciones: "",
    banco: "",
    fechaPago: moment().format("YYYY-MM-DD"),
    imagen: null,
  });
  const [selectedPedidoAbono, setSelectedPedidoAbono] = useState("");
  const [selectedClienteAbono, setSelectedClienteAbono] = useState("");
  const [selectedColaboradorAbono, setSelectedColaboradorAbono] = useState("");
  const [abonosExistentes, setAbonosExistentes] = useState([]);
  const [cargandoAbonos, setCargandoAbonos] = useState(false);

  // Estados para modal de preview de imagen
  const [modalImagenPreview, setModalImagenPreview] = useState(false);
  const toggleImagenPreview = () => setModalImagenPreview(!modalImagenPreview);
  const [imagenPreview, setImagenPreview] = useState("");
  const [abonoImagenSeleccionado, setAbonoImagenSeleccionado] = useState(null);

  // Estados para fotos de productos
  const [productPhotos, setProductPhotos] = useState({});
  const [loadingPhotos, setLoadingPhotos] = useState({});

  //--- Pagination (comments state moved above ActualizaTotales)
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const [AbrirEditar, setAbrirEditar] = useState(false);

  // Arrays ordenados memoizados — se recalculan solo cuando cambia la lista, no en cada render
  const sortedClientes = useMemo(
    () => [...clientes].sort((a, b) => a.nombre_comercial > b.nombre_comercial ? 1 : -1),
    [clientes]
  );
  const sortedColaboradores = useMemo(
    () => [...colaboradores].sort((a, b) => a.nombre > b.nombre ? 1 : -1),
    [colaboradores]
  );
  const sortedAreas = useMemo(
    () => [...areas].sort((a, b) => a.name > b.name ? 1 : -1),
    [areas]
  );
  const sortedPaqueterias = useMemo(
    () => [...paqueterias].sort((a, b) => a.name > b.name ? 1 : -1),
    [paqueterias]
  );

  const ITEMS_PER_PAGE = 50;

  // useEffect para datos del listado principal — solo al montar (clientes, colaboradores, áreas para los filtros)
  useEffect(() => {
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    axios.get(URL_CLIENTES, { headers }).then((r) => setClientes(r.data)).catch(console.log);
    axios.get(URL_COLABORADORES, { headers }).then((r) => setColaboradores(r.data)).catch(console.log);
    axios.get(URL_AREAS, { headers }).then((r) => setAreas(r.data)).catch(console.log);
    // articulos, tallas, inventarios, paqueterias y bancos se cargan de forma lazy
    // cuando el usuario abre el modal de edición o el modal de abonos
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Convierte un pedido del API en la fila de la tabla (undefined si el pedido está inactivo).
  // Se usa al cargar el rango de fechas y al refrescar UNA sola fila tras una acción.
  const filaDePedido = (a) => {
            if(a.is_active == "Si"){
            return {
              _id: a._id,
              numero: a.idPedido,
              activo: a.is_active,
              fecha: a.fecha,
              colaboradores:
                a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
              idColaboradores: a.colaboradores[0]._id,
              observaciones: a.observaciones,
              subTotal: a.subTotal,
              iva: a.iva,
              total_general: parseFloat(a.total_general || 0),
              clientes: a.clientes[0].nombre_comercial,
              idClientes: a.clientes[0]._id,
              total_cantidad: a.total_cantidad,
              status: a.status,
              bloqueado: a.bloqueado,
              autorizadoApartado: a.autorizadoApartado,
              autorizadoSurtido: a.autorizadoSurtido,
              comisionTDC: a.comisionTDC,
              comisionFlete: a.comisionFlete,
              impuestos: a.impuestos,
              paqueteria: a.paqueterias[0].name,
              idPaqueteria: a.paqueterias[0]._id,
              areaName: a.areas[0].name,
              idArea: a.areas[0]._id,
              surtido: a.surtido,
              codigoClientes: a.clientes[0].codigo,
              alias: "Principal",
              calle: a.clientes[0].calle,
              numero_ext: a.clientes[0].numero_ext,
              numero_int: a.clientes[0].numero_int,
              pais: a.clientes[0].pais,
              estado: a.clientes[0].estado,
              ciudad: a.clientes[0].ciudad,
              delegacion: a.clientes[0].delegacion,
              colonia: a.clientes[0].colonia,
              cp: a.clientes[0].cp,
              RFC: a.clientes[0].RFC,
              area: a.areas[0].name,
              fechaModificado: a.fechaModificado,
              telefono: a.clientes[0].telefono,
              editado: a.editado,
              editPedido: a.editPedido,
              autorizoApartado: a.autorizoApartado,
              autorizoSurtido: a.autorizoSurtido,
              descuento: a.descuento,
              descuentoImporte: a.descuentoImporte || 0,
              creado: a.creado[0].nombre + " " + a.creado[0].apellido,
              fechaHora:
                moment(a.createdAt).utcOffset("-0600").format("DD-MM-YYYY") +
                " " +
                moment(a.createdAt).utcOffset("-0600").format("HH:mm:ss"),
              abonos: a.abonos,
              saldo: parseFloat(a.saldo || 0),
              updatedAt: a.updatedAt,
              fechaContador: a.fechaContador,
              fechaCierre: a.fechaCierre || "",
            };
          }};

  const [cargandoPedidos, setCargandoPedidos] = useState(false);

  // useEffect para pedidos — se re-ejecuta cuando cambia el rango de fechas
  useEffect(() => {
    const controller = new AbortController();
    // Al cambiar el rango se CANCELA la consulta anterior (cleanup abajo: abort() corta la
    // petición y el servidor aborta su consulta a Mongo) y se lanza la nueva. No se consulta un
    // rango incompleto/absurdo (mientras se teclea el año) ni invertido, y se espera a que el
    // usuario termine de cambiar la fecha para no disparar una consulta por tecla.
    if (!rangoFechasValido(selectedFechaInicio, selectedFechaFin)) {
      setCargandoPedidos(false);
      return undefined;
    }
    setCargandoPedidos(true);
    const espera = setTimeout(() => {
    axios
      .get(`${URL_PEDIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
        signal: controller.signal,
      })
      .then((response) => {
        let allPedidos = response.data;
        let arrayTabla = allPedidos
          .sort((a, b) => (a.idPedido < b.idPedido ? 1 : -1))
          .map(filaDePedido)
          .filter(function (el) {
            return el != null;
          });

        setComments(Object.values(arrayTabla));
        setCargandoPedidos(false);
      })
      .catch((err) => {
        if (axios.isCancel(err)) return;
        console.log(err);
        setCargandoPedidos(false);
      });
    }, ESPERA_CAMBIO_FECHA_MS);
    return () => {
      clearTimeout(espera);
      controller.abort();
    };
  }, [selectedFechaInicio, selectedFechaFin]); // eslint-disable-line react-hooks/exhaustive-deps

  // Refresca SOLO la fila de un pedido con GET /pedidos/:id (unos KB). Reemplaza a
  // window.location.reload(), que obligaba a volver a bajar clientes + pedidos de 90 días
  // (~25 MB) + artículos + inventarios en cada acción. Si el pedido ya no aplica (inactivo),
  // se quita de la tabla. Devuelve la fila nueva o null.
  async function refrescarFilaPedido(pedidoId) {
    if (!pedidoId) return null;
    try {
      const r = await axios.get(`${URL_PEDIDOS}/${pedidoId}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      const fila = filaDePedido(r.data) || null;
      if (fila) {
        // GET /pedidos/:id trae los usuarios completos; la tabla (pedidosFechas) solo guarda
        // nombre y apellido. Se reduce al mismo formato para no cargar permisos en el estado.
        const soloNombre = (arr) =>
          Array.isArray(arr)
            ? arr.map((u) => (u && typeof u === "object" ? { _id: u._id, nombre: u.nombre, apellido: u.apellido } : u))
            : arr;
        fila.editPedido = soloNombre(fila.editPedido);
        fila.autorizoSurtido = soloNombre(fila.autorizoSurtido);
      }
      setComments((prev) =>
        fila
          ? prev.map((x) => (x._id === pedidoId ? fila : x))
          : prev.filter((x) => x._id !== pedidoId)
      );
      return fila;
    } catch (err) {
      console.log("No se pudo refrescar el pedido:", err);
      return null;
    }
  }

  // Después de guardar la edición de un pedido: volver a la lista, refrescar esa fila e
  // invalidar el caché de disponibilidad (la edición cambió lo apartado; se vuelve a pedir
  // al abrir la siguiente edición, igual que pasaba con la recarga completa).
  function finalizarEdicionPedido() {
    // Estados que savePedido deja a medias en el camino exitoso (antes los limpiaba el reload):
    // el modal "Progreso" y el botón Guardar deshabilitado.
    Swal.close();
    setModalProgreso(false);
    setValidaBoton(true);
    setAbrirEditar(false);
    setInventarios([]);
    refrescarFilaPedido(idEditRef.current);
  }

  // Después de validar/invalidar un abono: el backend movió saldo/abonos del pedido, así que
  // se refresca la fila y los totales del modal de abonos (sin recargar toda la app).
  function actualizarTrasAbono() {
    refrescarFilaPedido(selectedPedidoAbono).then((fila) => {
      if (fila) {
        setTotalAbono(fila.abonos);
        setSaldoAbono(fila.saldo);
      }
    });
  }


  // Función para validar disponibilidad de inventario
  function checkInventoryAvailability(idArticulo, idColor, idTalla, cantidadSolicitada, cantidadExistentePedido = 0, esArticuloNuevo = false) {
    // FORZAR: Siempre requerir inventarios cargados antes de cualquier operación
    if (!Array.isArray(inventarios) || inventarios.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Inventarios requeridos",
        text: "Debe esperar a que se carguen los inventarios antes de realizar cualquier modificación",
        timer: 4000,
        showConfirmButton: false,
      });
      return false;
    }

    // Si la cantidad solicitada es 0 o negativa, permitir (puede ser que esté borrando)
    if (cantidadSolicitada <= 0) {
      return true;
    }

    // Usar la misma estructura que en PedidosCreate.jsx
    const inventarioItem = inventarios.find(
      (inv) =>
        String(inv.idArticulo) === String(idArticulo) &&
        String(inv.idColor) === String(idColor) &&
        String(inv.idTalla) === String(idTalla)
    );

    if (!inventarioItem) {
      Swal.fire({
        icon: "error",
        title: "Sin inventario",
        text: "No hay inventario disponible para este artículo, color y talla",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }

    // CORRECCIÓN: Calcular el máximo permitido (inventario original + cantidad existente del pedido)
    // Esto permite tomar exactamente el total disponible, incluso cuando disponible dinámico = 0
    const maximoPermitido = (inventarioItem.disponible || 0) + cantidadExistentePedido;
    
    // CORRECCIÓN: Validar contra el máximo permitido en lugar de disponible dinámico
    if (cantidadSolicitada > maximoPermitido) {
      Swal.fire({
        icon: "error",
        title: "Inventario insuficiente",
        text: `Solo hay ${maximoPermitido} unidades disponibles (${inventarioItem.disponible} en inventario${cantidadExistentePedido > 0 ? ` + ${cantidadExistentePedido} liberados del pedido` : ''}). Cantidad solicitada: ${cantidadSolicitada}`,
        timer: 4000,
        showConfirmButton: false,
      });
      return false;
    }

    return true;
  }

  // Función para obtener inventario disponible para validación considerando cantidad existente del pedido
  function getInventoryAvailableForValidation(idArticulo, idColor, idTalla, cantidadExistentePedido = 0) {
    if (!Array.isArray(inventarios) || inventarios.length === 0) {
      return 0;
    }

    const inventarioItem = inventarios.find(
      (inv) =>
        String(inv.idArticulo) === String(idArticulo) &&
        String(inv.idColor) === String(idColor) &&
        String(inv.idTalla) === String(idTalla)
    );

    if (!inventarioItem) {
      return 0;
    }

    // Crear clave única para el producto
    const claveProducto = `${idArticulo}-${idColor}-${idTalla}`;

    // Obtener incrementos acumulados para este producto
    const incrementoAcumulado = incrementosAcumulados[claveProducto] || 0;

    // Calcular disponible para validación: inventario original + cantidad existente del pedido - incrementos acumulados
    const disponibleParaValidacion = (inventarioItem.disponible || 0) + cantidadExistentePedido - incrementoAcumulado;
    
    // Nunca devolver menos de 0
    return Math.max(0, disponibleParaValidacion);
  }

  // Función para obtener inventario disponible dinámico considerando incrementos acumulados
  function getInventoryAvailable(idArticulo, idColor, idTalla) {
    if (!Array.isArray(inventarios) || inventarios.length === 0) {
      return 'Cargando...';
    }

    const inventarioItem = inventarios.find(
      (inv) =>
        String(inv.idArticulo) === String(idArticulo) &&
        String(inv.idColor) === String(idColor) &&
        String(inv.idTalla) === String(idTalla)
    );

    if (!inventarioItem) {
      return 0;
    }

    // Crear clave única para el producto
    const claveProducto = `${idArticulo}-${idColor}-${idTalla}`;

    // Obtener incrementos acumulados para este producto
    const incrementoAcumulado = incrementosAcumulados[claveProducto] || 0;
    
    // Calcular disponible dinámico: inventario original - incrementos acumulados
    const disponibleDinamico = (inventarioItem.disponible || 0) - incrementoAcumulado;
    
    // Nunca devolver menos de 0
    return Math.max(0, disponibleDinamico);
  }

  // Función para registrar incremento de inventario usado
  function registrarIncrementoInventario(idArticulo, idColor, idTalla, incremento) {
    if (incremento !== 0) {
      const claveProducto = `${idArticulo}-${idColor}-${idTalla}`;
      
      setIncrementosAcumulados(prev => {
        const nuevo = { ...prev };
        nuevo[claveProducto] = (nuevo[claveProducto] || 0) + incremento;
        
        return nuevo;
      });
    }
  }

  // Función para reiniciar incrementos cuando se carga un pedido
  function reiniciarIncrementosAcumulados() {
    setIncrementosAcumulados({});
  }

  // Función helper para generar opciones de precios disponibles
  const getPriceOptions = (articulo) => {
    if (!articulo) return [];

    const options = [];
    
    if (articulo.listaPrecioPieza && articulo.listaPrecioPieza > 0) {
      options.push({
        label: `$${articulo.listaPrecioPieza.toFixed(2)} Pieza`,
        value: articulo.listaPrecioPieza,
        type: 'pieza'
      });
    }
    
    if (articulo.listaPrecioCorrida && articulo.listaPrecioCorrida > 0) {
      options.push({
        label: `$${articulo.listaPrecioCorrida.toFixed(2)} Corrida`,
        value: articulo.listaPrecioCorrida,
        type: 'corrida'
      });
    }
    
    if (articulo.listaPrecioPaquete && articulo.listaPrecioPaquete > 0) {
      options.push({
        label: `$${articulo.listaPrecioPaquete.toFixed(2)} Paquete`,
        value: articulo.listaPrecioPaquete,
        type: 'paquete'
      });
    }
    
    if (articulo.listaPrecioCaja && articulo.listaPrecioCaja > 0) {
      options.push({
        label: `$${articulo.listaPrecioCaja.toFixed(2)} Caja`,
        value: articulo.listaPrecioCaja,
        type: 'caja'
      });
    }
    
    if (articulo.listaPrecioRebajas && articulo.listaPrecioRebajas > 0) {
      options.push({
        label: `$${articulo.listaPrecioRebajas.toFixed(2)} Rebajas`,
        value: articulo.listaPrecioRebajas,
        type: 'rebajas'
      });
    }

    // Filtrar opciones duplicadas basándose en el valor
    const uniqueOptions = options.filter((option, index, self) =>
      index === self.findIndex((opt) => opt.value === option.value)
    );

    return uniqueOptions;
  };

  // Componente para renderizar selector de precios especiales
  const PriceSelector = ({ articulo, currentPrice, onPriceChange, disabled, itemId }) => {
    if (!articulo || articulo.precioEsp !== "Si") {
      // Renderizar input normal para artículos sin precio especial
      return (
        <Input
          type="number"
          min="0"
          step="0.01"
          value={currentPrice}
          disabled={disabled}
          onChange={(e) => onPriceChange(parseFloat(e.target.value) || 0)}
          size="sm"
          style={{ width: "90px" }}
        />
      );
    }

    // Renderizar dropdown para artículos con precio especial
    const priceOptions = getPriceOptions(articulo);

    return (
      <Input
        type="select"
        value={currentPrice}
        disabled={disabled}
        onChange={(e) => onPriceChange(parseFloat(e.target.value) || 0)}
        size="sm"
        style={{ width: "120px" }}
      >
        <option value="">Seleccionar precio</option>
        {priceOptions.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Input>
    );
  };

  // Función para manejar cambios de precios especiales en grupos
  const handleGroupPriceChange = (grupo, nuevoPrecio) => {
    // Actualizar todos los artículos del mismo grupo (artículo + color)
    const articulosActualizados = articulosPedido.map(item => {
      if (item.articulos === grupo.articulos && item.idColor === grupo.idColor) {
        const nuevoTotal = item.cantidad * nuevoPrecio;
        return {
          ...item,
          precio: nuevoPrecio,
          total: nuevoTotal
        };
      }
      return item;
    });

    setArticulosPedido(articulosActualizados);
    ActualizaTotales();
  };

  // Función para cargar foto de producto
  const fetchProductPhoto = async (articuloId) => {
    if (productPhotos[articuloId] || loadingPhotos[articuloId]) return;
    
    setLoadingPhotos(prev => ({...prev, [articuloId]: true}));
    
    try {
      const URL_GET_MEDIA = `${VITE_URL_GETMEDIA}/${articuloId}`;
      const response = await axios.get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      
      if (response.data.secure_url) {
        setProductPhotos(prev => ({
          ...prev,
          [articuloId]: response.data.secure_url
        }));
      } else if (response.data.version) {
        setProductPhotos(prev => ({
          ...prev,
          [articuloId]: response.data.version
        }));
      }
    } catch (err) {
      console.log('Error fetching photo:', err);
    } finally {
      setLoadingPhotos(prev => ({...prev, [articuloId]: false}));
    }
  };

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio === "" || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin === "" || selectedFechaFin >= a.fecha) &&
        (status === "" || status === a.status) &&
        (autorizadoApartado === "" ||
          autorizadoApartado === a.autorizadoApartado) &&
        (autorizadoSurtido === "" ||
          autorizadoSurtido === a.autorizadoSurtido) &&
        (selectedCliente === "" || selectedCliente === a.idClientes)
      ) {
        return [
          a.numero,
          a.fecha,
          a.colaboradores,
          a.clientes,
          a.total_cantidad,
          fmtCurrency.format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Pedidos`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Vendedor", "Cliente", "Cantidad", "Total"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Pedidos.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio === "" || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin === "" || selectedFechaFin >= a.fecha) &&
        (status === "" || status === a.status) &&
        (autorizadoApartado === "" ||
          autorizadoApartado === a.autorizadoApartado) &&
        (autorizadoSurtido === "" ||
          autorizadoSurtido === a.autorizadoSurtido) &&
        (selectedCliente === "" || selectedCliente === a.idClientes)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Vendedor: a.colaboradores,
          Cliente: a.clientes,
          Cantidad: a.total_cantidad,
          Total: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoPedidos";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoPedidos",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "Total",
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cantidad",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio === "" || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin === "" || selectedFechaFin >= a.fecha) &&
        (status === "" || status === a.status) &&
        (autorizadoApartado === "" ||
          autorizadoApartado === a.autorizadoApartado) &&
        (autorizadoSurtido === "" ||
          autorizadoSurtido === a.autorizadoSurtido) &&
        (selectedCliente === "" || selectedCliente === a.idClientes)
      ) {
        return [
          a.numero,
          a.fecha,
          a.colaboradores,
          a.clientes,
          a.total_cantidad,
          fmtCurrency.format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Ordenes de Produccion`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Vendedor", "Cliente", "Cantidad", "Total"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Pedidos",
          email: mailTo,
          fileName: "ListadoPedidos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${
           import.meta.env.VITE_TAMANO_LOGO_MAIL
         }" align="center" src="${
            import.meta.env.VITE_LINK_SISTEMA
          }logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${
           import.meta.env.VITE_NOMBRE_INSTITUCION
         }</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Pedidos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${
           import.meta.env.VITE_TELEFONO_INSTITUCION
         }</tr>
         <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${
           import.meta.env.VITE_LINK_SISTEMA
         }Logo-Sistemify-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        // Sin reload: enviar el correo no modifica datos.
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  const options = useMemo(() => articulos.map((option) => {
    const junta = option.codigo;
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  }), [articulos]);
  const handleChangeInputProporcion = (id, event) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        return { ...i, [event.target.name]: event.target.value };
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  // Función para manejar el cambio del input del scanner con debounce
  const handleScannerInputChange = (value) => {
    setScannerInput(value);

    // Limpiar timeout anterior
    if (scannerTimeoutRef.current) {
      clearTimeout(scannerTimeoutRef.current);
    }

    // Si el valor tiene longitud suficiente, esperar y procesar automáticamente
    if (value && value.length >= 5) {
      scannerTimeoutRef.current = setTimeout(() => {
        procesarCodigoScanner(value);
      }, 300); // 300ms de debounce para pistolas sin enter automático
    }
  };

  // Función para manejar Enter en el scanner (previene submit del formulario)
  const handleScannerKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      // Limpiar timeout pendiente
      if (scannerTimeoutRef.current) {
        clearTimeout(scannerTimeoutRef.current);
      }
      if (scannerInput && scannerInput.length >= 2) {
        procesarCodigoScanner(scannerInput);
      }
    }
  };

  // Función principal para procesar el código escaneado en "Agregar Caja"
  // Esta función llena inputArticulos para que el usuario pueda seleccionar cuántas cajas agregar
  async function procesarCodigoScanner(scanValue) {
    // Validate the scan value exists
    if (!scanValue || scanValue.length < 2) {
      return;
    }

    // Limpiar el input inmediatamente para evitar doble procesamiento
    setScannerInput("");

    // Búsqueda con trim para tolerar espacios o retornos de carro del scanner
    const scanValueTrimmed = scanValue.trim();

    // Buscar en artículos locales por EAN (código de barras)
    const foundArticleByEAN = articulos.find((a) =>
      a.EAN && (a.EAN === scanValueTrimmed || a.EAN.trim() === scanValueTrimmed)
    );

    if (foundArticleByEAN) {
      // Encontrado por EAN - llenar inputArticulos para agregar cajas
      const idArticulo = foundArticleByEAN._id;
      const articulosNombre = `${foundArticleByEAN.codigo} ${foundArticleByEAN.nombre}`;
      const precio = foundArticleByEAN.venta;
      const colores = foundArticleByEAN.colores;
      const tallas = foundArticleByEAN.tallas;
      const precioEsp = foundArticleByEAN.precioEsp || "No";

      handleChangeInputArticuloProporcion(
        inputArticulos[0]?.id || "template",
        idArticulo,
        precio,
        articulosNombre,
        colores,
        tallas,
        scanValueTrimmed,
        precioEsp
      );

      // Cargar foto del producto
      fetchProductPhoto(idArticulo);
      return;
    }

    // Función auxiliar para buscar artículo en API
    const buscarArticuloEnAPI = async () => {
      // Primero intentar por EAN
      try {
        const resByEAN = await axios.get(
          `${URL_ARTICULOS_PROPORCION}/EAN/${scanValueTrimmed}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_token")}`,
            },
          }
        );
        if (resByEAN.data) return resByEAN;
      } catch (error) {
        console.error("Error buscando por EAN:", error);
      }

      // Si no se encuentra y es un ObjectId válido, intentar por _id
      const isValidObjectId = /^[a-fA-F0-9]{24}$/.test(scanValueTrimmed);
      if (isValidObjectId) {
        try {
          const resById = await axios.get(
            `${URL_ARTICULOS_PROPORCION}/${scanValueTrimmed}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_token")}`,
              },
            }
          );
          if (resById.data) return resById;
        } catch (error) {
          console.error("Error buscando por ID:", error);
        }
      }

      return null;
    };

    const res = await buscarArticuloEnAPI();

    if (!res || !res.data) {
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
      return;
    }

    const {
      articulos: articulosArray,
      colores,
      tallas,
    } = res.data;

    const firstArticulo = articulosArray?.[0];

    // Check if any required data is missing
    if (!firstArticulo || !colores?.length || !tallas?.length) {
      Swal.fire({
        icon: "error",
        title: "Datos incompletos",
        text: "El artículo no tiene datos completos de color o talla",
      });
      return;
    }

    // Encontrado en artículos-proporción - llenar inputArticulos con el artículo base
    const idArticulo = firstArticulo._id;
    const articulosNombre = `${firstArticulo.codigo} ${firstArticulo.nombre}`;
    const precio = firstArticulo.venta;
    const precioEsp = firstArticulo.precioEsp || "No";

    handleChangeInputArticuloProporcion(
      inputArticulos[0]?.id || "template",
      idArticulo,
      precio,
      articulosNombre,
      firstArticulo.colores || colores,
      firstArticulo.tallas || tallas,
      scanValue,
      precioEsp
    );

    // Cargar foto del producto
    fetchProductPhoto(idArticulo);
  }

  function BuscaArticuloProporcion(id, selectedArticulo) {
    const foundArticle = articulos.find(
      (a) => a.EAN === selectedArticulo.target.value
    );

    if (foundArticle) {
      const idArticulo = foundArticle._id;
      const articulosNombre = `${foundArticle.codigo} ${foundArticle.nombre}`;
      const precio = foundArticle.venta;
      const colores = foundArticle.colores;
      const tallas = foundArticle.tallas;
      const precioEsp = foundArticle.precioEsp || "No";

      handleChangeInputArticuloProporcion(
        id,
        idArticulo,
        precio,
        articulosNombre,
        colores,
        tallas,
        selectedArticulo._id,
        precioEsp
      );

      // Cargar foto del producto
      fetchProductPhoto(idArticulo);
    } else {
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
    }
  }

  function BuscaArticuloProporcion2(id, selectedArticulo) {
    const foundArticle = articulos.find((a) => a._id === selectedArticulo._id);

    if (foundArticle) {
      const idArticulo = selectedArticulo._id;
      const articulosNombre = `${selectedArticulo.codigo} ${selectedArticulo.nombre}`;
      const precio = foundArticle.venta;
      const colores = foundArticle.colores;
      const tallas = foundArticle.tallas;
      const EAN = foundArticle.EAN;
      const precioEsp = foundArticle.precioEsp || "No";

      handleChangeInputArticuloProporcion(
        id,
        idArticulo,
        precio,
        articulosNombre,
        colores,
        tallas,
        EAN,
        precioEsp
      );

      // Cargar foto del producto
      fetchProductPhoto(idArticulo);
    } else {
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
    }
  }
  const handleChangeInputArticuloProporcion = (
    id,
    idArticulo,
    precio,
    articulosNombre,
    colores,
    tallas,
    ean,
    precioEsp = "No"
  ) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        return {
          ...i,
          articulos: idArticulo,
          precio,
          precioOriginal: precio,
          articulosNombre,
          cajas: 0,
          colores,
          tallas,
          EAN: ean,
          precioEsp
        };
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
    ActualizaTotales();
  };
  function agregarProporcion(
    idArticulo,
    articulosNombre,
    precio,
    cajas,
    colores,
    tallas,
    precioEsp = "No"
  ) {
    // Check if adding items should be blocked
    if (shouldBlockAddingItems()) {
      Swal.fire({
        icon: "warning",
        title: "No se pueden agregar más piezas",
        text: "Este pedido tiene más de 8 días y aún tiene saldo pendiente. No se pueden agregar más piezas hasta que se liquide.",
        confirmButtonText: "Entendido"
      });
      return;
    }
    axios
      .get(`${URL_ARTICULOS_PROPORCION}Articulos/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;

        // VALIDACIÓN DE INVENTARIO: Verificar disponibilidad por color y talla antes de agregar
        let validacionExitosa = true;
        let mensajeError = "";
        let cajasMaximasDisponibles = cajas; // Empezamos con las cajas solicitadas

        // Calcular el máximo de cajas que se pueden agregar basándose en el inventario mínimo
        for (const articulo of allArticulos) {
          const cantidadNecesaria = cajas * articulo.cantidad;
          const idColor = articulo.colores[0]._id;
          const idTalla = articulo.tallas[0]._id;
          
          // Validar inventario disponible dinámico
          const inventarioDisponible = getInventoryAvailable(idArticulo, idColor, idTalla);
          
          // Calcular cuántas cajas máximo se pueden hacer con este inventario
          const cajasMaximasParaEsteItem = Math.floor(inventarioDisponible / articulo.cantidad);
          
          // El cuello de botella determina el máximo de cajas totales
          if (cajasMaximasParaEsteItem < cajasMaximasDisponibles) {
            cajasMaximasDisponibles = cajasMaximasParaEsteItem;
          }
          
          if (cantidadNecesaria > inventarioDisponible) {
            validacionExitosa = false;
            mensajeError += `${articulo.colores[0].name} / ${articulo.tallas[0].name}: Necesitas ${cantidadNecesaria}, disponible ${inventarioDisponible}\n`;
          }
        }

        // Si la validación falla, ofrecer agregar lo disponible
        if (!validacionExitosa) {
          if (cajasMaximasDisponibles > 0) {
            // Hay algo disponible, ofrecer alternativa
            Swal.fire({
              icon: "warning",
              title: "Inventario insuficiente",
              html: `No hay suficiente inventario para ${cajas} cajas:<br><br>${mensajeError.replace(/\n/g, '<br>')}<br><strong>¿Deseas agregar ${cajasMaximasDisponibles} cajas que sí están disponibles?</strong>`,
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: `Sí, agregar ${cajasMaximasDisponibles} cajas`,
              cancelButtonText: "Cancelar",
            }).then((result) => {
              if (result.isConfirmed) {
                // Recursivamente llamar la función con las cajas disponibles
                agregarProporcion(
                  idArticulo,
                  articulosNombre,
                  precio,
                  cajasMaximasDisponibles,
                  colores,
                  tallas,
                  precioEsp
                );
              }
            });
          } else {
            // No hay nada disponible
            Swal.fire({
              icon: "error",
              title: "Sin inventario disponible",
              text: `No hay inventario disponible para ninguna caja:\n${mensajeError}`,
              timer: 5000,
              showConfirmButton: true,
            });
          }
          return;
        }

        // Si la validación es exitosa, proceder a crear los artículos
        // Registrar el uso de inventario para cada artículo
        allArticulos.forEach((i) => {
          const cantidadUsada = cajas * i.cantidad;
          registrarIncrementoInventario(idArticulo, i.colores[0]._id, i.tallas[0]._id, cantidadUsada);
        });

        const newInputFields = allArticulos.map((i) => {
          return {
            id: uuidv4(),
            articulos: idArticulo,
            articulosNombre: articulosNombre,
            idArticuloProporcion: i._id || "", // ID del artículo-proporción individual
            precio: precio,
            precioOriginal: precio,
            cantidad: cajas * i.cantidad,
            idTalla: i.tallas[0]._id,
            tallaNombre: i.tallas[0].name,
            idColor: i.colores[0]._id,
            colorNombre: i.colores[0].name,
            total: cajas * i.cantidad * precio,
            colores: colores,
            tallas: tallas,
            precioEsp: precioEsp,
            // Add a groupKey to help with visual grouping
            groupKey: `${articulosNombre}-${i.colores[0].name}`,
            isFirstInGroup: false, // We'll set this after sorting
          };
        });

        setInputFields((prevInputFields) => {
          const updatedInputFields = [...prevInputFields, ...newInputFields];

          // Sort using your existing order
          const sortedInputFields = updatedInputFields.sort((a, b) => {
            if (a.articulosNombre < b.articulosNombre) return -1;
            if (a.articulosNombre > b.articulosNombre) return 1;

            if (a.colorNombre < b.colorNombre) return -1;
            if (a.colorNombre > b.colorNombre) return 1;

            return (
              customSizeOrder.indexOf(a.tallaNombre) -
              customSizeOrder.indexOf(b.tallaNombre)
            );
          });

          // Cargar fotos para los nuevos artículos
          newInputFields.forEach((field) => {
            if (field.articulos) {
              fetchProductPhoto(field.articulos);
            }
          });

          // Mark first items in each group
          let currentGroup = "";
          sortedInputFields.forEach((field, index) => {
            if (field.groupKey !== currentGroup) {
              field.isFirstInGroup = true;
              currentGroup = field.groupKey;
            } else {
              field.isFirstInGroup = false;
            }
          });

          // Calculate totals
          const totalCantidad = sortedInputFields.reduce(
            (acc, curr) => acc + parseFloat(curr.cantidad),
            0
          );
          setTotalCantidadEdit(totalCantidad);

          let importes = sortedInputFields.map((c) => parseFloat(c.total));
          let TG = importes.reduce((t, total) => t + total, 0);
          setSubTotal(TG);

          if (selectedImpuesto !== 0) {
            setIva((selectedImpuesto * TG) / 100);
          } else {
            setIva(0);
          }

          let temp1 = parseFloat(((TG * descuentoEditRef.current) / 100).toFixed(2));
          setDescuentoImporteEdit(temp1);
          descuentoImporteEditRef.current = temp1;

          let totTemp =
            (selectedImpuesto * TG) / 100 +
            TG +
            parseFloat(comisionTDC) +
            parseFloat(comisionFlete) -
            parseFloat(temp1);
          setTotalGeneralEdit(totTemp.toFixed(2));

          const pedidoEnEdicion = commentsRef.current.find((p) => p._id === idEditRef.current);
          const abonosActuales = pedidoEnEdicion ? pedidoEnEdicion.abonos || 0 : 0;
          setSaldoEdit((totTemp - parseFloat(abonosActuales)).toFixed(2));

          return sortedInputFields;
        });

        setInputArticulos([
          {
            id: uuidv4(),
            articulos: "",
            cajas: 0,
            precio: 0,
            precioOriginal: 0,
            articulosNombre: "",
            colores: [],
            tallas: [],
            EAN: "",
            precioEsp: "No",
          },
        ]);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const [manualInput, setManualInput] = useState({
    articulosNombre: "",
    articulos: "",
    idArticuloProporcion: "",
    idColor: "",
    idTalla: "",
    tallaNombre: "",
    cantidad: 0,
    precio: 0,
    precioOriginal: 0,
    colores: [],
    tallas: [],
    total: 0,
    precioEsp: "No",
  });

  const handleManualArticuloChange = (selectedArticulo) => {
    if (selectedArticulo) {
      setManualInput({
        articulos: selectedArticulo._id,
        articulosNombre: selectedArticulo.nombre,
        idArticuloProporcion: "", // Se limpia porque es selección manual, no por QR
        precio: selectedArticulo.venta,
        precioOriginal: selectedArticulo.venta,
        colores: selectedArticulo.colores,
        tallas: selectedArticulo.tallas,
        idColor: "",
        idTalla: "",
        tallaNombre: "",
        cantidad: 0,
        total: 0,
        precioEsp: selectedArticulo.precioEsp || "No",
      });

      // Cargar foto del producto
      fetchProductPhoto(selectedArticulo._id);
    }
  };
  const handleManualInputChange = (event) => {
    const { name, value } = event.target;

    setManualInput((prev) => {
      const updatedInput = {
        ...prev,
        [name]: value,
      };

      // If changing talla, update tallaNombre
      if (name === "idTalla") {
        const selectedTalla = prev.tallas.find((t) => t._id === value);
        updatedInput.tallaNombre = selectedTalla ? selectedTalla.name : "";
      }

      // Calculate total whenever cantidad changes
      if (name === "cantidad") {
        const nuevaCantidad = parseFloat(value) || 0;
        updatedInput.cantidad = nuevaCantidad;
        updatedInput.total = nuevaCantidad * prev.precio;

        // Solo validar inventario al intentar agregar (no durante la escritura)
        // La validación real se hace en handleManualAdd
      }

      return updatedInput;
    });
  };

  const handleManualAdd = async () => {
    if (
      !manualInput.articulosNombre ||
      !manualInput.idColor ||
      !manualInput.idTalla ||
      !manualInput.cantidad
    ) {
      return;
    }

    // Check if adding items should be blocked
    if (shouldBlockAddingItems()) {
      Swal.fire({
        icon: "warning",
        title: "No se pueden agregar más piezas",
        text: "Este pedido tiene más de 8 días y aún tiene saldo pendiente. No se pueden agregar más piezas hasta que se liquide.",
        confirmButtonText: "Entendido"
      });
      return;
    }

    // Validar inventario disponible dinámico antes de agregar
    const inventarioDisponible = getInventoryAvailable(manualInput.articulos, manualInput.idColor, manualInput.idTalla);
    
    if (manualInput.cantidad > inventarioDisponible) {
      Swal.fire({
        icon: "error",
        title: "Inventario insuficiente",
        text: `Solo hay ${inventarioDisponible} unidades disponibles. Intentas agregar ${manualInput.cantidad} unidades.`,
        timer: 4000,
        showConfirmButton: false,
      });
      return;
    }

    const selectedColor = manualInput.colores.find(
      (c) => c._id === manualInput.idColor
    );
    const selectedTalla = manualInput.tallas.find(
      (t) => t._id === manualInput.idTalla
    );

    // Registrar el uso de inventario ANTES de agregar el artículo
    registrarIncrementoInventario(manualInput.articulos, manualInput.idColor, manualInput.idTalla, manualInput.cantidad);

    const newField = await {
      id: uuidv4(),
      articulos: manualInput.articulos,
      articulosNombre: manualInput.articulosNombre,
      idArticuloProporcion: manualInput.idArticuloProporcion || "", // Para tracking de piezas escaneadas
      precio: manualInput.precio,
      precioOriginal: manualInput.precio,
      cantidad: parseFloat(manualInput.cantidad),
      idTalla: manualInput.idTalla,
      tallaNombre: selectedTalla ? selectedTalla.name : "",
      idColor: manualInput.idColor,
      colorNombre: selectedColor ? selectedColor.name : "",
      total: manualInput.cantidad * manualInput.precio,
      colores: manualInput.colores,
      tallas: manualInput.tallas,
      precioEsp: manualInput.precioEsp || "No",
    };

    setInputFields((prev) => [...prev, newField]);

    // Cargar foto del producto recién agregado
    fetchProductPhoto(newField.articulos);

    // Reset only specific fields after adding
    setManualInput((prev) => ({
      ...prev,
      idColor: "",
      articulos: "",
      articulosNombre: "",
      idArticuloProporcion: "", // Limpiar también el idArticuloProporcion
      cantidad: 0,
      idTalla: "",
      tallaNombre: "",
      precio: 0,
      precioOriginal: 0,
      total: 0,
      precioEsp: "No",
    }));
  };
  async function buscarArticuloSingular(id, event) {
    if (event.target.value.length >= 1) {
      const scanValue = event.target.value.trim();

      // Buscar en API por EAN en ArticulosProporcion
      const buscarEnAPI = async () => {
        // Primero intentar por EAN
        try {
          const resByEAN = await axios.get(
            `${URL_ARTICULOS_PROPORCION}/EAN/${scanValue}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_token")}`,
              },
            }
          );
          if (resByEAN.data) return resByEAN;
        } catch (error) {
          console.log("Error buscando por EAN:", error);
        }

        // Si no se encuentra y es un ObjectId válido, intentar por _id
        const isValidObjectId = /^[a-fA-F0-9]{24}$/.test(scanValue);
        if (isValidObjectId) {
          try {
            const resById = await axios.get(
              `${URL_ARTICULOS_PROPORCION}/${scanValue}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("app_token")}`,
                },
              }
            );
            if (resById.data) return resById;
          } catch (error) {
            console.log("Error buscando por ID:", error);
          }
        }

        return null;
      };

      const res = await buscarEnAPI();

      if (res?.data) {
        // CORRECCIÓN: res.data._id es el ID del artículo-proporción
        // res.data.articulos[0]._id es el ID del artículo base
        const idArticuloProporcion = res.data._id;
        const idArticulo = res.data.articulos[0]._id;
        const articulosNombre = `${res.data.articulos[0].codigo} ${res.data.articulos[0].nombre}`;
        const precio = res.data.articulos[0].venta;
        const colores = res.data.colores;
        const coloresId = res.data.colores[0]._id;
        const tallas = res.data.tallas;
        const tallasId = res.data.tallas[0]._id;
        const precioEsp = res.data.articulos[0].precioEsp || "No";

        setManualInput({
          articulos: idArticulo, // ID del artículo base (correcto)
          idArticuloProporcion: idArticuloProporcion, // ID del artículo-proporción para tracking
          articulosNombre: articulosNombre,
          precio: precio,
          precioOriginal: precio,
          colores: colores,
          tallas: tallas,
          idColor: coloresId,
          idTalla: tallasId,
          tallaNombre: tallas[0]?.name || "",
          cantidad: 1,
          total: precio,
          precioEsp: precioEsp,
        });

        // Cargar foto del producto (usando el ID del artículo base)
        fetchProductPhoto(idArticulo);
      } else {
        Swal.fire({
          icon: "error",
          title: "Artículo no encontrado",
          text: "No se encontró ningún artículo con el código proporcionado",
        });
      }
    }
  }


  // async function PDFOCFoto(
  //   fecha,
  //   colaboradores,
  //   idClientes,
  //   clientes,
  //   total_cantidad,
  //   total_general,
  //   observaciones,
  //   numero,
  //   impuestos,
  //   comisionFlete,
  //   comisionTDC,
  //   idPDFOC,
  //   alias,
  //   calle,
  //   numero_ext,
  //   numero_int,
  //   pais,
  //   estado,
  //   ciudad,
  //   delegacion,
  //   colonia,
  //   cp,
  //   RFC,
  //   paqueteria,
  //   area,
  //   codigoClientes,
  //   autorizadoApartado,
  //   autorizadoSurtido,
  //   telefono,
  //   editado,
  //   editPedido,
  //   autorizoApartado,
  //   autorizoSurtido,
  //   descuento,
  //   creado,
  //   fechaHora
  // ) {
  //   await axios
  //     .get(`${URL_ARTICULOS_PEDIDO}/surtir2/${idPDFOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosPedido = response.data;
  //       let arrayTabla = allArticulosPedido
  //         .map((a) => {
  //           return {
  //             id: a._id,
  //             articulos: a.articulos[0].codigo,
  //             idArticulo: a.articulos[0]._id,
  //             observaciones: a.observaciones,
  //             cantidad: a.cantidad,
  //             surtido: a.surtido,
  //             precio: a.precio,
  //             total: a.total,
  //             pendiente_surtir: a.pendiente_surtir,
  //             cajas: a.cantidad / a.articulos[0].piezasPorCaja,
  //             foto: ""
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });

  //       let dataFinal = Object.values(arrayTabla);

  //       let agrupado = dataFinal.reduce(function (groups, item) {
  //         const val = item["idArticulo"]
  //         groups[val] = groups[val] || {
  //           idArticulo: item.idArticulo,
  //           cantidad: 0,
  //           total: 0,
  //           pendiente_surtir: 0,
  //           cajas: 0
  //         };
  //         groups[val].cantidad += item.cantidad;
  //         groups[val].idArticulo = item.idArticulo;
  //         groups[val].articulos = item.articulos;
  //         groups[val].precio = item.precio;
  //         groups[val].total += item.total;
  //         groups[val].pendiente_surtir += item.pendiente_surtir;
  //         groups[val].cajas += item.cajas;
  //         groups[val].foto = item.foto

  //         return groups;
  //       },[])

  //       let dataAgrupado = Object.values(agrupado);

  //       let totalKG = dataFinal.map((c) => parseFloat(c.cantidad));
  //       let TK = totalKG.reduce((t, total, index) => t + total, 0);

  //       let importes = dataFinal.map((c) => parseFloat(c.total));
  //       let TG = importes.reduce((t, total, index) => t + total, 0);

  //       let TC = dataFinal.map((c) => parseFloat(c.cajas));
  //       let TTC = TC.reduce((t, total, index) => t + total, 0);

  //       let iva_tabla = (TG * impuestos) / 100;

  //       let temp1 = (TG * descuento) / 100;

  //       dataAgrupado.map(async (z) => {
  //         const URL_GET_MEDIA = `${import.meta.env.VITE_URL_GETMEDIA}/${z.idArticulo}`;
  //        await axios
  //           .get(URL_GET_MEDIA, {
  //             headers: {
  //               Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //             },
  //           })
  //           .then((data) => {
  //             if(data.data.secure_url != null){
  //             z.foto = data.data.secure_url
  //           }else z.foto = "sinImagen.png"
  //           })
  //           .catch((err) => {
  //             console.log(err);
  //           });
  //         return z
  //       })

  //       setTimeout(() => {

  //       const data = dataFinal
  //       .sort((a, b) => (a.articulos > b.articulos ? 1 : -1))
  //       .map((a) => {
  //         // totalParcial = a.cantidad * a.precio;
  //         // subTotalTabla = subTotalTabla + totalParcial
  //         // iva_tabla = iva_tabla + (subTotalTabla * impuesto_tabla/100)
  //         return [
  //           a.foto,
  //           a.articulos,
  //           fmtNumber.format(a.cantidad),
  //           // fmtNumber.format(a.surtido),
  //           new Intl.NumberFormat("en-US", {
  //             style: "currency",
  //             currency: "USD",
  //             maximumFractionDigits: 2,
  //           }).format(a.precio),
  //           new Intl.NumberFormat("en-US", {
  //             style: "currency",
  //             currency: "USD",
  //             maximumFractionDigits: 2,
  //           }).format(a.total),
  //         ];
  //       });
  //       const dataPDF = Object.values(data);
  //       const dataPDFLimpia = dataPDF.filter(function (el) {
  //         return el != null;
  //       });
  //       const doc = new jsPDF();
  //       // const doc = new jsPDF("landscape","mm", "a4", true);
  //       var img = new Image();
  //       img.src = "Logo-Sistemify-PDF.png";
  //       doc.addImage(img, "png", 8, 5, 18, 5);
  //       var img2 = new Image();
  //       img2.src = "logoInstitucion.png";
  //       doc.addImage(img2, "png", 10, 11, 20, 10);

  //       doc.setFontSize(16);
  //       doc.text(`No. Pedido: ${numero}`, 35, 15);
  //       // doc.text(`Fecha:`, 35, 15);
  //       // doc.text(`${fecha}`, 60, 15);

  //       doc.setFontSize(12);
  //       doc.text(`Ejecutivo:`, 120, 15);
  //       doc.text(`${colaboradores}`, 150, 15);
  //       doc.text(`Aut. Apartado:`, 120, 20);
  //       doc.text(`${autorizadoApartado}`, 150, 20);
  //       doc.text(`Aut. Surtido:`, 120, 25);
  //       doc.text(`${autorizadoSurtido}`, 150, 25);

  //       doc.setFontSize(8);
  //       doc.text(`Creado por: ${creado}`, 120, 32);
  //       doc.text(`Fecha creado: ${fechaHora}`, 120, 37);

  //       doc.text(`Cliente: ${codigoClientes} - ${clientes}`, 10, 32);
  //       doc.text(`RFC: ${RFC}`, 10, 37);
  //       doc.text(`Direccion de Envio: ${calle} #${numero_ext} Int. ${numero_int}`, 10, 47);
  //       doc.text(`Telefono: ${telefono}`, 10, 52);
  //       doc.text(`Edo: ${estado}, Ciudad: ${ciudad}, CP: ${cp}`, 10, 57);
  //       doc.text(`Del: ${delegacion}, Col: ${colonia}`, 10, 62);

  //       doc.setFontSize(12);
  //       doc.text(`Paqueteria: ${paqueteria}`, 120, 50);
  //       doc.text(`Almacen: ${area}`, 120, 57);
  //       doc.autoTable({
  //         columnStyles: {
  //           0: {
  //             fontSize: .0001,
  //             cellWidth: 20,
  //           },
  //         },
  //         // columnStyles: {
  //         //   0: {cellWidth: 37},
  //         //   1: {cellWidth: 60},
  //         //   2: {cellWidth: 15},
  //         //   3: {cellWidth: 17},
  //         //   4: {cellWidth: 17},
  //         //   5: {cellWidth: 20},
  //         //   6: {cellWidth: 22},
  //         // },
  //         head: [
  //           [
  //             "Foto",
  //             "Articulo",
  //             "Cant.",
  //             // "Surt.",
  //             "Precio",
  //             "Total",
  //           ],
  //         ],
  //         body: dataPDFLimpia,
  //         bodyStyles:{
  //           rowHeight : 22
  //         },
  //         styles: {
  //           fontSize: 10,
  //         },
  //         startY: 70,

  //         didDrawCell: function(data) {
  //           if (data.column.index === 0 && data.cell.section === 'body') {
  //              var td = data.cell.raw;
  //              var img3 = td
  //             //  var dim = data.cell.height - data.cell.padding('vertical');
  //              var textPos = data.cell;
  //              doc.addImage(img3, textPos.x,  textPos.y, 20, 20);
  //           }
  //         },

  //         margin:{left:10, right:10},
  //         foot: [
  //           [
  //             "",
  //             // "",
  //             fmtNumber.format(TK) + " Piezas",
  //             "",
  //             "Sub Total",
  //             new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //               maximumFractionDigits: 2,
  //             }).format(TG),
  //           ],
  //           [
  //             "",
  //             // "",
  //             "",
  //             "",
  //             `IVA`,
  //             new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //               maximumFractionDigits: 2,
  //             }).format(iva_tabla),
  //           ],
  //           [
  //             "",
  //             // "",
  //             "",
  //             "",
  //             "Comision TDC",
  //             new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //               maximumFractionDigits: 2,
  //             }).format(comisionTDC),
  //           ],
  //           [
  //             "",
  //             "",
  //             // "",
  //             "",
  //             "Flete",
  //             new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //               maximumFractionDigits: 2,
  //             }).format(comisionFlete),
  //           ],
  //           [
  //             "",
  //             // "",
  //             "",
  //             "",
  //             `Desc ${descuento}%`,
  //             new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //               maximumFractionDigits: 2,
  //             }).format(-temp1),
  //           ],
  //           [
  //             "",
  //             // "",
  //             "",
  //             "",
  //             "Total",
  //             new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //               maximumFractionDigits: 2,
  //             }).format(total_general),
  //           ],
  //         ],
  //         showFoot: "lastPage",
  //       });

  //       doc.setFontSize(10);
  //       var lines = doc.splitTextToSize(`Observaciones ${observaciones}`, 200);
  //       doc.text(10, doc.autoTable.previous.finalY + 10, lines);

  //       doc.save(`Pedido-${numero}.pdf`);

  //     }, 1000);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  /**
   * Renglones para imprimir la nota de un pedido.
   *
   * Pedido abierto: se leen los renglones vivos, igual que siempre.
   * Pedido cerrado: al cerrar se apagan todos los renglones, asi que surtir2
   * devolveria vacio. Se usa el endpoint de reimpresion, que ademas verifica que
   * los renglones cuadren con el total guardado del pedido.
   *
   * Devuelve null cuando no se debe imprimir (ya se le aviso al usuario).
   */
  async function obtenerRenglonesImpresion(idPedido, statusPedido) {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    try {
      if (statusPedido !== "Cerrado") {
        const res = await axios.get(
          `${URL_ARTICULOS_PEDIDO}/surtir2/${idPedido}`,
          { headers }
        );
        return res.data;
      }

      const res = await axios.get(
        `${URL_ARTICULOS_PEDIDO}/reimpresion/${idPedido}`,
        { headers }
      );

      if (!res.data.fiel) {
        Swal.fire({
          icon: "warning",
          title: "No se puede reimprimir esta nota",
          html:
            `Los renglones guardados no coinciden con el total del pedido ` +
            `(${res.data.cantidadRenglones} contra ${res.data.cantidadPedido} piezas), ` +
            `probablemente porque se dio de baja un articulo antes de cerrarla.<br><br>` +
            `Imprimirla mostraria articulos que no se entregaron.`,
        });
        return null;
      }

      return res.data.articulos;
    } catch (err) {
      console.log("No se pudieron obtener los renglones del pedido:", err);
      Swal.fire({
        icon: "error",
        title: "No se pudo imprimir",
        text: "No se pudieron obtener los articulos del pedido.",
      });
      return null;
    }
  }

  // Ticket PDF function for thermal receipt style
  async function PDFOCTicket(
    fecha,
    colaboradores,
    idClientes,
    clientes,
    total_cantidad,
    total_general,
    observaciones,
    numero,
    impuestos,
    comisionFlete,
    comisionTDC,
    idPDFOC,
    alias,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    area,
    codigoClientes,
    autorizadoApartado,
    autorizadoSurtido,
    telefono,
    editado,
    editPedido,
    autorizoApartado,
    autorizoSurtido,
    descuento,
    descuentoImporte,
    creado,
    fechaHora,
    abonos,
    saldo,
    statusPedido,
  ) {
    try {
      // Los renglones se piden antes que nada: si la nota no se puede reimprimir
      // no tiene caso sellar la fecha de emision de un ticket que no va a salir.
      const allArticulosPedido = await obtenerRenglonesImpresion(
        idPDFOC,
        statusPedido
      );
      if (!allArticulosPedido) return;

      // Fecha de emision del ticket. El backend la sella la PRIMERA vez que se
      // genera y despues solo la devuelve, para que una reimpresion muestre la
      // fecha original. Si la llamada falla no se detiene la impresion: el ticket
      // sale sin esa linea, que es preferible a no poder imprimir.
      let fechaEmisionTicket = null;
      let esReimpresion = false;
      try {
        const emision = await axios.patch(
          `${URL_PEDIDOS}EmitirTicket/${idPDFOC}`,
          {},
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        fechaEmisionTicket = emision.data?.fechaEmisionTicket || null;
        esReimpresion = emision.data?.reimpresion === true;
      } catch (err) {
        console.log("No se pudo sellar la fecha de emisión del ticket:", err);
      }
      let arrayTabla = allArticulosPedido
        .map((a) => {
          return {
            id: a._id,
            articulos: a.articulos[0].codigo + " - " + a.articulos[0].nombre,
            idArticulo: a.articulos[0]._id,
            colorNombre: a.colores && a.colores.length > 0 ? a.colores[0].name : "",
            tallaNombre: a.tallas && a.tallas.length > 0 ? a.tallas[0].name : "",
            observaciones: a.observaciones,
            cantidad: a.cantidad,
            surtido: a.surtido,
            precio: a.precio,
            total: a.total,
            pendiente_surtir: a.pendiente_surtir,
            cajas: a.cantidad / a.articulos[0].piezasPorCaja,
            createdAt: a.createdAt,
          };
        })
        .filter(function (el) {
          return el != null;
        });

      let dataFinal = Object.values(arrayTabla);

      // let agrupado = dataFinal.reduce(function (groups, item) {
      //   const val = item["idArticulo"];
      //   groups[val] = groups[val] || {
      //     idArticulo: item.idArticulo,
      //     cantidad: 0,
      //     total: 0,
      //     pendiente_surtir: 0,
      //     cajas: 0,
      //   };
      //   groups[val].cantidad += item.cantidad;
      //   groups[val].idArticulo = item.idArticulo;
      //   groups[val].articulos = item.articulos;
      //   groups[val].colorNombre = item.colorNombre;
      //   groups[val].tallaNombre = item.tallaNombre;
      //   groups[val].precio = item.precio;
      //   groups[val].total += item.total;
      //   groups[val].pendiente_surtir += item.pendiente_surtir;
      //   groups[val].cajas += item.cajas;
      //   return groups;
      // }, []);

      // let dataAgrupado = Object.values(agrupado);

      let totalKG = dataFinal.map((c) => parseFloat(c.cantidad));
      let TK = totalKG.reduce((t, total, index) => t + total, 0);

      let importes = dataFinal.map((c) => parseFloat(c.total));
      let TG = importes.reduce((t, total, index) => t + total, 0);

      let TC = dataFinal.map((c) => parseFloat(c.cajas));
      let TTC = TC.reduce((t, total, index) => t + total, 0);

      let iva_tabla = (TG * impuestos) / 100;
      let temp1 = parseFloat(descuentoImporte) > 0 ? parseFloat(descuentoImporte) : (TG * descuento) / 100;
      let total_general_tabla = TG + iva_tabla + comisionFlete + comisionTDC - temp1;

      // Process data for table - sort by insertion order (createdAt)
      const data = dataFinal
        .sort((a, b) => {
          const aDate = a.createdAt ? new Date(a.createdAt) : new Date(0);
          const bDate = b.createdAt ? new Date(b.createdAt) : new Date(0);
          return aDate - bDate;
        })
        .map((a) => {
          // Truncate item name if too long (max 24 chars for 8cm width)
          const itemName = a.articulos.length > 24
            ? a.articulos.substring(0, 21) + "..."
            : a.articulos;

          return [
            itemName,
            a.colorNombre || "",
            a.tallaNombre || "",
            a.cantidad.toString(),
            `$${a.precio.toFixed(2)}`,
            `$${a.total.toFixed(2)}`,
          ];
        });

      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter(function (el) {
        return el != null;
      });

      // Calculate dynamic height based on content (in mm)
      const itemHeightMm = 8; // Height per item in mm (increased for line-break support)
      const headerHeightMm = 80; // Height for header section (unified with ListadoPendienteSurtir)
      const footerHeightMm = 120; // Height for footer, totals, payments
      const bufferHeightMm = 80; // Extra space at the end for cutting

      // Count items with long names that may cause line-break and add extra height
      // Check against dataFinal (before truncation), not dataPDFLimpia (after truncation)
      const longNameItems = dataFinal.filter(
        (item) => item.articulos && item.articulos.length > 24
      ).length;
      const extraHeightForLongNames = longNameItems * 3; // 3mm extra per long-name item

      const totalHeightMm =
        headerHeightMm +
        dataPDFLimpia.length * itemHeightMm +
        extraHeightForLongNames +
        footerHeightMm +
        bufferHeightMm;

      // Create PDF with estandarized thermal dimensions (80mm width) and calculated height
      const doc = createTicketPDF({
        width: THERMAL_PAPER_SIZES.THERMAL_80MM.width,
        height: totalHeightMm,
        title: `Pedido ${numero}`,
      });

      // Generate QR code
      var base64 = await qrcode.toDataURL(idPDFOC);
      var img3 = new Image();
      img3.src = base64;

      var img2 = new Image();
      img2.src = "logoInstitucion.png";

      // HEADER SECTION with yPos tracking (in mm)
      const centerX = 40; // Center of 80mm width
      const leftMargin = 2;
      const rightMargin = 78;
      let yPos = 3; // Start position in mm

      // Logo
      doc.addImage(img2, "png", 65, yPos, 12, 8);
      yPos += 10; // Space after logo

      // Business information - centered with better spacing
      setFontStyle(doc, 10, "bold");
      doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, centerX, yPos, {
        align: "center",
      });
      yPos += 5; // More space after business name

      setFontStyle(doc, 7, "normal");
      doc.text("CALLE ##, COLONIA", centerX, yPos, {
        align: "center",
      });
      yPos += 3.5; // More space between address lines

      doc.text("CIUDAD, ESTADO CP", centerX, yPos, {
        align: "center",
      });
      yPos += 3.5; // More space between address lines

      doc.text(`RFC:`, centerX, yPos, { align: "center" });
      yPos += 3.5; // More space after RFC

      doc.text("General de Ley de Personas Morales", centerX, yPos, {
        align: "center",
      });
      yPos += 5; // More space before separator

      // Separator line
      doc.setLineWidth(0.1);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 5; // More space after separator

      // Store information with better spacing
      setFontStyle(doc, 8, "normal");
      doc.text(`Area: ${area}`, centerX, yPos, {
        align: "center",
      });
      yPos += 3.5; // More space between store info lines

      // Another separator
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 5; // More space after separator

      // Transaction information with better spacing
      setFontStyle(doc, 8, "bold");
      doc.text(`Fecha: ${fecha}`, centerX, yPos, { align: "center" });
      yPos += 4; // More space after date

      setFontStyle(doc, 8, "normal");
      doc.text(`Pedido: ${numero}`, centerX, yPos, { align: "center" });
      yPos += 3.5;

      // Fecha de EMISION del ticket. "Fecha" de arriba es cuando se levanto el
      // pedido; esta es cuando se genero el ticket por primera vez. El backend la
      // sella una sola vez, asi que una reimpresion sigue mostrando la fecha
      // original en lugar del dia en que se reimprime.
      if (fechaEmisionTicket) {
        setFontStyle(doc, 7, "normal");
        doc.text(
          `Emitido: ${moment(fechaEmisionTicket).format("YYYY-MM-DD HH:mm")}`,
          centerX,
          yPos,
          { align: "center" }
        );
        yPos += 5; // More space before customer info
      } else {
        yPos += 1.5; // sin sello, se conserva el espaciado original
      }

      // Aviso de reimpresion: el backend indica si el ticket ya se habia
      // generado antes, para que una copia no se confunda con el original.
      if (esReimpresion) {
        setFontStyle(doc, 9, "bold");
        doc.text("*** REIMPRESION ***", centerX, yPos, { align: "center" });
        yPos += 5;
        // Se restaura el tamano que traia el texto en este punto para no alterar
        // el resto del ticket: 7 si se imprimio la linea "Emitido", 8 si no.
        setFontStyle(doc, fechaEmisionTicket ? 7 : 8, "normal");
      }

      // Customer and seller info with better spacing
      doc.text(`Cliente: ${clientes}`, leftMargin, yPos);
      yPos += 3.5; // More space between customer and seller

      doc.text(`Ejecutivo: ${colaboradores}`, leftMargin, yPos);
      yPos += 6; // Much more space before final separator

      // Final separator before items
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6; // Much more space before table starts

      // ITEMS TABLE with proper column widths for 80mm (in mm units)
      doc.autoTable({
        head: [["Articulo", "Color", "Talla", "Can", "Precio", "Total"]],
        body: dataPDFLimpia,
        startY: yPos, // Use yPos instead of fixed value

        // Fixed column widths that total to ~76mm (leaving margins)
        columnStyles: {
          0: {
            cellWidth: 20, // Item name (largest)
            halign: "left",
            overflow: "linebreak",
            fontSize: 7,
          },
          1: {
            cellWidth: 10, // Color
            halign: "left",
            overflow: "hidden",
            fontSize: 7,
          },
          2: {
            cellWidth: 10, // Talla
            halign: "left",
            overflow: "hidden",
            fontSize: 7,
          },
          3: {
            cellWidth: 8, // Cantidad
            halign: "center",
            overflow: "hidden",
            fontSize: 7,
          },
          4: {
            cellWidth: 13, // Precio
            halign: "right",
            overflow: "linebreak",
            fontSize: 6,
          },
          5: {
            cellWidth: 15, // Total
            halign: "right",
            overflow: "linebreak",
            fontSize: 6,
          },
        },

        styles: {
          fontSize: 8,
          font: "helvetica",
          cellPadding: { top: 2, right: 1, bottom: 2, left: 1 }, // Padding in mm
          lineWidth: 0.1,
          lineColor: [180, 180, 180],
          textColor: [0, 0, 0],
          overflow: "linebreak",
        },

        headStyles: {
          fontStyle: "bold",
          fontSize: 9,
          fillColor: [245, 245, 245],
          textColor: [0, 0, 0],
          halign: "center",
          cellPadding: { top: 2.5, right: 1, bottom: 2.5, left: 1 }, // Padding in mm
        },

        margin: { left: leftMargin, right: leftMargin },
        tableWidth: "wrap",
        theme: "grid",
      });

      // Get the Y position after the table with much more space (in mm)
      yPos = doc.lastAutoTable.finalY + 8; // Much more space after table

      // TOTALS SECTION
      doc.setLineWidth(0.2);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 4; // More space after line

      // Subtotal, discount, total with better spacing and simpler formatting
      setFontStyle(doc, 9, "normal");

      const totalsX = 38; // Move labels more to the left for better spacing (in mm)

      doc.text("SubTotal:", totalsX, yPos);
      doc.text(formatCurrency(TG), rightMargin - 1, yPos, {
        align: "right",
      });
      yPos += 3.5; // More space between lines

      if (temp1 > 0) {
        doc.text(`Descuento ${descuento}%:`, totalsX, yPos);
        doc.text(formatCurrency(temp1), rightMargin - 1, yPos, {
          align: "right",
        });
        yPos += 3.5;
      }

      if (iva_tabla > 0) {
        doc.text("IVA:", totalsX, yPos);
        doc.text(formatCurrency(iva_tabla), rightMargin - 1, yPos, {
          align: "right",
        });
        yPos += 3.5;
      }

      if (comisionTDC > 0) {
        doc.text("Comision TDC:", totalsX, yPos);
        doc.text(formatCurrency(comisionTDC), rightMargin - 1, yPos, {
          align: "right",
        });
        yPos += 3.5;
      }

      if (comisionFlete > 0) {
        doc.text("Flete:", totalsX, yPos);
        doc.text(formatCurrency(comisionFlete), rightMargin - 1, yPos, {
          align: "right",
        });
        yPos += 3.5;
      }

      // Separator line before total
      doc.setLineWidth(0.1);
      yPos += 2.5;

      // Total with emphasis
      setFontStyle(doc, 11, "bold");

      const totalLabelX = 35;
      doc.text("TOTAL:", totalLabelX, yPos);
      doc.text(formatCurrency(total_general_tabla), rightMargin - 1, yPos, {
        align: "right",
      });
      yPos += 4; // Space after total

      // Total de piezas
      setFontStyle(doc, 10, "bold");
      doc.text("TOTAL PIEZAS:", totalLabelX, yPos);
      doc.text(formatNumber(TK), rightMargin - 1, yPos, {
        align: "right",
      });
      yPos += 4; // More space after total piezas

      // FOOTER with more spacing
      yPos += 3;
      doc.setLineWidth(0.1);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 4;

      // Store policies - centered
      setFontStyle(doc, 7, "bold");
      doc.text("POLÍTICAS DE LA TIENDA", centerX, yPos, {
        align: "center",
      });
      yPos += 5;

      setFontStyle(doc, 6, "normal");

      const policies = [
        "**** NO ES UN COMPROBANTE FISCAL ****",
        "NO SE ACEPTAN CAMBIOS NI DEVOLUCIONES",
        "NI POR DEFECTO",
        "**** GRACIAS POR SU PREFERENCIA ****",
      ];

      policies.forEach((line) => {
        doc.text(line, centerX, yPos, { align: "center" });
        yPos += 2.5;
      });

      yPos += 4;
      setFontStyle(doc, 7, "normal");
      doc.text("¡Gracias por su pedido!", centerX, yPos, {
        align: "center",
      });
      yPos += 2.5;
      doc.text("Conserve este comprobante", centerX, yPos, {
        align: "center",
      });
      yPos += 4;

      // WhatsApp customer service info
      setFontStyle(doc, 6, "bold");
      doc.text("WhatsApp Atención a clientes:", centerX, yPos, {
        align: "center",
      });
      yPos += 2.5;
      setFontStyle(doc, 6, "normal");
      doc.text("495 103 6208 & 495 101 1713", centerX, yPos, {
        align: "center",
      });
      yPos += 4;

      // QR code - properly centered (in mm)
      const qrSize = 16;
      doc.addImage(img3, "png", centerX - qrSize / 2, yPos, qrSize, qrSize);

      // Save and print
      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");

    } catch (error) {
      console.error("Error in PDFOCTicket function:", error);
      Swal.fire({
        icon: "error",
        title: "Error generando PDF",
        text: "Hubo un problema al generar el PDF",
        footer: error.message,
      });
    }
  }

  async function PDFOC(
    fecha,
    colaboradores,
    idClientes,
    clientes,
    total_cantidad,
    total_general,
    observaciones,
    numero,
    impuestos,
    comisionFlete,
    comisionTDC,
    idPDFOC,
    alias,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    area,
    codigoClientes,
    autorizadoApartado,
    autorizadoSurtido,
    telefono,
    editado,
    editPedido,
    autorizoApartado,
    autorizoSurtido,
    descuento,
    descuentoImporte,
    creado,
    fechaHora,
    abonos,
    saldo,
    statusPedido,
  ) {
    const allArticulosPedido = await obtenerRenglonesImpresion(
      idPDFOC,
      statusPedido
    );
    if (!allArticulosPedido) return;

    // Los renglones ya vienen resueltos arriba. Se conserva la cadena .then
    // original unicamente para no reindentar el armado completo del PDF.
    await Promise.resolve()
      .then(() => {
        let arrayTabla = allArticulosPedido
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].codigo + " - " + a.articulos[0].nombre,
              idArticulo: a.articulos[0]._id,
              observaciones: a.observaciones,
              cantidad: a.cantidad,
              surtido: a.surtido,
              precio: a.precio,
              total: a.total,
              pendiente_surtir: a.pendiente_surtir,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        // let agrupado = dataFinal.reduce(function (groups, item) {
        //   const val = item["idArticulo"];
        //   groups[val] = groups[val] || {
        //     idArticulo: item.idArticulo,
        //     cantidad: 0,
        //     total: 0,
        //     pendiente_surtir: 0,
        //     cajas: 0,
        //   };
        //   groups[val].cantidad += item.cantidad;
        //   groups[val].idArticulo = item.idArticulo;
        //   groups[val].articulos = item.articulos;
        //   groups[val].precio = item.precio;
        //   groups[val].total += item.total;
        //   groups[val].pendiente_surtir += item.pendiente_surtir;
        //   groups[val].cajas += item.cajas;

        //   return groups;
        // }, []);

        // let dataAgrupado = Object.values(agrupado);

        let totalKG = dataFinal.map((c) => parseFloat(c.cantidad));
        let TK = totalKG.reduce((t, total, index) => t + total, 0);

        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);

        let TC = dataFinal.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let iva_tabla = (TG * impuestos) / 100;

        let temp1 = parseFloat(descuentoImporte) > 0 ? parseFloat(descuentoImporte) : (TG * descuento) / 100;

        // Calcular el total general correctamente incluyendo flete y comisión TDC
        let total_general_calculado = TG + iva_tabla + parseFloat(comisionFlete) + parseFloat(comisionTDC) - temp1;
        // Calcular saldo pendiente basado en el total calculado
        let saldo_calculado = total_general_calculado - parseFloat(abonos || 0);

        const data = dataFinal
          .sort((a, b) => (a.articulos > b.articulos ? 1 : -1))
          .map((a) => {
            // totalParcial = a.cantidad * a.precio;
            // subTotalTabla = subTotalTabla + totalParcial
            // iva_tabla = iva_tabla + (subTotalTabla * impuesto_tabla/100)
            return [
              a.articulos,
              fmtNumber.format(a.cantidad),
              // fmtNumber.format(a.surtido),
              fmtCurrency.format(a.precio),
              fmtCurrency.format(a.total),
            ];
          });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });

        const doc = new jsPDF();

        // Header with logos
        var img = new Image();
        img.src = "Logo-Sistemify-PDF.png";
        doc.addImage(img, "png", 8, 5, 18, 5);
        var img2 = new Image();
        img2.src = "logoInstitucion.png";
        doc.addImage(img2, "png", 10, 11, 20, 10);

        // Header line
        doc.setDrawColor(41, 128, 185);
        doc.setLineWidth(0.5);
        doc.line(10, 25, 200, 25);

        // Main title
        doc.setFontSize(18);
        doc.setTextColor(41, 128, 185);
        doc.setFont(undefined, 'bold');
        doc.text(`ORDEN DE PEDIDO No. ${numero}`, 35, 18);

        // Date
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'normal');
        doc.text(`Fecha: ${fecha}`, 35, 23);

        // Right side info
        doc.setFontSize(10);
        doc.setFont(undefined, 'bold');
        doc.text(`Ejecutivo:`, 120, 15);
        doc.setFont(undefined, 'normal');
        doc.text(`${colaboradores}`, 145, 15);

        doc.setFont(undefined, 'bold');
        doc.text(`Aut. Apartado:`, 120, 20);
        doc.setFont(undefined, 'normal');
        doc.text(`${autorizadoApartado}`, 155, 20);

        doc.setFont(undefined, 'bold');
        doc.text(`Aut. Surtido:`, 120, 25);
        doc.setFont(undefined, 'normal');
        doc.text(`${autorizadoSurtido}`, 155, 25);

        // Creation info
        doc.setFontSize(8);
        doc.setTextColor(100, 100, 100);
        doc.text(`Creado por: ${creado}`, 120, 32);
        doc.text(`Fecha creado: ${fechaHora}`, 120, 37);

        // Client information section
        doc.setFontSize(12);
        doc.setTextColor(41, 128, 185);
        doc.setFont(undefined, 'bold');
        doc.text(`INFORMACIÓN DEL CLIENTE`, 10, 35);

        doc.setDrawColor(41, 128, 185);
        doc.setLineWidth(0.3);
        doc.line(10, 37, 110, 37);

        doc.setFontSize(9);
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'bold');
        doc.text(`Cliente:`, 10, 42);
        doc.setFont(undefined, 'normal');
        doc.text(`${codigoClientes} - ${clientes}`, 25, 42);

        doc.setFont(undefined, 'bold');
        doc.text(`RFC:`, 10, 47);
        doc.setFont(undefined, 'normal');
        doc.text(`${RFC}`, 20, 47);

        doc.setFont(undefined, 'bold');
        doc.text(`Dirección:`, 10, 52);
        doc.setFont(undefined, 'normal');
        doc.text(`${calle} #${numero_ext} Int. ${numero_int}`, 28, 52);

        doc.setFont(undefined, 'bold');
        doc.text(`Teléfono:`, 10, 57);
        doc.setFont(undefined, 'normal');
        doc.text(`${telefono}`, 28, 57);

        doc.setFont(undefined, 'bold');
        doc.text(`Ubicación:`, 10, 62);
        doc.setFont(undefined, 'normal');
        doc.text(`${estado}, ${ciudad}, CP: ${cp}`, 28, 62);

        doc.setFont(undefined, 'bold');
        doc.text(`Delegación:`, 10, 67);
        doc.setFont(undefined, 'normal');
        doc.text(`${delegacion}, Col: ${colonia}`, 32, 67);

        // Shipping information
        doc.setFontSize(12);
        doc.setTextColor(41, 128, 185);
        doc.setFont(undefined, 'bold');
        doc.text(`INFORMACIÓN DE ENVÍO`, 120, 45);

        doc.setDrawColor(41, 128, 185);
        doc.setLineWidth(0.3);
        doc.line(120, 47, 200, 47);

        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'bold');
        doc.text(`Paquetería:`, 120, 52);
        doc.setFont(undefined, 'normal');
        doc.text(`${paqueteria}`, 145, 52);

        doc.setFont(undefined, 'bold');
        doc.text(`Almacén:`, 120, 57);
        doc.setFont(undefined, 'normal');
        doc.text(`${area}`, 138, 57);
        doc.autoTable({
          head: [
            [
              "Articulo",
              "Cant.",
              // "Surt.",
              "Precio",
              "Total",
            ],
          ],
          body: dataPDFLimpia,
          styles: {
            fontSize: 10,
            cellPadding: 3,
          },
          headStyles: {
            fillColor: [41, 128, 185],
            textColor: 255,
            fontStyle: 'bold',
            fontSize: 11,
          },
          alternateRowStyles: {
            fillColor: [245, 245, 245],
          },
          startY: 75,
          margin: { left: 10, right: 10 },
          foot: [
            [
              "",
              fmtNumber.format(TK) + " Piezas",
              "Sub Total",
              fmtCurrency.format(TG),
            ],
            [
              "",
              "",
              `IVA (${impuestos}%)`,
              fmtCurrency.format(iva_tabla),
            ],
            [
              "",
              "",
              "Comision TDC",
              fmtCurrency.format(comisionTDC),
            ],
            [
              "",
              "",
              "Flete",
              fmtCurrency.format(comisionFlete),
            ],
            [
              "",
              "",
              `Desc ${descuento}%`,
              fmtCurrency.format(-temp1),
            ],
            [
              "",
              "",
              "Total General",
              fmtCurrency.format(total_general_calculado),
            ],
            [
              "",
              "",
              "Abonos",
              fmtCurrency.format(abonos || 0),
            ],
            [
              "",
              "",
              "Saldo Pendiente",
              fmtCurrency.format(saldo_calculado),
            ],
          ],
          footStyles: {
            fillColor: [52, 73, 94],
            textColor: 255,
            fontStyle: 'bold',
            fontSize: 10,
          },
          showFoot: "lastPage",
        });

        // Observations section
        const finalY = doc.autoTable.previous.finalY + 15;

        doc.setFontSize(12);
        doc.setTextColor(41, 128, 185);
        doc.setFont(undefined, 'bold');
        doc.text(`OBSERVACIONES`, 10, finalY);

        doc.setDrawColor(41, 128, 185);
        doc.setLineWidth(0.3);
        doc.line(10, finalY + 2, 80, finalY + 2);

        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'normal');
        var lines = doc.splitTextToSize(observaciones || 'Sin observaciones', 180);
        doc.text(10, finalY + 8, lines);

        // Payment status section
        const paymentY = finalY + 8 + (lines.length * 5) + 10;

        // Políticas de la tienda section
        doc.setFontSize(10);
        doc.setTextColor(41, 128, 185);
        doc.setFont(undefined, 'bold');
        doc.text(`POLÍTICAS DE LA TIENDA`, 120, finalY);

        doc.setDrawColor(41, 128, 185);
        doc.setLineWidth(0.3);
        doc.line(120, finalY + 2, 200, finalY + 2);

        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'normal');
        doc.text(`• NO ES UN COMPROBANTE FISCAL`, 120, finalY + 7);
        doc.text(`• NO SE ACEPTAN CAMBIOS NI DEVOLUCIONES`, 120, finalY + 12);
        doc.text(`• GRACIAS POR SU PREFERENCIA`, 120, finalY + 17);

        // WhatsApp customer service info
        doc.setFontSize(9);
        doc.setFont(undefined, 'bold');
        doc.text(`WhatsApp Atención a clientes:`, 120, finalY + 25);
        doc.setFont(undefined, 'normal');
        doc.text(`495 103 6208 & 495 101 1713`, 120, finalY + 30);

        // Footer
        const pageHeight = doc.internal.pageSize.height;
        doc.setFontSize(8);
        doc.setTextColor(100, 100, 100);
        doc.setFont(undefined, 'italic');
        doc.text(`Documento generado el ${new Date().toLocaleString('es-MX')}`, 10, pageHeight - 10);
        doc.text(`Página 1 de 1`, 170, pageHeight - 10);

        // doc.save(`Pedido-${numero}.pdf`);
        window.open(doc.output("bloburl"), "_blank");
      })
      .catch((err) => {
        console.log(err);
      });
  }


  const headers = [
    // { name: "Activo", field: "activo", sortable: true },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "colaboradores", sortable: true },
    { name: "Almacen", field: "areaName", sortable: true },
    { name: "Cantidad", field: "total_cantidad", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Abonos", field: "abonos", sortable: true },
    { name: "Saldo", field: "saldo", sortable: true },
    { name: "Fecha Cierre", field: "fechaCierre", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
    { name: "Editar", field: "editar", sortable: false },
    { name: "Abonos", field: "abonosGestion", sortable: false },
    { name: "Surtido", field: "surtido", sortable: false },
  ];

  // Compute filtered and sorted comments
  const { filteredComments, totalFilteredItems } = useMemo(() => {
    // Create a copy to avoid mutating original array
    let computedComments = [...comments];

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.areaName.toLowerCase().includes(search.toLowerCase()) ||
          comment.colaboradores.toLowerCase().includes(search.toLowerCase()) ||
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.total_cantidad.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.alias.toLowerCase().includes(search.toLowerCase())
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        e.idColaboradores.includes(selectedColaborador)
      );
    }
    if (status) {
      computedComments = computedComments.filter((e) =>
        e.status.includes(status)
      );
    }
    if (autorizadoSurtido) {
      computedComments = computedComments.filter((e) =>
        e.autorizadoSurtido.includes(autorizadoSurtido)
      );
    }
    if (autorizadoApartado) {
      computedComments = computedComments.filter((e) =>
        e.autorizadoApartado.includes(autorizadoApartado)
      );
    }

    if (selectedArea) {
      computedComments = computedComments.filter((e) =>
        e.idArea.includes(selectedArea)
      );
    }

    // Sorting comments - use slice() to create a copy before sorting to avoid mutation
    if (sorting.field) {
      const numericFields = ["total_cantidad", "total_general", "numero", "abonos", "saldo"];
      const isNumeric = numericFields.includes(sorting.field);
      const reversed = sorting.order === "asc" ? 1 : -1;

      computedComments = [...computedComments].sort((a, b) => {
        if (isNumeric) {
          return reversed * (parseFloat(a[sorting.field] || 0) - parseFloat(b[sorting.field] || 0));
        } else {
          const aVal = a[sorting.field] || "";
          const bVal = b[sorting.field] || "";
          return reversed * aVal.localeCompare(bVal);
        }
      });
    }

    return {
      filteredComments: computedComments,
      totalFilteredItems: computedComments.length
    };
  }, [
    comments,
    search,
    sorting,
    selectedCliente,
    selectedColaborador,
    status,
    autorizadoApartado,
    autorizadoSurtido,
    selectedArea,
  ]);

  // Update totalItems when filtered results change (separate from useMemo to avoid side effects)
  useEffect(() => {
    setTotalItems(totalFilteredItems);
  }, [totalFilteredItems]);

  // Reset to page 1 when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [
    search,
    selectedCliente,
    selectedColaborador,
    status,
    autorizadoApartado,
    autorizadoSurtido,
    selectedArea,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

  // Paginated data for current page
  const commentsData = useMemo(() => {
    return filteredComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [filteredComments, currentPage]);

  // Pre-calcular qué pedidos necesitan advertencia (fondo rojo) — evita llamar shouldShowWarning por fila en cada render.
  // Replica el conteo por día calendario de getDiasPedido (definido más abajo; no se
  // puede invocar aquí porque el useMemo se ejecuta antes de su inicialización).
  const warningIds = useMemo(() => {
    const hoy = new Date();
    const hoyDia = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
    const ids = new Set();
    commentsData.forEach((a) => {
      const saldo = parseFloat(a.saldo || 0);
      if (saldo <= 0) return;
      const fechaRef = a.fechaContador || a.fecha;
      if (!fechaRef) return;
      let refDia;
      if (typeof fechaRef === "string" && /^\d{4}-\d{2}-\d{2}$/.test(fechaRef)) {
        const [y, m, d] = fechaRef.split("-").map(Number);
        refDia = new Date(y, m - 1, d);
      } else {
        const parsed = new Date(fechaRef);
        if (isNaN(parsed.getTime())) return;
        const esMedianocheUTC =
          parsed.getUTCHours() === 0 &&
          parsed.getUTCMinutes() === 0 &&
          parsed.getUTCSeconds() === 0 &&
          parsed.getUTCMilliseconds() === 0;
        refDia = esMedianocheUTC
          ? new Date(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate())
          : new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
      }
      const diffDays = Math.round((hoyDia.getTime() - refDia.getTime()) / 86400000);
      if (diffDays >= 7) ids.add(a._id);
    });
    return ids;
  }, [commentsData]);

  function EditArticulos(
    idOC,
    numero_pedido,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    iva,
    total_general,
    total_cantidad,
    surtido,
    areaSurtido,
    clientes,
    idClientes,
    fechaModificado,
    descuento,
    colaboradorId,
    paqueteriaId,
    areaId,
    observacionesPedido,
    descuentoImporte
  ) {
    // Limpiar el input del scanner al abrir el modal de edición
    setScannerInput("");
    if (scannerTimeoutRef.current) {
      clearTimeout(scannerTimeoutRef.current);
    }

    // Resetear estados de formularios de agregar artículos
    setManualInput({
      articulosNombre: "",
      articulos: "",
      idArticuloProporcion: "",
      idColor: "",
      idTalla: "",
      tallaNombre: "",
      cantidad: 0,
      precio: 0,
      precioOriginal: 0,
      colores: [],
      tallas: [],
      total: 0,
      precioEsp: "No",
    });

    setInputArticulos([
      {
        id: uuidv4(),
        articulos: "",
        cajas: 0,
        precio: 0,
        precioOriginal: 0,
        articulosNombre: "",
        colores: [],
        tallas: [],
        EAN: "",
        precioEsp: "No",
      },
    ]);

    // Limpiar inputFields para empezar con artículos nuevos limpios
    setInputFields([]);

    setComisionTDC(comisionTDC);
    setComisionFlete(comisionFlete);
    setSelectedImpuesto(impuestos);
    setSurtido(surtido);
    setIva(iva.toFixed(2));
    setTotalGeneralEdit(total_general);
    setTotalCantidadEdit(total_cantidad);
    setSubTotal(subTotal);
    setAreaSurtido(areaSurtido);
    setNombreClienteEdit(clientes);
    setFechaModificado(fechaModificado);
    setSelectedClienteEdit(idClientes);
    setDescuentoEdit(descuento);
    descuentoEditRef.current = descuento;
    const importeInicial = descuentoImporte || 0;
    setDescuentoImporteEdit(importeInicial);
    descuentoImporteEditRef.current = importeInicial;
    discountModeEditRef.current = importeInicial > 0 ? 'amount' : 'percent';

    // Nuevos campos para edición inline
    setSelectedColaboradorEdit(colaboradorId);
    setPaqueteria(paqueteriaId);
    setSelectedAreaEdit(areaId);
    setSelectedAreaEditVieja(areaId);
    setObservaciones(observacionesPedido);

    // Calcular el saldo inicial: total_general - abonos
    const pedidoEnEdicion = comments.find((p) => p._id === idOC);
    const abonosActuales = pedidoEnEdicion ? pedidoEnEdicion.abonos || 0 : 0;
    const saldoInicial = total_general - parseFloat(abonosActuales);
    setSaldoEdit(saldoInicial.toFixed(2));

    setArticulosPedido([]);
    setCargandoArticulosPedido(true);
    setIdEdit(idOC);
    setNumeroPedido(numero_pedido);

    // Carga lazy de datos del modal de edición — solo si aún no están cargados
    const editHeaders = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

    // Artículos (para el autocomplete de agregar artículos)
    if (!articulos || articulos.length === 0) {
      axios.get(`${URL_ARTICULOS}Activos`, { headers: editHeaders })
        .then((r) => setArticulos(r.data))
        .catch(console.log);
    }

    // Tallas (para el grid de tallas al agregar artículos)
    if (!tallas || tallas.length === 0) {
      axios.get(URL_TALLAS, { headers: editHeaders })
        .then((r) => {
          setTallas(r.data);
          setCustomSizeOrder(r.data.map((t) => t.name));
        })
        .catch(console.log);
    }

    // Paqueterías (para el select de paquetería en el header del pedido)
    if (!paqueterias || paqueterias.length === 0) {
      axios.get(URL_PAQUETERIAS, { headers: editHeaders })
        .then((r) => setPaqueterias(r.data))
        .catch(console.log);
    }

    // Inventarios (para validar disponibilidad al modificar cantidades)
    if (!inventarios || inventarios.length === 0) {
      setCargandoInventarios(true);
      axios.get(URL_INVENTARIOS_BODEGA_PEDIDO, { headers: editHeaders })
        .then((res) => {
          setInventarios(Array.isArray(res.data) ? res.data : []);
          setCargandoInventarios(false);
        })
        .catch((err) => {
          console.log("Error cargando inventarios:", err);
          setCargandoInventarios(false);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudieron cargar los inventarios. Reintente más tarde.",
          });
        });
    }

    axios
      .get(`${URL_ARTICULOS_PEDIDO}/pedidos/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosPedido = response.data;
        let arrayTabla = allArticulosPedido
          .map((a) => {
            return {
              id: a._id,
              is_active: a.is_active,
              articulos: a.articulos[0]._id,
              codigo: a.articulos[0].codigo + " " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              surtido: a.surtido,
              precio: a.precio,
              precioOriginal: a.articulos[0].venta,
              total: a.total,
              pendiente_surtir: a.pendiente_surtir,
              colorNombre: a.colores[0].name,
              idColor: a.colores[0]._id,
              tallaNombre: a.tallas[0].name,
              idTalla: a.tallas[0]._id,
              colores: a.articulos[0].colores,
              tallas: a.articulos[0].tallas,
              createdAt: a.createdAt,
              precioEsp: a.articulos[0].precioEsp || "No",
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        // Sort articles using the helper function
        const sortedData = sortArticulosPedido(dataFinal);

        setArticulosPedido(sortedData);
        articulosPedidoOriginalRef.current = sortedData.map((a) => ({
          id: a.id,
          codigo: a.codigo,
          cantidad: a.cantidad,
          precio: a.precio,
          createdAt: a.createdAt,
        }));

        // Cargar fotos de todos los productos del pedido
        sortedData.forEach((item) => {
          fetchProductPhoto(item.articulos);
        });
        
        // Reiniciar incrementos acumulados cuando se abre un pedido para editar
        reiniciarIncrementosAcumulados();
        setCargandoArticulosPedido(false);
      })
      .catch((err) => {
        console.log(err);
        setCargandoArticulosPedido(false);
      });
    setAbrirEditar(true);
  }

  const handleChangeInputExistentesPrecio = (id, event) => {
    const newArticulosPedido = articulosPedido.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        const totalParcial = i.cantidad * event;
        return {
          ...i,
          precio: event,
          total: totalParcial,
          pendiente_surtir: i.cantidad - i.surtido
        };
      }
      return i;
    });
    setArticulosPedido(newArticulosPedido);
    ActualizaTotales();
  };

  const handleChangeInputExistentes = (id, event) => {
    const newArticulosPedido = articulosPedido.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        const updated = { ...i, [event.target.name]: event.target.value };

        // Update color or size name when IDs change
        if (event.target.name === "idColor") {
          const selectedColor = i.colores?.find(c => c._id === event.target.value);
          if (selectedColor) {
            updated.colorNombre = selectedColor.name;
          }
        } else if (event.target.name === "idTalla") {
          const selectedTalla = i.tallas?.find(t => t._id === event.target.value);
          if (selectedTalla) {
            updated.tallaNombre = selectedTalla.name;
          }
        }
        return updated;
      }
      return i;
    });

    // Apply sorting if color or size changed (which affects sort order)
    if (event.target.name === "idColor" || event.target.name === "idTalla") {
      const sortedArticulos = sortArticulosPedido(newArticulosPedido);
      setArticulosPedido(sortedArticulos);
    } else {
      setArticulosPedido(newArticulosPedido);
    }
  };

  function BuscaArticuloExistentes(id, event) {
    articulos.map((a) => {
      if (a._id === event.target.value) {
        let idArticulo = a._id;
        handleChangeInputExistentesArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputExistentesArticulo = (id, idArticulo) => {
    const newArticulosPedido = articulosPedido.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        const totalParcial = i.cantidad * i.precio;
        return {
          ...i,
          articulos: idArticulo,
          total: totalParcial,
          pendiente_surtir: i.cantidad - i.surtido
        };
      }
      return i;
    });
    setArticulosPedido(newArticulosPedido);
    ActualizaTotales();
  };

  const handleChangeInputCantidadExistentes = (id, event) => {
    const nuevaCantidad = parseFloat(event.target.value) || 0;
    
    // Encontrar el artículo que se está editando
    const articuloActual = articulosPedido.find(item => item.id === id);
    if (!articuloActual) return;

    // La cantidad nunca puede quedar por debajo de lo ya surtido:
    // dejaría pendiente_surtir en negativo sobre mercancía que ya salió
    const surtidoActual = parseFloat(articuloActual.surtido || 0);
    if (surtidoActual > 0 && nuevaCantidad < surtidoActual) {
      Swal.fire({
        icon: "error",
        title: "Cantidad inválida",
        text: `Este renglón ya tiene ${surtidoActual} pieza(s) surtida(s). La cantidad no puede ser menor.`,
        timer: 4000,
        showConfirmButton: false,
      });
      return;
    }

    // Calcular el incremento
    const incremento = nuevaCantidad - articuloActual.cantidad;

    // Solo validar si se está incrementando la cantidad
    if (incremento > 0) {
      // Obtener disponible dinámico ANTES de hacer el cambio
      const inventarioDisponible = getInventoryAvailable(articuloActual.articulos, articuloActual.idColor, articuloActual.idTalla);
      
      if (incremento > inventarioDisponible) {
        Swal.fire({
          icon: "error",
          title: "Inventario insuficiente",
          text: `Solo puedes incrementar máximo ${inventarioDisponible} unidades. Intentas incrementar ${incremento} unidades.`,
          timer: 4000,
          showConfirmButton: false,
        });
        return; // No continuar si el incremento excede el disponible
      }
    }
    
    // Si llegamos aquí, el cambio es válido
    // Registrar el incremento en el sistema dinámico
    registrarIncrementoInventario(articuloActual.articulos, articuloActual.idColor, articuloActual.idTalla, incremento);

    const newArticulosPedido = articulosPedido.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        const totalParcial = nuevaCantidad * i.precio;
        return {
          ...i,
          cantidad: nuevaCantidad,
          total: totalParcial,
          pendiente_surtir: nuevaCantidad - parseFloat(i.surtido)
        };
      }
      return i;
    });
    setArticulosPedido(newArticulosPedido);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const nuevaCantidad = parseFloat(event.target.value) || 0;

    // Encontrar el artículo que se está editando
    const articuloActual = inputFields.find(item => item.id === id);
    if (!articuloActual) return;

    // Calcular el incremento
    const incremento = nuevaCantidad - articuloActual.cantidad;

    // Solo validar si se está incrementando la cantidad
    if (incremento > 0) {
      // Obtener disponible dinámico ANTES de hacer el cambio
      const inventarioDisponible = getInventoryAvailable(articuloActual.articulos, articuloActual.idColor, articuloActual.idTalla);

      if (incremento > inventarioDisponible) {
        Swal.fire({
          icon: "error",
          title: "Inventario insuficiente",
          text: `Solo puedes incrementar máximo ${inventarioDisponible} unidades. Intentas incrementar ${incremento} unidades.`,
          timer: 4000,
          showConfirmButton: false,
        });
        return; // No continuar si el incremento excede el disponible
      }
    }

    // Si llegamos aquí, el cambio es válido
    // Registrar el incremento en el sistema dinámico
    registrarIncrementoInventario(articuloActual.articulos, articuloActual.idColor, articuloActual.idTalla, incremento);

    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        const totalParcial = nuevaCantidad * i.precio;
        return {
          ...i,
          cantidad: nuevaCantidad,
          total: totalParcial
        };
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // Prevent Enter from submitting the form
  const preventEnterSubmit = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        return { ...i, [event.target.name]: event.target.value };
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleAddFields = (id) => {
    const inputSearch = articulosPedido.find((input) => input.id === id);

    if (!inputSearch) return;

    const updatedFields = articulosPedido.map((input) => {
      if (
        input.articulos === inputSearch.articulos &&
        input.idColor === inputSearch.idColor
      ) {
        return { ...input, is_active: "Si" };
      }
      return input;
    });

    setArticulosPedido(updatedFields);
  };

  const handleRemoveFields = (id) => {
    const inputSearch = articulosPedido.find((input) => input.id === id);

    if (!inputSearch) return;

    const updatedFields = articulosPedido.map((input) => {
      if (
        input.articulos === inputSearch.articulos &&
        input.idColor === inputSearch.idColor
      ) {
        return { ...input, is_active: "No" };
      }
      return input;
    });

    setArticulosPedido(updatedFields);
  };

  const handleChangeInputPrecio = (id, value) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        const totalParcial = i.cantidad * value;
        return {
          ...i,
          precio: value,
          total: totalParcial
        };
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, event) {
    articulos.forEach((a) => {
      if (a._id === event.target.value) {
        let idArticulo = a._id;
        let precio = a.venta;
        let colores = a.colores;
        let tallas = a.tallas;
        handleChangeInputArticulo(id, idArticulo, precio, colores, tallas);
      }
    });
  }

  const handleChangeInputArticulo = (
    id,
    idArticulo,
    precio,
    colores,
    tallas
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        // Create a new object to avoid direct mutation
        const totalParcial = i.cantidad * precio;
        return {
          ...i,
          articulos: idArticulo,
          precio,
          total: totalParcial,
          colores,
          tallas
        };
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

const removeInputField = (id) => {
  const updatedFields = inputFields.filter(field => field.id !== id);
  setInputFields(updatedFields);
  ActualizaTotales();
};

// ActualizaTotales was moved to useCallback at the top of the component to fix hoisting issue

  function calculaDescuento(e) {
    discountModeEditRef.current = 'percent';
    const pct = parseFloat(e) || 0;
    setDescuentoEdit(pct);
    descuentoEditRef.current = pct;
    const descImporte = parseFloat(((subTotal * pct) / 100).toFixed(2));
    setDescuentoImporteEdit(descImporte);
    descuentoImporteEditRef.current = descImporte;
    const ivaActual = (selectedImpuesto * subTotal) / 100;
    setIva(ivaActual);
    const totTemp = subTotal + ivaActual + parseFloat(comisionTDC) + parseFloat(comisionFlete) - descImporte;
    setTotalGeneralEdit(totTemp.toFixed(2));
    const pedidoEnEdicion = comments.find((p) => p._id === idEdit);
    const abonosActuales = pedidoEnEdicion ? pedidoEnEdicion.abonos || 0 : 0;
    setSaldoEdit((totTemp - parseFloat(abonosActuales)).toFixed(2));
  }

  function calculaDescuentoImporteEdit(e) {
    discountModeEditRef.current = 'amount';
    const val = parseFloat(parseFloat(e || 0).toFixed(2));
    setDescuentoImporteEdit(val);
    descuentoImporteEditRef.current = val;
    // Actualizar % solo para display — NO dispara ActualizaTotales
    const pct = subTotal > 0 ? parseFloat(((val / subTotal) * 100).toFixed(2)) : 0;
    setDescuentoEdit(pct);
    descuentoEditRef.current = pct;
    const ivaActual = (selectedImpuesto * subTotal) / 100;
    setIva(ivaActual);
    // Total usa el valor exacto ingresado por el usuario
    const totTemp = subTotal + ivaActual + parseFloat(comisionTDC) + parseFloat(comisionFlete) - val;
    setTotalGeneralEdit(totTemp.toFixed(2));
    const pedidoEnEdicion = comments.find((p) => p._id === idEdit);
    const abonosActuales = pedidoEnEdicion ? pedidoEnEdicion.abonos || 0 : 0;
    setSaldoEdit((totTemp - parseFloat(abonosActuales)).toFixed(2));
  }

  const savePedido = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();

    // Validar inventario antes de guardar (solo para nuevos artículos)
    let validacionExitosa = true;

    // Solo validar nuevos artículos agregados (inputFields)
    // Los artículos existentes ya fueron validados individualmente
    for (const articulo of inputFields) {
      if (articulo.cantidad > 0) {
        const esValido = checkInventoryAvailability(
          articulo.articulos,
          articulo.idColor,
          articulo.idTalla,
          articulo.cantidad,
          0, // No hay cantidad existente
          true // Es artículo nuevo
        );
        
        if (!esValido) {
          validacionExitosa = false;
          break;
        }
      }
    }

    if (!validacionExitosa) {
      setValidaBoton(true);
      toggleProgreso();
      Swal.fire({
        icon: "error",
        title: "Error de validación",
        text: "Hay artículos con cantidades que exceden el inventario disponible",
      });
      return;
    }

    // Validar los renglones existentes, que pudieron corregirse en cantidad o precio
    const abortarGuardado = (title, text) => {
      setValidaBoton(true);
      toggleProgreso();
      Swal.fire({ icon: "error", title, text });
    };

    // Sólo se validan los renglones que esta edición tocó: un pedido con datos
    // inconsistentes de antes debe poder seguir guardándose sin quedar atorado.
    for (const a of articulosPedido) {
      if (a.is_active === "No") continue;

      const original = articulosPedidoOriginalRef.current.find((o) => o.id === a.id);
      const nombreArticulo = a.articulosNombre || a.codigo;
      const surtidoActual = parseFloat(a.surtido || 0);

      const cantidadCambio =
        !original || parseFloat(original.cantidad) !== parseFloat(a.cantidad);
      if (cantidadCambio && parseFloat(a.cantidad || 0) < surtidoActual) {
        abortarGuardado(
          "Cantidad inválida",
          `${nombreArticulo}: la cantidad no puede ser menor a las ${surtidoActual} pieza(s) ya surtida(s).`
        );
        return;
      }

      // Los modelos con precios autorizados sólo admiten uno de esos precios
      const precioCambio =
        !original || parseFloat(original.precio) !== parseFloat(a.precio);
      const articuloCatalogo = articulos.find((art) => art._id === a.articulos);
      if (precioCambio && articuloCatalogo && articuloCatalogo.precioEsp === "Si") {
        const precioActual = parseFloat(a.precio || 0);
        const esAutorizado = getPriceOptions(articuloCatalogo).some(
          (opcion) => Math.abs(opcion.value - precioActual) < 0.01
        );
        if (!esAutorizado) {
          abortarGuardado(
            "Precio no autorizado",
            `${nombreArticulo}: selecciona uno de los precios autorizados para este modelo.`
          );
          return;
        }
      }
    }

    // Correcciones hechas sobre renglones ya fuera de la ventana de 24h: quedan en bitácora
    const correcciones = articulosPedido.reduce((acc, a) => {
      const original = articulosPedidoOriginalRef.current.find((o) => o.id === a.id);
      if (!original || a.is_active === "No" || dentroVentana24h(original.createdAt)) {
        return acc;
      }

      const cambios = [];
      if (parseFloat(original.cantidad) !== parseFloat(a.cantidad)) {
        cambios.push(`cantidad ${original.cantidad} a ${a.cantidad}`);
      }
      if (parseFloat(original.precio) !== parseFloat(a.precio)) {
        cambios.push(`precio ${original.precio} a ${a.precio}`);
      }
      if (cambios.length > 0) {
        acc.push(`${original.codigo}: ${cambios.join(", ")}`);
      }
      return acc;
    }, []);

    let totalPedido = inputFields.length + articulosPedido.length;
    const URL_PEDIDOS_EDIT = `${URL_PEDIDOS}/${idEdit}`;
    
    // Verificar si se cambió de almacén
    const cambioAlmacen = selectedAreaEditVieja !== selectedAreaEdit;
    
    try {
      // Actualizar datos del pedido incluyendo nuevos campos
      await axios
        .patch(
          URL_PEDIDOS_EDIT,
          {
            total_general: parseFloat(total_general_edit).toFixed(2),
            total_cantidad: total_cantidad_edit,
            editArticulos: user.id,
            comisionTDC,
            comisionFlete,
            subTotal: parseFloat(subTotal).toFixed(2),
            iva: parseFloat(iva).toFixed(2),
            impuestos: selectedImpuesto,
            editado: "Si",
            autorizadoSurtido: cambioAlmacen ? "No" : "No",
            fechaModificado,
            descuento: descuentoEdit,
            descuentoImporte: descuentoImporteEdit,
            // Nuevos campos de edición inline
            colaboradores: selectedColaboradorEdit,
            paqueterias: paqueteria,
            areas: selectedAreaEdit,
            observaciones: observaciones,
            editPedido: user.id,
            autorizoApartado: cambioAlmacen ? user.id : undefined
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          if (correcciones.length > 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Corrección Prendas Pedido",
                detalle: `${numero_pedido} | ${correcciones.join(" | ")}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
          }
          inputFields.map((a) => {
            if (a.articulos !== "" && a.cantidad !== 0) {
              // Validar precios solo si no es precio especial
              if (a.is_active !== "No" && a.precioEsp !== "Si" && a.precioOriginal && (a.precioOriginal - 51 > a.precio)) {
                Swal.fire({
                  icon: "warning",
                  title: "Precio muy bajo",
                  text: `El precio ${a.precio} es menor al permitido para ${a.articulosNombre}`,
                });
                return;
              }

              axios
                .post(
                  URL_ARTICULOS_PEDIDO,
                  {
                    pedidos: idEdit,
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total).toFixed(2),
                    surtido: 0,
                    pendiente_surtir: parseFloat(a.cantidad),
                    autorizadoApartado: "Si",
                    autorizadoSurtido: "No",
                    clientes: selectedClienteEdit,
                    colores: a.idColor,
                    tallas: a.idTalla,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalPedido = totalPedido - 1;
                  if (totalPedido === 0) {
                    axios.post(
                      URL_LOGS,
                      {
                        tipo: "Editar Pedido",
                        detalle: `${numero_pedido}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );
                    Swal.fire("Good job!", "Creado con exito", `success`);
                    setTimeout(() => finalizarEdicionPedido(), 1000); // mismo margen que tenía el reload: que terminen los POST pendientes
                  }
                });
            } else {
              totalPedido = totalPedido - 1;
              if (totalPedido === 0) {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Editar Pedido",
                    detalle: `${numero_pedido}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire("Good job!", "Creado con exito", `success`);
                setTimeout(() => finalizarEdicionPedido(), 1000); // mismo margen que tenía el reload: que terminen los POST pendientes
              }
            }
          });
          articulosPedido.map((a) => {
            // Verificar si es un artículo nuevo (creado con handleCreateNewArticuloTalla)
            // Los artículos nuevos tienen un id UUID que no existe en la base de datos
            const isNewArticle =
              a.id && a.id.length === 36 && a.id.includes("-");

            if (isNewArticle) {
              // Validar precios solo si no es precio especial
              if (a.is_active !== "No" && a.precioEsp !== "Si" && a.precioOriginal && (a.precioOriginal - 51 > a.precio)) {
                Swal.fire({
                  icon: "warning",
                  title: "Precio muy bajo",
                  text: `El precio ${a.precio} es menor al permitido para ${a.articulosNombre || a.codigo}`,
                });
                return;
              }

              // Crear nuevo artículo
              axios
                .post(
                  URL_ARTICULOS_PEDIDO,
                  {
                    pedidos: idEdit,
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total).toFixed(2),
                    surtido: 0,
                    pendiente_surtir: parseFloat(a.cantidad),
                    autorizadoApartado: "Si",
                    autorizadoSurtido: "Si",
                    clientes: selectedClienteEdit,
                    colores: a.idColor,
                    tallas: a.idTalla,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalPedido = totalPedido - 1;
                  if (totalPedido === 0) {
                    axios.post(
                      URL_LOGS,
                      {
                        tipo: "Editar Pedido",
                        detalle: `${numero_pedido}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );
                    Swal.fire("Good job!", "Creado con exito", `success`);
                    setTimeout(() => finalizarEdicionPedido(), 1000); // mismo margen que tenía el reload: que terminen los POST pendientes
                  }
                });
            } else {
              // Validar precios solo si no es precio especial
              if (a.is_active !== "No" && a.precioEsp !== "Si" && a.precioOriginal && (a.precioOriginal - 51 > a.precio)) {
                Swal.fire({
                  icon: "warning",
                  title: "Precio muy bajo",
                  text: `El precio ${a.precio} es menor al permitido para ${a.articulosNombre || a.codigo}`,
                });
                return;
              }

              // Actualizar artículo existente
              axios
                .patch(
                  `${URL_ARTICULOS_PEDIDO}/${a.id}`,
                  {
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total).toFixed(2),
                    pendiente_surtir: parseFloat(a.pendiente_surtir),
                    colores: a.idColor,
                    tallas: a.idTalla,
                    is_active: a.is_active || "Si",
                    // autorizadoApartado: "No",
                    // autorizadoSurtido: "No",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalPedido = totalPedido - 1;
                  if (totalPedido === 0) {
                    axios.post(
                      URL_LOGS,
                      {
                        tipo: "Editar Pedido",
                        detalle: `${numero_pedido}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );
                    Swal.fire("Good job!", "Creado con exito", `success`);
                    setTimeout(() => finalizarEdicionPedido(), 1000); // mismo margen que tenía el reload: que terminen los POST pendientes
                  }
                });
            }
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
          });
          console.log(error);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
      });
      console.log(error);
    }
  };

  function desautorizarApartado(id) {
    const URL_AUTORIZADO = `${URL_PEDIDOS}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_PEDIDO}/autorizadoApartado/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se liberará el inventario!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, liberar el inventario!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizadoApartado: "No",
              autorizadoSurtido: "No",
              autorizoApartado: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                URL_AUTORIZADO_HIJO,
                {
                  autorizadoApartado: "No",
                  autorizadoSurtido: "No",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Desautorizar Apartado",
                    detalle: `${numero_pedido} ${fecha}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se libero el inventario",
                  showConfirmButton: false,
                  timer: 2000,
                });
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.autorizadoApartado = "No";
                    i.autorizadoSurtido = "No";
                  }
                  return i;
                });
                setComments(newComments);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          });
      }
    });
  }

  // Bloquea/desbloquea manualmente un pedido para impedir que se agreguen más
  // piezas, SIN liberar las prendas (no toca apartado ni surtido).
  function toggleBloqueo(id, estadoActual, numeroPedido, fechaPedido) {
    const nuevoEstado = estadoActual === "Si" ? "No" : "Si";
    const bloqueando = nuevoEstado === "Si";

    Swal.fire({
      title: "Estas seguro?",
      text: bloqueando
        ? "Se va a bloquear el pedido. No se podrán agregar más piezas, pero las prendas seguirán apartadas."
        : "Se va a desbloquear el pedido. Se podrán volver a agregar piezas.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: bloqueando ? "Si, bloquear!" : "Si, desbloquear!",
    }).then((result) => {
      if (!result.isConfirmed) return;
      axios
        .patch(
          `${URL_PEDIDOS}/${id}`,
          { bloqueado: nuevoEstado },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          axios.post(
            URL_LOGS,
            {
              tipo: bloqueando ? "Bloquear Pedido" : "Desbloquear Pedido",
              detalle: `${numeroPedido ?? numero_pedido ?? ""} ${fechaPedido ?? fecha ?? ""}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          Swal.fire({
            position: "center",
            icon: "success",
            title: bloqueando ? "Pedido bloqueado" : "Pedido desbloqueado",
            showConfirmButton: false,
            timer: 2000,
          });
          const newComments = comments.map((i) => {
            if (id === i._id) {
              i.bloqueado = nuevoEstado;
            }
            return i;
          });
          setComments(newComments);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error?.response?.data?.message || error?.response?.data?.error || ""}`,
          });
          console.log(error);
        });
    });
  }

  function autorizarApartado(id, almacen) {
    const URL_AUTORIZADO = `${URL_PEDIDOS}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_PEDIDO}/autorizadoApartado/${id}`;

    axios
      .get(`${URL_ARTICULOS_PEDIDO}/surtir4/${id}/${almacen}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosAutorizar = response.data;

        let cantidadArticulos = allArticulosAutorizar.length;

        allArticulosAutorizar.map((a) => {
          // if (a.cantidadPedido > a.disponible) {
          //   return toggleNoDisponible();
          // } else
          {
            cantidadArticulos = cantidadArticulos - 1;
            if (cantidadArticulos === 0) {
              Swal.fire({
                title: "Estas seguro?",
                text: "Se va a bloquear el inventario!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, bloquear!",
              }).then((result) => {
                if (result.isConfirmed) {
                  axios
                    .patch(
                      URL_AUTORIZADO,
                      {
                        autorizadoApartado: "Si",
                        autorizoApartado: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then((response) => {
                      axios
                        .patch(
                          URL_AUTORIZADO_HIJO,
                          {
                            autorizadoApartado: "Si",
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          axios.post(
                            URL_LOGS,
                            {
                              tipo: "Autorizar Apartado",
                              detalle: `${numero_pedido} ${fecha}`,
                              user: user.id,
                            },
                            {
                              headers: {
                                Authorization: `Bearer: ${localStorage.getItem(
                                  "app_token"
                                )}`,
                              },
                            }
                          );
                          Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se Aparto",
                            showConfirmButton: false,
                            timer: 2000,
                          });
                          const newComments = comments.map((i) => {
                            if (id === i._id) {
                              i.autorizadoApartado = "Si";
                            }
                            return i;
                          });
                          setComments(newComments);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                          });
                          console.log(error);
                        });
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                      });
                      console.log(error);
                    });
                }
              });
            }
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function desautorizarSurtido(id) {
    const URL_AUTORIZADO = `${URL_PEDIDOS}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_PEDIDO}/autorizadoSurtido/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se quitara la autorizacion de Surtir!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, quitar autorizacion!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizadoSurtido: "No",
              autorizoSurtido: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                URL_AUTORIZADO_HIJO,
                {
                  autorizadoSurtido: "No",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Desautorizar Surtido",
                    detalle: `${numero_pedido} ${fecha}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se quito la autorizacion",
                  showConfirmButton: false,
                  timer: 2000,
                });
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.autorizadoSurtido = "No";
                  }
                  return i;
                });
                setComments(newComments);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          });
      }
    });
  }

  // Ventana libre de 24 horas desde que se capturó la prenda
  const dentroVentana24h = (createdAt) => {
    if (!createdAt) return false;
    const itemDate = new Date(createdAt);
    const now = new Date();
    const hoursDiff = (now - itemDate) / (1000 * 60 * 60);
    return hoursDiff <= 24;
  };

  const canCancelItem = (createdAt) => {
    if (!createdAt) return false;
    // Allow cancellation within 24 hours OR with authorization
    return dentroVentana24h(createdAt) || cancelarPrendas;
  };

  // Corregir cantidad/precio: libre dentro de las 24h, después sólo con permiso de perfil
  const canEditItem = (createdAt) => {
    if (!createdAt) return false;
    return dentroVentana24h(createdAt) || !!user.corrigeArticulosPedido;
  };

  // Check if item needs authorization to cancel (after 24 hours)
  const needsAuthorizationToCancel = (createdAt) => {
    if (!createdAt) return false;
    return !dentroVentana24h(createdAt);
  };

  // New function to format creation date
  const formatCreatedDate = (createdAt) => {
    if (!createdAt) return "N/A";
    return moment(createdAt).format("DD/MM/YYYY HH:mm");
  };

  // Function to handle cancellation with authorization check
  const handleCancelarArticulo = (id) => {
    const itemToCancel = articulosPedido.find(item => item.id === id);
    if (!itemToCancel) return;

    // Check if authorization is needed (after 24 hours)
    if (needsAuthorizationToCancel(itemToCancel.createdAt) && !cancelarPrendas) {
      // Show authorization modal
      setItemToCancelId(id);
      toggleCancelarPrendas();
      return;
    }

    // Proceed with cancellation (either within 24 hours or authorized)
    cancelarArticulo(id);
  };

  // Add this function to handle cancellation of articles
  const cancelarArticulo = (id) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción cancelará permanentemente este artículo del pedido",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, cancelar artículo",
      cancelButtonText: "No, mantener"
    }).then((result) => {
      if (result.isConfirmed) {
      // Find the item to get its data for calculations
      const itemToCancel = articulosPedido.find(item => item.id === id);
      if (!itemToCancel) return;

      // Update the article to cancelled status
      axios.patch(
        `${URL_ARTICULOS_PEDIDO}/${id}`,
        {
          is_active: "No",
          cancelado: "Si",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        // Update local state
        const updatedArticulos = articulosPedido.map(item =>
          item.id === id
            ? { ...item, is_active: "No", cancelado: "Si", cancelledAt: new Date() }
            : item
        );
        setArticulosPedido(updatedArticulos);
        
        // Calculate new totals after cancellation
        const activeItems = updatedArticulos.filter(item => item.is_active === "Si");
        const allActiveItems = [...activeItems, ...inputFields];
        
        const newTotalCantidad = allActiveItems.reduce((sum, item) => sum + parseFloat(item.cantidad || 0), 0);
        const newSubTotal = allActiveItems.reduce((sum, item) => sum + parseFloat(item.total || 0), 0);
        const newIva = selectedImpuesto !== 0 ? (selectedImpuesto * newSubTotal) / 100 : 0;
        const discountAmount = discountModeEditRef.current === 'amount'
          ? parseFloat(descuentoImporteEditRef.current || 0)
          : parseFloat(((newSubTotal * descuentoEditRef.current) / 100).toFixed(2));
        const newDescuentoPct = newSubTotal > 0 ? parseFloat(((discountAmount / newSubTotal) * 100).toFixed(2)) : descuentoEditRef.current;
        const newTotalGeneral = newSubTotal + newIva + parseFloat(comisionTDC) + parseFloat(comisionFlete) - discountAmount;

        // Update the pedido with new totals
        axios.patch(
          `${URL_PEDIDOS}/${idEdit}`,
          {
            total_cantidad: newTotalCantidad,
            total_general: parseFloat(newTotalGeneral).toFixed(2),
            subTotal: parseFloat(newSubTotal).toFixed(2),
            iva: parseFloat(newIva).toFixed(2),
            descuento: newDescuentoPct,
            descuentoImporte: parseFloat(discountAmount).toFixed(2),
            editArticulos: user.id,
            fechaModificado: moment().format("YYYY-MM-DD")
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          // Update local pedido state
          const updatedComments = comments.map(pedido => 
            pedido._id === idEdit 
              ? { 
                  ...pedido, 
                  total_cantidad: newTotalCantidad,
                  total_general: newTotalGeneral,
                  subTotal: newSubTotal,
                  iva: newIva,
                  saldo: newTotalGeneral - (pedido.abonos || 0)
                }
              : pedido
          );
          setComments(updatedComments);
          
          // Update local edit state
          setTotalCantidadEdit(newTotalCantidad);
          setTotalGeneralEdit(newTotalGeneral.toFixed(2));
          setSubTotal(newSubTotal.toFixed(2));
          setIva(newIva.toFixed(2));
          setDescuentoNumeroEdit(discountAmount.toFixed(2));
          setDescuentoEdit(newDescuentoPct);
          descuentoEditRef.current = newDescuentoPct;
          setDescuentoImporteEdit(parseFloat(discountAmount.toFixed(2)));
          descuentoImporteEditRef.current = parseFloat(discountAmount.toFixed(2));
          
          // Calculate new saldo
          const pedidoEnEdicion = comments.find((p) => p._id === idEdit);
          const abonosActuales = pedidoEnEdicion ? pedidoEnEdicion.abonos || 0 : 0;
          const nuevoSaldo = newTotalGeneral - parseFloat(abonosActuales);
          setSaldoEdit(nuevoSaldo.toFixed(2));
          
          // Log the action
          axios.post(
            URL_LOGS,
            {
              tipo: "Cancelar Artículo Pedido",
              detalle: `Artículo cancelado del pedido ${numero_pedido} - Nueva cantidad: ${newTotalCantidad}, Nuevo total: ${newTotalGeneral.toFixed(2)}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          Swal.fire({
            position: "center",
            icon: "success",
            title: "Artículo cancelado exitosamente",
            text: `Pedido actualizado - Total: ${newTotalGeneral.toFixed(2)}`,
            showConfirmButton: false,
            timer: 3000,
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo actualizar el pedido",
            footer: `${error.response?.data?.message || error.response?.data?.error || error.message}`,
          });
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo cancelar el artículo",
          footer: `${error.response?.data?.message || error.response?.data?.error || error.message}`,
        });
      });
    }
  });
};

  function autorizarSurtido(id) {
    const URL_AUTORIZADO = `${URL_PEDIDOS}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_PEDIDO}/autorizadoSurtido/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se va a autorizar Surtir!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, autorizar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizadoSurtido: "Si",
              autorizoSurtido: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                URL_AUTORIZADO_HIJO,
                {
                  autorizadoSurtido: "Si",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Autorizar Surtido",
                    detalle: `${numero_pedido} ${fecha}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se Autorizo",
                  showConfirmButton: false,
                  timer: 2000,
                });
                const newComments = comments.map((i) => {
                  if (id === i._id) {
                    i.autorizadoSurtido = "Si";
                  }
                  return i;
                });
                setComments(newComments);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          });
      }
    });
  }

  function calculaImpuesto(e) {
    setSelectedImpuesto(e);
    const st = parseFloat(subTotal) || 0;
    if (e !== 0) {
      setIva((e * st) / 100);
    } else {
      setIva(0);
    }
    const nuevoTotal =
      (e * st) / 100 +
      st +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      parseFloat(descuentoImporteEdit);
    setTotalGeneralEdit(nuevoTotal);

    // Calcular el nuevo saldo: total_general - abonos
    const pedidoEnEdicion = comments.find((p) => p._id === idEdit);
    const abonosActuales = pedidoEnEdicion ? pedidoEnEdicion.abonos || 0 : 0;
    const nuevoSaldo = nuevoTotal - parseFloat(abonosActuales);
    setSaldoEdit(nuevoSaldo.toFixed(2));
  }

  function jalaComisionTDC(e) {
    setComisionTDC(e);
    const st = parseFloat(subTotal) || 0;
    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * st) / 100);
    } else {
      setIva(0);
    }
    const nuevoTotal =
      (selectedImpuesto * st) / 100 +
      st +
      parseFloat(e) +
      parseFloat(comisionFlete) -
      parseFloat(descuentoImporteEdit);
    setTotalGeneralEdit(nuevoTotal);

    // Calcular el nuevo saldo: total_general - abonos
    const pedidoEnEdicion = comments.find((p) => p._id === idEdit);
    const abonosActuales = pedidoEnEdicion ? pedidoEnEdicion.abonos || 0 : 0;
    const nuevoSaldo = nuevoTotal - parseFloat(abonosActuales);
    setSaldoEdit(nuevoSaldo.toFixed(2));
  }

  function jalaComisionFlete(e) {
    setComisionFlete(e);
    const st = parseFloat(subTotal) || 0;
    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * st) / 100);
    } else {
      setIva(0);
    }
    const nuevoTotal =
      (selectedImpuesto * st) / 100 +
      st +
      parseFloat(comisionTDC) +
      parseFloat(e) -
      parseFloat(descuentoImporteEdit);
    setTotalGeneralEdit(nuevoTotal);

    // Calcular el nuevo saldo: total_general - abonos
    const pedidoEnEdicion = comments.find((p) => p._id === idEdit);
    const abonosActuales = pedidoEnEdicion ? pedidoEnEdicion.abonos || 0 : 0;
    const nuevoSaldo = nuevoTotal - parseFloat(abonosActuales);
    setSaldoEdit(nuevoSaldo.toFixed(2));
  }

  function autorizaCambio() {
    if (password === PASSWORD_CAMBIA_PRECIO) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  function autorizaCancelarPrendas() {
    if (passwordCancelar === PASSWORD_CANCELAR_PRENDAS) {
      setCancelarPrendas(true);
      toggleCancelarPrendas();
      // If there's a pending item to cancel, proceed with cancellation
      if (itemToCancelId) {
        cancelarArticulo(itemToCancelId);
        setItemToCancelId(null);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
    setPasswordCancelar("");
  }

  function bajaArticulo(id) {
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_PEDIDO}/autorizadoApartado/${idEdit}`;
    const temp = articulosPedido.map((i) => {
      if (id === i.id) {
        i.is_active = "No";
      }
      return i;
    });

    Swal.fire({
      title: "Estas seguro?",
      text: "Se dara de baja!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, dar de Baja!",
    }).then((result) => {
      if (result.isConfirmed) {
        let activos = temp.filter((e) => e.is_active === "Si");
        let cantidadActivos = activos.map((c) => parseFloat(c.cantidad));
        let TA = cantidadActivos.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TA);

        let totalActivos = activos.map((c) => parseFloat(c.total));
        let TG = totalActivos.reduce((t, total, index) => t + total, 0);
        setSubTotal(TG);

        let IT;
        if (selectedImpuesto !== 0) {
          IT = (selectedImpuesto * TG) / 100;
        } else {
          IT = 0;
        }

        setIva(IT);

        let TGT =
          (selectedImpuesto * TG) / 100 +
          TG +
          parseFloat(comisionTDC) +
          parseFloat(comisionFlete) -
          parseFloat(descuentoImporteEdit || 0);

        setTotalGeneralEdit(TGT.toFixed(2));

        axios
          .patch(
            `${URL_ARTICULOS_PEDIDO}/${id}`,
            {
              is_active: "No",
              autorizadoApartado: "No",
              autorizadoSurtido: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            //Patch Pedidos
            axios
              .patch(
                `${URL_PEDIDOS}/${idEdit}`,
                {
                  total_cantidad: TA,
                  total_general: TGT,
                  subTotal: TG,
                  iva: IT,
                  // autorizadoApartado: "No",
                  // autorizadoSurtido: "No",
                  autorizoApartado: user.id,
                  fechaModificado: hoy,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios
                  .patch(
                    URL_AUTORIZADO_HIJO,
                    {
                      autorizadoApartado: "No",
                      autorizadoSurtido: "No",
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    const newAP = articulosPedido.map((i) => {
                      if (id === i.id) {
                        i.is_active = "No";
                      }
                      return i;
                    });
                    setArticulosPedido(newAP);

                    const newPed = comments.map((i) => {
                      if (idEdit === i._id) {
                        i.total_cantidad = TA;
                        i.total_general = TGT;
                        i.subTotal = TG;
                        i.iva = IT;
                        // i.autorizadoApartado = "No";
                        // i.autorizadoSurtido = "No";
                      }
                      return i;
                    });
                    setComments(newPed);

                    Swal.fire({
                      position: "center",
                      icon: "success",
                      title: "Se dio de Baja",
                      showConfirmButton: false,
                      timer: 2000,
                    });
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                    });
                    console.log(error);
                  });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                });
                console.log(error);
              });
            //Termina Patch Pedidos
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          });
      }
    });
  }

  function altaArticulo(id) {
    const temp = articulosPedido.map((i) => {
      if (id === i.id) {
        i.is_active = "Si";
      }
      return i;
    });

    Swal.fire({
      title: "Estas seguro?",
      text: "Se dara de Alta!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, dar de Alta!",
    }).then((result) => {
      if (result.isConfirmed) {
        let activos = temp.filter((e) => e.is_active === "Si");
        let cantidadActivos = activos.map((c) => parseFloat(c.cantidad));
        let TA = cantidadActivos.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TA);

        let totalActivos = activos.map((c) => parseFloat(c.total));
        let TG = totalActivos.reduce((t, total, index) => t + total, 0);
        setSubTotal(TG);

        let IT;
        if (selectedImpuesto !== 0) {
          IT = (selectedImpuesto * TG) / 100;
        } else {
          IT = 0;
        }

        setIva(IT);

        let TGT =
          (selectedImpuesto * TG) / 100 +
          TG +
          parseFloat(comisionTDC) +
          parseFloat(comisionFlete) -
          parseFloat(descuentoImporteEdit || 0);

        setTotalGeneralEdit(TGT.toFixed(2));

        axios
          .patch(
            `${URL_ARTICULOS_PEDIDO}/${id}`,
            {
              is_active: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            //Patch Pedidos
            axios
              .patch(
                `${URL_PEDIDOS}/${idEdit}`,
                {
                  total_cantidad: TA,
                  total_general: TGT,
                  subTotal: TG,
                  iva: IT,
                  // autorizadoApartado: "No",
                  // autorizadoSurtido: "No",
                  autorizoApartado: user.id,
                  fechaModificado: hoy,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((response) => {
                const newAP = articulosPedido.map((i) => {
                  if (id === i.id) {
                    i.is_active = "Si";
                  }
                  return i;
                });
                setArticulosPedido(newAP);

                const newPed = comments.map((i) => {
                  if (idEdit === i._id) {
                    i.total_cantidad = TA;
                    i.total_general = TGT;
                    i.subTotal = TG;
                    i.iva = IT;
                    // i.autorizadoApartado = "No";
                    // i.autorizadoSurtido = "No";
                  }
                  return i;
                });
                setComments(newPed);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Se dio de Alta",
                  showConfirmButton: false,
                  timer: 2000,
                });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
                });
                console.log(error);
              });
            //Termina Patch Pedidos
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          });
      }
    });
  }

  async function QRGen(idPedido, numero, fecha) {
    try {
      const doc = new jsPDF("landscape", "mm", [100, 60], true);

      // Add product info at the top
      doc.setFontSize(8).setFont(undefined, "bold");
      doc.text(`PEDIDO: ${numero}`, 5, 10);
      doc.text(`FECHA: ${fecha}`, 5, 15);

      var qrDataUrl = qrcode.toDataURL(
        `${import.meta.env.VITE_LINK_SISTEMA}vistaPedido/${idPedido}`,
        4
      );
      var qrImage = new Image();
      qrImage.src = qrDataUrl;

      // Add the QR code image centered on the page
      doc.addImage(qrImage, "png", 30, 15, 40, 40);

      // Save the PDF
      // doc.save(`${codigo}_QR.pdf`);
      window.open(doc.output("bloburl"), "_blank");
    } catch (error) {
      console.error("Error generating QR codes:", error);
      throw error;
    }
  }

  // Función para abrir modal de abonos
  async function abrirModalAbonos(pedidoId, numeroPedido, clienteId, total_general, abonos, saldo, idColaborador) {
    // Cargar bancos de forma lazy — solo si aún no están cargados
    if (!bancos || bancos.length === 0) {
      axios.get(URL_BANCOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      }).then((r) => setBancos(r.data)).catch(console.log);
    }

    setSelectedPedidoAbono(pedidoId);
    setSelectedClienteAbono(clienteId);
    setTotalGeneralAbono(total_general);
    setTotalAbono(abonos);
    setSaldoAbono(saldo);
    setSelectedColaboradorAbono(idColaborador);
    const fechaHoy = moment().format("YYYY-MM-DD");
    setAbonoData({
      importe: 0,
      formaPago: "",
      concepto: `Abono a Pedido ${numeroPedido}`,
      observaciones: "",
      banco: "",
      fechaPago: fechaHoy,
      imagen: null,
    });

    // Buscar abonos existentes del pedido usando findOnePedido
    setCargandoAbonos(true);
    try {
      const response = await axios.get(`${URL_ABONOS}Pedido/${pedidoId}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      setAbonosExistentes(response.data);
    } catch (error) {
      console.error("Error al buscar abonos:", error);
      setAbonosExistentes([]);
    } finally {
      setCargandoAbonos(false);
    }

    toggleAbonos();
  }

  // Función para manejar cambios en el formulario de abonos
  function handleAbonoChange(field, value) {
    setAbonoData((prev) => ({
      ...prev,
      [field]: value,
    }));
  }

  // Función para manejar la subida de imagen
  function handleImagenChange(event) {
    const file = event.target.files[0];
    setAbonoData((prev) => ({
      ...prev,
      imagen: file,
    }));
  }

  // Función para guardar el abono
  async function guardarAbono() {
    if (!abonoData.importe || abonoData.importe <= 0) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "El importe debe ser mayor a 0",
      });
      return;
    }

    // Validar que el importe no exceda el saldo pendiente
    const importeNumerico = parseFloat(abonoData.importe) || 0;
    const saldoNumerico = parseFloat(saldoAbono) || 0;

    if (importeNumerico > saldoNumerico) {
      Swal.fire({
        icon: "error",
        title: "Importe excede el saldo",
        text: `El importe ($${importeNumerico.toFixed(2)}) no puede ser mayor al saldo pendiente ($${saldoNumerico.toFixed(2)})`,
      });
      return;
    }

    if (!abonoData.formaPago) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Debe seleccionar una forma de pago",
      });
      return;
    }

    try {
      const abonoPayload = {
        fecha: abonoData.fechaPago || moment().format("YYYY-MM-DD"),
        importe: abonoData.importe,
        pedidos: selectedPedidoAbono,
        clientes: selectedClienteAbono,
        colaboradores: selectedColaboradorAbono,
        formaPago: abonoData.formaPago,
        concepto: abonoData.concepto,
        observaciones: abonoData.observaciones || "NA",
        validado: "No",
        codigoAgrupado,
      };

      if (abonoData.banco) {
        abonoPayload.bancos = abonoData.banco;
      }

      // Crear el abono
      const responseAbono = await axios.post(URL_ABONOS, abonoPayload, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "application/json",
        },
      });

      // Si hay una imagen seleccionada, subirla al abono recién creado
      if (abonoData.imagen) {
        await subirImagenAbono(responseAbono.data._id, abonoData.imagen);
      }

      // Log de la acción
      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Abono",
          detalle: `Abono de $${abonoData.importe} para pedido ${numero_pedido}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // Recargar los abonos existentes para mostrar el nuevo abono
      const responseAbonos = await axios.get(
        `${URL_ABONOS}Pedido/${selectedPedidoAbono}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      setAbonosExistentes(responseAbonos.data);

      // Limpiar el formulario
      setAbonoData({
        importe: 0,
        formaPago: "",
        concepto: `Abono a Pedido ${numero_pedido}`,
        observaciones: "",
        banco: "",
        fechaPago: moment().format("YYYY-MM-DD"),
        imagen: null,
      });

      Swal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: "Abono creado correctamente",
        timer: 1000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al crear abono:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error al crear el abono",
        footer: `${error.response?.data?.message || error.response?.data?.error || error.message}`,
      });
    }
  }

  // Función para validar un abono
  async function validarAbono(abonoId, validado) {
    if (validado === "Si") {
      try {
        // 1. Obtener datos del abono
        const abono = abonosExistentes.find(a => a._id === abonoId);
        if (!abono) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se encontró el abono seleccionado"
          });
          return;
        }

        // 2. Verificar si importe > saldo del pedido (asegurar comparación numérica)
        const importeNumerico = parseFloat(abono.importe) || 0;
        const saldoNumerico = parseFloat(saldoAbono) || 0;

        if (importeNumerico > saldoNumerico) {
          const excedente = importeNumerico - saldoNumerico;
          
          // 3. Mostrar confirmación
          const resultado = await Swal.fire({
            title: "Abono mayor al saldo",
            html: `El abono de <strong>$${importeNumerico.toFixed(2)}</strong> excede el saldo de <strong>$${saldoNumerico.toFixed(2)}</strong><br>
                   Diferencia: <strong>$${excedente.toFixed(2)}</strong><br><br>
                   ¿Desea convertir los <strong>$${excedente.toFixed(2)}</strong> en un anticipo para el cliente?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, crear anticipo",
            cancelButtonText: "Cancelar validación",
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#dc3545"
          });
          
          if (resultado.isConfirmed) {
            try {
              
              // 4. Actualizar abono al saldo exacto
              await axios.patch(
                `${URL_ABONOS}EditarAbono/${abonoId}`,
                { importe: saldoNumerico },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    "Content-Type": "application/json",
                  },
                }
              );

              // 5. Crear anticipo por diferencia usando el nuevo endpoint
              const anticipoData = {
                fecha: moment().format("YYYY-MM-DD"),
                importe: excedente,
                clientes: selectedClienteAbono,
                formaPago: abono.formaPago || "Transferencia",
                saldo: excedente,
                utilizado: 0,
                bancos: abono.bancos[0]._id,
              };

              await axios.post(`${URL_ANTICIPOS}/fromAbono`, anticipoData, {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  "Content-Type": "application/json",
                },
              });

              // 6. Validar el abono ajustado
              await axios.patch(
                `${URL_ABONOS}Validate/${abonoId}`,
                { validado: "Si" },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    "Content-Type": "application/json",
                  },
                }
              );

              // Actualizar la lista de abonos localmente
              setAbonosExistentes((prev) =>
                prev.map((a) =>
                  a._id === abonoId
                    ? { ...a, validado: "Si", importe: saldoNumerico }
                    : a
                )
              );

              // Log de la acción
              await axios.post(
                URL_LOGS,
                {
                  tipo: "Validar Abono con Anticipo",
                  detalle: `Abono ${abonoId} validado por $${saldoNumerico.toFixed(2)} y anticipo creado por $${excedente.toFixed(2)}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              );

              Swal.fire({
                icon: "success",
                title: "¡Operación completada!",
                html: `<strong>Abono validado:</strong> $${saldoNumerico.toFixed(2)}<br>
                       <strong>Anticipo creado:</strong> $${excedente.toFixed(2)}`,
                timer: 3000,
                showConfirmButton: true,
              });

              actualizarTrasAbono();
            } catch (error) {
              console.error("Error en operación compleja:", error);
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Error al procesar la operación",
                footer: `${error.response?.data?.message || error.response?.data?.error || error.message}`,
              });
            }
        }
        // Si cancela, no hacer nada
        return;
      }

        // Validación normal cuando importe <= saldo
        await axios.patch(
          `${URL_ABONOS}Validate/${abonoId}`,
          { validado: "Si" },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              "Content-Type": "application/json",
            },
          }
        );

        // Actualizar la lista de abonos
        setAbonosExistentes((prev) =>
          prev.map((abono) =>
            abono._id === abonoId ? { ...abono, validado: "Si" } : abono
          )
        );

        Swal.fire({
          icon: "success",
          title: "¡Éxito!",
          text: "Abono validado correctamente",
          timer: 1000,
          showConfirmButton: false,
        });
        actualizarTrasAbono();

      } catch (error) {
        console.error("Error al validar abono:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Error al validar el abono",
          footer: `${error.response?.data?.message || error.response?.data?.error || error.message}`,
        });
      }
    } else {
      // Invalidar abono (lógica original)
      try {
        await axios.patch(
          `${URL_ABONOS}Validate/${abonoId}`,
          { validado: validado },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              "Content-Type": "application/json",
            },
          }
        );

        // Actualizar la lista de abonos
        setAbonosExistentes((prev) =>
          prev.map((abono) =>
            abono._id === abonoId ? { ...abono, validado: validado } : abono
          )
        );

        Swal.fire({
          icon: "success",
          title: "¡Éxito!",
          text: "Abono invalidado correctamente",
          timer: 1000,
          showConfirmButton: false,
        });
        actualizarTrasAbono();
      } catch (error) {
        console.error("Error al invalidar abono:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Error al invalidar el abono",
          footer: `${error.response?.data?.message || error.response?.data?.error || error.message}`,
        });
      }
    }
  }

  // Función para subir imagen a un abono existente
  async function subirImagenAbono(abonoId, file) {
    setValidaBoton(false);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("abono", abonoId);

      const URL_UPFILE = import.meta.env.VITE_URL_UPFILE;

      // Subir imagen usando el endpoint del FileController
      const uploadResponse = await axios.post(
        `${URL_FILEPOST}`,
        formData,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Actualizar el estado local inmediatamente
      setAbonosExistentes((prev) =>
        prev.map((abono) =>
          abono._id === abonoId
            ? {
                ...abono,
                foto: "Si",
                urlFoto: uploadResponse.data.secure_url,
              }
            : abono
        )
      );

      Swal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: "Imagen subida correctamente",
        timer: 1000,
        showConfirmButton: false,
      });

      setValidaBoton(true);
    } catch (error) {
      console.error("Error al subir imagen:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error al subir la imagen",
        footer: `${error.response?.data?.message || error.response?.data?.error || error.message}`,
      });
    }
    setValidaBoton(true);
  }

  // Función para abrir el modal de preview de imagen
  function abrirPreviewImagen(abono) {
    const imagenUrl =
      abono.foto === "Si" && abono.urlFoto ? abono.urlFoto : abono.imagen;
    setImagenPreview(imagenUrl);
    setAbonoImagenSeleccionado(abono);
    toggleImagenPreview();
  }

  // Función para eliminar imagen del abono
  async function eliminarImagenAbono(abonoId) {
    try {
      const URL_DELMEDIA = import.meta.env.VITE_URL_DELMEDIA;

      // Eliminar imagen de Cloudinary
      await axios.delete(`${URL_DELMEDIA}Abonos/${abonoId}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });

      // Actualizar el abono en la base de datos para quitar la referencia a la imagen
      await axios.patch(
        `${URL_ABONOS}EditarAbono/${abonoId}`,
        {
          foto: "No",
          urlFoto: null,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Actualizar la lista de abonos
      setAbonosExistentes((prev) =>
        prev.map((abono) =>
          abono._id === abonoId
            ? { ...abono, foto: "No", urlFoto: null, imagen: null }
            : abono
        )
      );

      // Cerrar el modal
      toggleImagenPreview();

      Swal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: "Imagen eliminada correctamente",
        timer: 1000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al eliminar imagen:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error al eliminar la imagen",
        footer: `${error.response?.data?.message || error.response?.data?.error || error.message}`,
      });
    }
  }
  const handleCreateNewArticuloTalla = (
    idArticulo,
    idColor,
    tallaNombre,
    cantidad,
    precio,
    colores,
    precioEsp = "No"
  ) => {
    if (!cantidad || parseFloat(cantidad) <= 0) return;

    // Buscar la talla completa en el array de tallas
    const tallaCompleta = tallas.find((t) => t.name === tallaNombre);
    if (!tallaCompleta) return;

    // Buscar el color completo en el array de colores del artículo
    const colorCompleto = colores.find((c) => c._id === idColor);
    if (!colorCompleto) return;

    // Buscar el artículo completo para obtener el código y nombre
    const articuloCompleto = articulos.find((a) => a._id === idArticulo);
    if (!articuloCompleto) return;

    // Validar inventario disponible dinámico antes de crear el artículo
    const inventarioDisponible = getInventoryAvailable(idArticulo, idColor, tallaCompleta._id);
    
    if (parseFloat(cantidad) > inventarioDisponible) {
      Swal.fire({
        icon: "error",
        title: "Inventario insuficiente",
        text: `Solo hay ${inventarioDisponible} unidades disponibles. Intentas agregar ${cantidad} unidades.`,
        timer: 4000,
        showConfirmButton: false,
      });
      return;
    }

    // Registrar el uso de inventario ANTES de crear el artículo
    registrarIncrementoInventario(idArticulo, idColor, tallaCompleta._id, parseFloat(cantidad));

    // Crear nuevo registro
    const nuevoArticulo = {
      id: uuidv4(),
      is_active: "Si",
      articulos: idArticulo,
      codigo: `${articuloCompleto.codigo} ${articuloCompleto.nombre}`,
      cantidad: parseFloat(cantidad),
      surtido: 0,
      precio: precio,
      precioOriginal: precio,
      total: parseFloat(cantidad) * precio,
      pendiente_surtir: parseFloat(cantidad),
      colorNombre: colorCompleto.name,
      idColor: idColor,
      tallaNombre: tallaNombre,
      idTalla: tallaCompleta._id,
      colores: colores,
      tallas: articuloCompleto.tallas,
      precioEsp: precioEsp,
    };

    // Agregar el nuevo artículo al array y aplicar ordenamiento
    setArticulosPedido((prev) => {
      const updatedArray = [...prev, nuevoArticulo];
      return sortArticulosPedido(updatedArray);
    });
    
    // Cargar foto del nuevo artículo
    fetchProductPhoto(idArticulo);
    
    ActualizaTotales();
  };

  // Días calendario transcurridos desde la fecha de referencia del pedido.
  // Uses fechaContador if available (resets when pedido is paid off), otherwise falls back to fecha.
  // Se cuenta por día calendario local (no por bloques de 24h) para que la hora a la
  // que se guardó la fecha no recorra el momento del bloqueo.
  const getDiasPedido = (pedido) => {
    if (!pedido) return null;

    const fechaReferencia = pedido.fechaContador || pedido.fecha;
    if (!fechaReferencia) return null;

    let refDia;
    if (
      typeof fechaReferencia === "string" &&
      /^\d{4}-\d{2}-\d{2}$/.test(fechaReferencia)
    ) {
      // Fecha sin hora ('YYYY-MM-DD'): interpretarla como día calendario local y no
      // como medianoche UTC, para evitar el corrimiento de un día por zona horaria
      const [y, m, d] = fechaReferencia.split("-").map(Number);
      refDia = new Date(y, m - 1, d);
    } else {
      const parsed = new Date(fechaReferencia);
      if (isNaN(parsed.getTime())) return null;
      // Un valor en medianoche UTC exacta proviene de una fecha 'YYYY-MM-DD' (así la
      // guarda el backend en fechaContador al crear el pedido): representa un día
      // calendario, no un instante, así que se leen sus componentes en UTC. Los
      // reinicios reales llevan hora y se interpretan en hora local.
      const esMedianocheUTC =
        parsed.getUTCHours() === 0 &&
        parsed.getUTCMinutes() === 0 &&
        parsed.getUTCSeconds() === 0 &&
        parsed.getUTCMilliseconds() === 0;
      refDia = esMedianocheUTC
        ? new Date(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate())
        : new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    }

    const hoy = new Date();
    const hoyDia = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());

    return Math.round((hoyDia.getTime() - refDia.getTime()) / (1000 * 60 * 60 * 24));
  };

  // True si el pedido ya cumplió N días (bloqueo al cumplir 8, advertencia al cumplir 7)
  const isOlderThanDays = (pedido, days = 8) => {
    const dias = getDiasPedido(pedido);
    return dias !== null && dias >= days;
  };

  // Legacy function for backwards compatibility - now checks against 7 days
  const isOlderThanSevenDays = (fechaPedido) => {
    if (!fechaPedido) return false;

    const today = new Date();
    const pedidoDate = new Date(fechaPedido);

    // Calculate difference in milliseconds
    const diffInMs = today.getTime() - pedidoDate.getTime();

    // Convert to days
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    return diffInDays > 7;
  };

  // Function to check if adding items should be blocked (at 8 days - total block)
  const shouldBlockAddingItems = () => {
    // When editing a pedido, use the edit variables
    if (idEdit) {
      // Find the current pedido being edited
      const pedidoEnEdicion = comments.find((p) => p._id === idEdit);
      if (pedidoEnEdicion) {
        // Bloqueo manual: si el pedido fue bloqueado a propósito, no se pueden
        // agregar más piezas (sin liberar las prendas apartadas)
        if (pedidoEnEdicion.bloqueado === "Si") {
          return true;
        }

        // IMPORTANT: Check the ORIGINAL pedido's saldo, not the current edited saldo
        const originalSaldo = parseFloat(pedidoEnEdicion.saldo || 0);

        // Block completely if pedido is >8 days old AND has unpaid balance
        // Uses fechaContador if available (resets when paid), otherwise fecha
        return isOlderThanDays(pedidoEnEdicion, 8) && originalSaldo > 0;
      }
    }
    // For new pedidos, use the regular variables (though this shouldn't apply since new pedidos can't be >8 days old)
    return isOlderThanDays({ fecha, fechaContador: null }, 8) && parseFloat(saldo || 0) > 0;
  };

  // Function to check if pedido should show warning (at 7 days - warning/red state)
  const shouldShowWarning = (pedido) => {
    if (!pedido) return false;
    const pedidoSaldo = parseFloat(pedido.saldo || 0);
    // Show warning if >7 days old AND has unpaid balance
    return isOlderThanDays(pedido, 7) && pedidoSaldo > 0;
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_pedidos ? (
        <div className="card col-12">
          {!AbrirEditar ? (
            <>
              <Row>
                <Col md={8}>
                  {user.pedidos_create ? (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      href="/PedidosCreate"
                    >
                      Nuevo Pedido
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      disabled
                    >
                      Nuevo Pedido
                    </Button>
                  )}
                  <Button
                    size="sm"
                    href="/MenuVentas"
                    className="btn btn-danger"
                    id="botonListado"
                  >
                    Regresar
                  </Button>
                </Col>
                <Col sm={4}>
                  <ButtonGroup id="logoutBoton">
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={PDFTabla}
                    >
                      PDF <i className="far fa-file-pdf"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      onClick={toggleMail}
                      color="info"
                    >
                      eMail <i className="fas fa-at"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="primary"
                      onClick={excel}
                    >
                      Excel <i className="far fa-file-excel"></i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                <ModalHeader toggle={toggleMail}>
                  <h4>Enviar Listado Pedidos</h4>
                </ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Email</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={mailTo}
                    required
                    onChange={(e) => {
                      setMailTo(e.target.value);
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button size="sm" color="success" onClick={enviaMail}>
                    Enviar
                  </Button>
                </ModalFooter>
              </Modal>
              <h3 align="center">Pedidos</h3>
              <div className="row">
                <div className="col-md-8">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                <div className="col-md-4 d-flex flex-row-reverse">
                  <Search
                    onSearch={(value) => {
                      setSearch(value);
                    }}
                  />
                </div>
              </div>
              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha Inicio</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaInicio}
                    required
                    onChange={(e) => {
                      setSelectedFechaInicio(e.target.value);
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha Fin</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaFin}
                    required
                    onChange={(e) => {
                      setSelectedFechaFin(e.target.value);
                    }}
                  />
                </Col>

                <Col md={2}>
                  <Label>Autorizado</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={autorizadoApartado}
                    required
                    onChange={(e) => {
                      setAutorizadoApartado(e.target.value);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>

                <Col md={2}>
                  <Label>Autorizado Surtir</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={autorizadoSurtido}
                    required
                    onChange={(e) => {
                      setAutorizadoSurtido(e.target.value);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>

                <Col md={2}>
                  <Label>Status</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={status}
                    required
                    onChange={(e) => {
                      setStatus(e.target.value);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Abierto">Abierto</option>
                    <option value="Cerrado">Cerrado</option>
                  </Input>
                </Col>
              </Row>
              <br />
              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl"
              >
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tr>
                  <td></td>
                  <td></td>
                  <td style={{ paddingTop: "0px" }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedCliente}
                      onChange={(e) => {
                        setSelectedCliente(e.target.value);
                      }}
                    >
                      {/* value="" y no "0": con "0" el filtro seguia activo y
                          descartaba los pedidos cuyo idCliente no contuviera un 0 */}
                      <option value="">Selecciona</option>
                      {sortedClientes.map((a) => (
                        <option key={a._id} value={a._id}>{a.nombre_comercial}</option>
                      ))}
                    </Input>
                  </td>
                  <td style={{ paddingTop: "0px" }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedColaborador}
                      onChange={(e) => {
                        setSelectedColaborador(e.target.value);
                      }}
                    >
                      <option value="">Selecciona un Vendedor</option>
                      {sortedColaboradores.map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.nombre} {a.apellido}
                        </option>
                      ))}
                    </Input>
                  </td>
                  <td style={{ paddingTop: "0px" }}>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedArea}
                      onChange={(e) => {
                        setSelectedArea(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {sortedAreas.map((a) => {
                        if (a.esTienda == "No") {
                          return <option key={a._id} value={a._id}>{a.name}</option>;
                        }
                      })}
                    </Input>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tbody>
                  {cargandoPedidos && (
                    <tr>
                      <td colSpan="13" className="text-center py-3 text-muted">
                        <Spinner size="sm" /> Cargando pedidos...
                      </td>
                    </tr>
                  )}
                  {commentsData.map((a) => {
                    // if (a.activo == "No") {
                    //   return (
                    //     <tr className="row-cancelled">
                    //       {/* <td>{a.activo}</td> */}
                    //       <td>{a.numero}</td>
                    //       <td>{a.fecha}</td>
                    //       <td>{a.clientes}</td>
                    //       <td>{a.colaboradores}</td>
                    //       <td>{a.areaName}</td>
                    //       <td></td>
                    //       <td></td>
                    //       <td></td>
                    //       <td></td>
                    //       <td>
                    //         <Button
                    //           size="sm"
                    //           className="btn"
                    //           color="danger"
                    //           onClick={(e) =>
                    //             PDFOC(
                    //               a.fecha,
                    //               a.colaboradores,
                    //               a.idClientes,
                    //               a.clientes,
                    //               a.total_cantidad,
                    //               a.total_general,
                    //               a.observaciones,
                    //               a.numero,
                    //               a.impuestos,
                    //               a.comisionFlete,
                    //               a.comisionTDC,
                    //               a._id,
                    //               a.alias,
                    //               a.calle,
                    //               a.numero_ext,
                    //               a.numero_int,
                    //               a.pais,
                    //               a.estado,
                    //               a.ciudad,
                    //               a.delegacion,
                    //               a.colonia,
                    //               a.cp,
                    //               a.RFC,
                    //               a.paqueteria,
                    //               a.area,
                    //               a.codigoClientes,
                    //               a.autorizadoApartado,
                    //               a.autorizadoSurtido,
                    //               a.telefono,
                    //               a.editado,
                    //               a.editPedido,
                    //               a.autorizoApartado,
                    //               a.autorizoSurtido,
                    //               a.descuento,
                    //               a.creado,
                    //               a.fechaHora,
                    //               a.abonos,
                    //               a.saldo
                    //             )
                    //           }
                    //         >
                    //           <i className="far fa-file-pdf"></i>
                    //         </Button>
                    //         {" "}
                    //         <Button
                    //           size="sm"
                    //           className="btn"
                    //           color="success"
                    //           onClick={(e) =>
                    //             PDFOCTicket(
                    //               a.fecha,
                    //               a.colaboradores,
                    //               a.idClientes,
                    //               a.clientes,
                    //               a.total_cantidad,
                    //               a.total_general,
                    //               a.observaciones,
                    //               a.numero,
                    //               a.impuestos,
                    //               a.comisionFlete,
                    //               a.comisionTDC,
                    //               a._id,
                    //               a.alias,
                    //               a.calle,
                    //               a.numero_ext,
                    //               a.numero_int,
                    //               a.pais,
                    //               a.estado,
                    //               a.ciudad,
                    //               a.delegacion,
                    //               a.colonia,
                    //               a.cp,
                    //               a.RFC,
                    //               a.paqueteria,
                    //               a.area,
                    //               a.codigoClientes,
                    //               a.autorizadoApartado,
                    //               a.autorizadoSurtido,
                    //               a.telefono,
                    //               a.editado,
                    //               a.editPedido,
                    //               a.autorizoApartado,
                    //               a.autorizoSurtido,
                    //               a.descuento,
                    //               a.creado,
                    //               a.fechaHora,
                    //               a.abonos,
                    //               a.saldo
                    //             )
                    //           }
                    //         >
                    //           <i className="fas fa-receipt"></i>
                    //         </Button>
                    //         {/* <Button
                    //                 size="sm"
                    //                 className="btn"
                    //                 color="info"
                    //                 onClick={(e) =>
                    //                   PDFOCFoto(
                    //                     a.fecha,
                    //                     a.colaboradores,
                    //                     a.idClientes,
                    //                     a.clientes,
                    //                     a.total_cantidad,
                    //                     a.total_general,
                    //                     a.observaciones,
                    //                     a.numero,
                    //                     a.impuestos,
                    //                     a.comisionFlete,
                    //                     a.comisionTDC,
                    //                     a._id,
                    //                     a.alias,
                    //                     a.calle,
                    //                     a.numero_ext,
                    //                     a.numero_int,
                    //                     a.pais,
                    //                     a.estado,
                    //                     a.ciudad,
                    //                     a.delegacion,
                    //                     a.colonia,
                    //                     a.cp,
                    //                     a.RFC,
                    //                     a.paqueteria,
                    //                     a.area,
                    //                     a.codigoClientes,
                    //                     a.autorizadoApartado,
                    //                     a.autorizadoSurtido,
                    //                     a.telefono,
                    //                     a.editado,
                    //                     a.editPedido,
                    //                     a.autorizoApartado,
                    //                     a.autorizoSurtido,
                    //                     a.descuento,
                    //                     a.creado,
                    //                     a.fechaHora
                    //                   )
                    //                 }
                    //               >
                    //                 <i className="far fa-file-pdf"></i>
                    //               </Button> */}
                    //       </td>
                    //       <td>CANCELADO</td>
                    //       <td></td>
                    //       <td></td>
                    //     </tr>
                    //   );
                    // } else 
                      
                      if (a.autorizadoSurtido == "Si") {
                      return (
                        <tr
                          key={a._id}
                          className={
                            a.status === "Cancelado" || warningIds.has(a._id)
                              ? "row-cancelled"
                              : "row-authorized"
                          }
                        >
                          {/* <td>{a.activo}</td> */}
                          <td>{a.numero}</td>
                          <td>{fmtFecha(a.fecha)}</td>
                          <td>{a.clientes}</td>
                          <td>{a.colaboradores}</td>
                          <td>{a.areaName}</td>
                          <td>
                            {fmtNumber.format(
                              a.total_cantidad
                            )}
                          </td>
                          <td align="right">
                            {fmtCurrency.format(a.total_general)}
                          </td>
                          <td align="right">
                            {fmtCurrency.format(a.abonos || 0)}
                          </td>
                          <td align="right">
                            {fmtCurrency.format(a.saldo || 0)}
                          </td>
                          <td>{fmtFecha(a.fechaCierre)}</td>
                          <td>
                            {user.pedidos_create ? (
                              <div>
                                {a.surtido === "No" &&
                                user.pedidos_autorizar &&
                                a.status === "Abierto" ? (
                                  a.autorizadoApartado === "Si" ? (
                                    <span>
                                      <Button
                                        color="primary"
                                        id="Baja"
                                        onClick={(e) =>
                                          desautorizarApartado(a._id)
                                        }
                                        size="sm"
                                      >
                                        <i className="fas fa-thumbs-up"></i>
                                      </Button>
                                    </span>
                                  ) : (
                                    <span>
                                      <Button
                                        color="danger"
                                        onClick={(e) =>
                                          autorizarApartado(a._id, a.idArea)
                                        }
                                        size="sm"
                                      >
                                        <i className="fas fa-thumbs-down"></i>
                                      </Button>
                                    </span>
                                  )
                                ) : undefined}

                                {a.status === "Abierto" ||
                                (a.status === "Cerrado" &&
                                  user.pedidos_autorizar) ? (
                                  <>
                                    <Button
                                      size="sm"
                                      className="btn"
                                      color="danger"
                                      onClick={(e) =>
                                        PDFOC(
                                          a.fecha,
                                          a.colaboradores,
                                          a.idClientes,
                                          a.clientes,
                                          a.total_cantidad,
                                          a.total_general,
                                          a.observaciones,
                                          a.numero,
                                          a.impuestos,
                                          a.comisionFlete,
                                          a.comisionTDC,
                                          a._id,
                                          a.alias,
                                          a.calle,
                                          a.numero_ext,
                                          a.numero_int,
                                          a.pais,
                                          a.estado,
                                          a.ciudad,
                                          a.delegacion,
                                          a.colonia,
                                          a.cp,
                                          a.RFC,
                                          a.paqueteria,
                                          a.area,
                                          a.codigoClientes,
                                          a.autorizadoApartado,
                                          a.autorizadoSurtido,
                                          a.telefono,
                                          a.editado,
                                          a.editPedido,
                                          a.autorizoApartado,
                                          a.autorizoSurtido,
                                          a.descuento,
                                          a.descuentoImporte,
                                          a.creado,
                                          a.fechaHora,
                                          a.abonos,
                                          a.saldo,
                                          a.status
                                        )
                                      }
                                    >
                                      <i className="far fa-file-pdf"></i>
                                    </Button>
                                    {" "}
                                    <Button
                                      size="sm"
                                      className="btn"
                                      color="success"
                                      onClick={(e) =>
                                        PDFOCTicket(
                                          a.fecha,
                                          a.colaboradores,
                                          a.idClientes,
                                          a.clientes,
                                          a.total_cantidad,
                                          a.total_general,
                                          a.observaciones,
                                          a.numero,
                                          a.impuestos,
                                          a.comisionFlete,
                                          a.comisionTDC,
                                          a._id,
                                          a.alias,
                                          a.calle,
                                          a.numero_ext,
                                          a.numero_int,
                                          a.pais,
                                          a.estado,
                                          a.ciudad,
                                          a.delegacion,
                                          a.colonia,
                                          a.cp,
                                          a.RFC,
                                          a.paqueteria,
                                          a.area,
                                          a.codigoClientes,
                                          a.autorizadoApartado,
                                          a.autorizadoSurtido,
                                          a.telefono,
                                          a.editado,
                                          a.editPedido,
                                          a.autorizoApartado,
                                          a.autorizoSurtido,
                                          a.descuento,
                                          a.descuentoImporte,
                                          a.creado,
                                          a.fechaHora,
                                          a.abonos,
                                          a.saldo,
                                          a.status
                                        )
                                      }
                                    >
                                      <i className="fas fa-receipt"></i>
                                    </Button>
                                    {/* <Button
                                   size="sm"
                                   className="btn"
                                   color="info"
                                   onClick={(e) =>
                                     PDFOCFoto(
                                       a.fecha,
                                       a.colaboradores,
                                       a.idClientes,
                                       a.clientes,
                                       a.total_cantidad,
                                       a.total_general,
                                       a.observaciones,
                                       a.numero,
                                       a.impuestos,
                                       a.comisionFlete,
                                       a.comisionTDC,
                                       a._id,
                                       a.alias,
                                       a.calle,
                                       a.numero_ext,
                                       a.numero_int,
                                       a.pais,
                                       a.estado,
                                       a.ciudad,
                                       a.delegacion,
                                       a.colonia,
                                       a.cp,
                                       a.RFC,
                                       a.paqueteria,
                                       a.area,
                                       a.codigoClientes,
                                       a.autorizadoApartado,
                                       a.autorizadoSurtido,
                                       a.telefono,
                                       a.editado,
                                       a.editPedido,
                                       a.autorizoApartado,
                                       a.autorizoSurtido,
                                       a.descuento,
                                       a.creado,
                                       a.fechaHora
                                     )
                                   }
                                 >
                                   <i className="far fa-file-pdf"></i>
                                 </Button> */}
                                  </>
                                ) : undefined}


                                {a.surtido === "No" &&
                                user.pedidos_autorizar &&
                                a.status === "Abierto" ? (
                                  a.autorizadoApartado === "Si" ? (
                                    a.autorizadoSurtido === "Si" ? (
                                      <span>
                                        <Button
                                          color="primary"
                                          id="Baja"
                                          onClick={(e) =>
                                            desautorizarSurtido(a._id)
                                          }
                                          size="sm"
                                        >
                                          <i className="fas fa-truck"></i>
                                        </Button>
                                      </span>
                                    ) : parseFloat(a.saldo) <= 0 ? (
                                      <span>
                                        <Button
                                          color="danger"
                                          onClick={(e) =>
                                            autorizarSurtido(a._id)
                                          }
                                          size="sm"
                                        >
                                          <i className="fas fa-truck"></i>
                                        </Button>
                                      </span>
                                    ) : null
                                  ) : a.autorizadoSurtido === "Si" ? (
                                    <span>
                                      <Button
                                        color="primary"
                                        id="Baja"
                                        onClick={(e) =>
                                          desautorizarSurtido(a._id)
                                        }
                                        size="sm"
                                        disabled
                                      >
                                        <i className="fas fa-truck"></i>
                                      </Button>
                                    </span>
                                  ) : parseFloat(a.saldo) <= 0 ? (
                                    <span>
                                      <Button
                                        color="danger"
                                        onClick={(e) => autorizarSurtido(a._id)}
                                        size="sm"
                                        disabled
                                      >
                                        <i className="fas fa-truck"></i>
                                      </Button>
                                    </span>
                                  ) : null
                                ) : undefined}

                                {a.surtido === "No" &&
                                user.pedidos_autorizar ? (
                                  <>
                                    <StatusMultiple
                                      idStatus={a._id}
                                      status={a.status}
                                      URL_STATUS={URL_PEDIDOS}
                                      hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                                    />
                                    <BajaMultiple
                                      idStatus={a._id}
                                      is_active={a.activo}
                                      URL_BAJA={URL_PEDIDOS}
                                      hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                                    />
                                  </>
                                ) : undefined}
                              </div>
                            ) : undefined}
                          </td>
                          <td>
                            {a.surtido === "No" ? (
                              a.status === "Abierto" && a.activo === "Si" ? (
                                <div>
                                  <Button
                                    color="info"
                                    id="Editar"
                                    size="sm"
                                    onClick={(e) =>
                                      EditArticulos(
                                        a._id,
                                        a.numero,
                                        a.comisionTDC,
                                        a.comisionFlete,
                                        a.impuestos,
                                        a.subTotal,
                                        a.iva,
                                        a.total_general,
                                        a.total_cantidad,
                                        a.surtido,
                                        a.idArea,
                                        a.clientes,
                                        a.idClientes,
                                        a.fechaModificado,
                                        a.descuento,
                                        a.idColaboradores,
                                        a.idPaqueteria,
                                        a.idArea,
                                        a.observaciones,
                                        a.descuentoImporte
                                      )
                                    }
                                  >
                                    <i className="fas fa-cart-plus"></i>
                                  </Button>
                                  {user.pedidos_bloquear ? (
                                    <Button
                                      size="sm"
                                      className={
                                        a.bloqueado === "Si"
                                          ? "btn btn-success"
                                          : "btn btn-warning"
                                      }
                                      onClick={() =>
                                        toggleBloqueo(
                                          a._id,
                                          a.bloqueado || "No",
                                          a.numero,
                                          a.fecha
                                        )
                                      }
                                      title={
                                        a.bloqueado === "Si"
                                          ? "Desbloquear pedido"
                                          : "Bloquear pedido"
                                      }
                                    >
                                      <i
                                        className={
                                          a.bloqueado === "Si"
                                            ? "fas fa-unlock"
                                            : "fas fa-lock"
                                        }
                                      ></i>
                                    </Button>
                                  ) : undefined}
                                </div>
                              ) : undefined
                            ) : undefined}
                          </td>
                          <td>
                            <Button
                              color="success"
                              size="sm"
                              onClick={() =>
                                abrirModalAbonos(a._id, a.numero, a.idClientes, a.total_general, a.abonos, a.saldo, a.idColaboradores)
                              }
                              title="Agregar Abono"
                            >
                              <i className="fas fa-dollar-sign"></i>
                            </Button>
                          </td>
                          <td>
                            {user.surtidos_create && user.pedidos_autorizar ? (
                              <>
                                <StatusMultipleSurtido
                                  idStatus={a._id}
                                  status={a.surtido}
                                  URL_STATUS={URL_PEDIDOS}
                                  hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                                />
                              </>
                            ) : undefined}

                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => QRGen(a._id, a.numero, a.fecha)}
                            >
                              <i className="fas fa-qrcode"></i>
                            </Button>
                          </td>
                        </tr>
                      );
                    } else {
                      return (
                        <tr
                          key={a._id}
                          className={
                            a.status === "Cancelado" || warningIds.has(a._id)
                              ? "row-cancelled"
                              : "row-default"
                          }
                        >
                          {/* <td>{a.activo}</td> */}
                          <td>{a.numero}</td>
                          <td>{fmtFecha(a.fecha)}</td>
                          <td>{a.clientes}</td>
                          <td>{a.colaboradores}</td>
                          <td>{a.areaName}</td>
                          <td>
                            {fmtNumber.format(
                              a.total_cantidad
                            )}
                          </td>
                          <td align="right">
                            {fmtCurrency.format(a.total_general)}
                          </td>
                          <td align="right">
                            {fmtCurrency.format(a.abonos || 0)}
                          </td>
                          <td align="right">
                            {fmtCurrency.format(a.saldo || 0)}
                          </td>
                          <td>{fmtFecha(a.fechaCierre)}</td>
                          <td>
                            {user.pedidos_create ? (
                              <div>
                                {a.surtido === "No" &&
                                user.pedidos_autorizar &&
                                a.status === "Abierto" ? (
                                  a.autorizadoApartado === "Si" ? (
                                    <span>
                                      <Button
                                        color="primary"
                                        id="Baja"
                                        onClick={(e) =>
                                          desautorizarApartado(a._id)
                                        }
                                        size="sm"
                                      >
                                        <i className="fas fa-thumbs-up"></i>
                                      </Button>
                                    </span>
                                  ) : (
                                    <span>
                                      <Button
                                        color="danger"
                                        onClick={(e) =>
                                          autorizarApartado(a._id, a.idArea)
                                        }
                                        size="sm"
                                      >
                                        <i className="fas fa-thumbs-down"></i>
                                      </Button>
                                    </span>
                                  )
                                ) : undefined}

                                {a.status === "Abierto" ? (
                                  <>
                                    <Button
                                      size="sm"
                                      className="btn"
                                      color="danger"
                                      onClick={(e) =>
                                        PDFOC(
                                          a.fecha,
                                          a.colaboradores,
                                          a.idClientes,
                                          a.clientes,
                                          a.total_cantidad,
                                          a.total_general,
                                          a.observaciones,
                                          a.numero,
                                          a.impuestos,
                                          a.comisionFlete,
                                          a.comisionTDC,
                                          a._id,
                                          a.alias,
                                          a.calle,
                                          a.numero_ext,
                                          a.numero_int,
                                          a.pais,
                                          a.estado,
                                          a.ciudad,
                                          a.delegacion,
                                          a.colonia,
                                          a.cp,
                                          a.RFC,
                                          a.paqueteria,
                                          a.area,
                                          a.codigoClientes,
                                          a.autorizadoApartado,
                                          a.autorizadoSurtido,
                                          a.telefono,
                                          a.editado,
                                          a.editPedido,
                                          a.autorizoApartado,
                                          a.autorizoSurtido,
                                          a.descuento,
                                          a.descuentoImporte,
                                          a.creado,
                                          a.fechaHora,
                                          a.abonos,
                                          a.saldo,
                                          a.status
                                        )
                                      }
                                    >
                                      <i className="far fa-file-pdf"></i>
                                    </Button>
                                  </>
                                ) : undefined}


                                {a.surtido === "No" &&
                                user.pedidos_autorizar &&
                                a.status === "Abierto" ? (
                                  a.autorizadoApartado === "Si" ? (
                                    a.autorizadoSurtido === "Si" ? (
                                      <span>
                                        <Button
                                          color="primary"
                                          id="Baja"
                                          onClick={(e) =>
                                            desautorizarSurtido(a._id)
                                          }
                                          size="sm"
                                        >
                                          <i className="fas fa-truck"></i>
                                        </Button>
                                      </span>
                                    ) : parseFloat(a.saldo) <= 0 ? (
                                      <span>
                                        <Button
                                          color="danger"
                                          onClick={(e) =>
                                            autorizarSurtido(a._id)
                                          }
                                          size="sm"
                                        >
                                          <i className="fas fa-truck"></i>
                                        </Button>
                                      </span>
                                    ) : null
                                  ) : a.autorizadoSurtido === "Si" ? (
                                    <span>
                                      <Button
                                        color="primary"
                                        id="Baja"
                                        onClick={(e) =>
                                          desautorizarSurtido(a._id)
                                        }
                                        size="sm"
                                        disabled
                                      >
                                        <i className="fas fa-truck"></i>
                                      </Button>
                                    </span>
                                  ) : parseFloat(a.saldo) <= 0 ? (
                                    <span>
                                      <Button
                                        color="danger"
                                        onClick={(e) => autorizarSurtido(a._id)}
                                        size="sm"
                                        disabled
                                      >
                                        <i className="fas fa-truck"></i>
                                      </Button>
                                    </span>
                                  ) : null
                                ) : undefined}

                                {a.surtido === "No" &&
                                user.pedidos_autorizar ? (
                                  <>
                                    <StatusMultiple
                                      idStatus={a._id}
                                      status={a.status}
                                      URL_STATUS={URL_PEDIDOS}
                                      hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                                    />
                                    <BajaMultiple
                                      idStatus={a._id}
                                      is_active={a.activo}
                                      URL_BAJA={URL_PEDIDOS}
                                      hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                                    />
                                  </>
                                ) : undefined}
                              </div>
                            ) : undefined}
                          </td>
                          <td>
                            {a.surtido === "No" ? (
                              a.status === "Abierto" && a.activo === "Si" ? (
                                <div>
                                  <Button
                                    color="info"
                                    id="Editar"
                                    size="sm"
                                    onClick={(e) =>
                                      EditArticulos(
                                        a._id,
                                        a.numero,
                                        a.comisionTDC,
                                        a.comisionFlete,
                                        a.impuestos,
                                        a.subTotal,
                                        a.iva,
                                        a.total_general,
                                        a.total_cantidad,
                                        a.surtido,
                                        a.idArea,
                                        a.clientes,
                                        a.idClientes,
                                        a.fechaModificado,
                                        a.descuento,
                                        a.idColaboradores,
                                        a.idPaqueteria,
                                        a.idArea,
                                        a.observaciones,
                                        a.descuentoImporte
                                      )
                                    }
                                  >
                                    <i className="fas fa-cart-plus"></i>
                                  </Button>
                                  {user.pedidos_bloquear ? (
                                    <Button
                                      size="sm"
                                      className={
                                        a.bloqueado === "Si"
                                          ? "btn btn-success"
                                          : "btn btn-warning"
                                      }
                                      onClick={() =>
                                        toggleBloqueo(
                                          a._id,
                                          a.bloqueado || "No",
                                          a.numero,
                                          a.fecha
                                        )
                                      }
                                      title={
                                        a.bloqueado === "Si"
                                          ? "Desbloquear pedido"
                                          : "Bloquear pedido"
                                      }
                                    >
                                      <i
                                        className={
                                          a.bloqueado === "Si"
                                            ? "fas fa-unlock"
                                            : "fas fa-lock"
                                        }
                                      ></i>
                                    </Button>
                                  ) : undefined}
                                </div>
                              ) : undefined
                            ) : undefined}
                          </td>
                          <td>
                            <Button
                              color="success"
                              size="sm"
                              onClick={() =>
                                abrirModalAbonos(a._id, a.numero, a.idClientes, a.total_general, a.abonos, a.saldo, a.idColaboradores)
                              }
                              title="Agregar Abono"
                            >
                              <i className="fas fa-dollar-sign"></i>
                            </Button>
                          </td>
                          <td>
                            {user.surtidos_create && user.pedidos_autorizar ? (
                              <StatusMultipleSurtido
                                idStatus={a._id}
                                status={a.surtido}
                                URL_STATUS={URL_PEDIDOS}
                                hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                              />
                            ) : undefined}

                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => QRGen(a._id, a.numero, a.fecha)}
                            >
                              <i className="fas fa-qrcode"></i>
                            </Button>
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </Table>
              <div className="col-md-6">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
            </>
          ) : (
            <div className="card container col-md-12">
              <h4>
                Editar Pedido {numero_pedido}
                {cargandoArticulosPedido && (
                  <span className="text-info ml-2">
                    <i className="fas fa-spinner fa-spin"></i> Cargando artículos...
                  </span>
                )}
                {!cargandoArticulosPedido && cargandoInventarios && (
                  <span className="text-warning ml-2">
                    <i className="fas fa-spinner fa-spin"></i> Cargando inventarios...
                  </span>
                )}
              </h4>
              <h4>Cliente: {nombreClienteEdit}</h4>
              {(!inventarios || inventarios.length === 0) && !cargandoInventarios && (
                <div className="alert alert-warning">
                  <i className="fas fa-exclamation-triangle"></i>
                  Los inventarios no están cargados. No se pueden modificar cantidades.
                </div>
              )}
              <Form onSubmit={(e) => e.preventDefault()}>
                <Row>
                  <Col md={1}>
                    <Label>TDC</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      placeholder="Ingresa una cantidad"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={comisionTDC}
                      className={`form-control`}
                      onValueChange={(value) => {
                        jalaComisionTDC(value);
                      }}
                    />
                  </Col>
                  <Col md={1}>
                    <Label>Flete</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      placeholder="Ingresa una cantidad"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={comisionFlete}
                      className={`form-control`}
                      onValueChange={(value) => {
                        jalaComisionFlete(value);
                      }}
                    />
                  </Col>
                  <Col md={1}>
                    <Label>Impuestos %</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={selectedImpuesto}
                      onChange={(e) => {
                        calculaImpuesto(e.target.value);
                      }}
                    />
                  </Col>

                  <Col md={1}>
                    <Label>Descuento %</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={descuentoEdit}
                      onChange={(e) => setDescuentoEdit(e.target.value)}
                      onBlur={(e) => calculaDescuento(e.target.value)}
                    />
                  </Col>
                  <Col md={1}>
                    <Label>Descuento $</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      value={descuentoImporteEdit}
                      onChange={(e) => setDescuentoImporteEdit(e.target.value)}
                      onBlur={(e) => calculaDescuentoImporteEdit(e.target.value)}
                    />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={3}>
                    <Label>Vendedor</Label>
                    <Input
                      type="select"
                      value={selectedColaboradorEdit}
                      onChange={(e) => {
                        setSelectedColaboradorEdit(e.target.value);
                      }}
                    >
                      <option value="">Selecciona un Vendedor</option>
                      {sortedColaboradores.map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.nombre} {a.apellido}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label>Paquetería</Label>
                    <Input
                      type="select"
                      value={paqueteria}
                      onChange={(e) => {
                        setPaqueteria(e.target.value);
                      }}
                    >
                      <option value="">Selecciona Paquetería</option>
                      {sortedPaqueterias.map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label>Surtir de Almacén</Label>
                    <Input
                      type="select"
                      value={selectedAreaEdit}
                      onChange={(e) => {
                        setSelectedAreaEdit(e.target.value);
                      }}
                    >
                      <option value="">Selecciona Almacén</option>
                      {sortedAreas.map((a) => {
                          if (a.esTienda === "No") {
                            return (
                              <option key={a._id} value={a._id}>
                                {a.name}
                              </option>
                            );
                          }
                        })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label>Observaciones</Label>
                    <Input
                      type="text"
                      rows="2"
                      placeholder="Observaciones del pedido"
                      value={observaciones}
                      onChange={(e) => {
                        setObservaciones(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={1}>
                    <Label>Sub Total</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      placeholder="Ingresa una cantidad"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={subTotal}
                      disabled
                      className={`form-control`}
                    />
                  </Col>

                  <Col md={1}>
                    <Label>IVA</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      placeholder="Ingresa una cantidad"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={iva}
                      disabled
                      className={`form-control`}
                    />
                  </Col>

                  <Col md={1}>
                    <Label>Total</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      placeholder="Ingresa una cantidad"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={total_general_edit}
                      disabled
                      className={`form-control`}
                    />
                  </Col>

                  <Col md={1}>
                    <Label>Piezas</Label>
                    <Input
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Piezas"
                      value={total_cantidad_edit}
                      required
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Label>Saldo</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      placeholder="Saldo"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={saldoEdit}
                      disabled
                      className={`form-control`}
                    />
                  </Col>

                  <Col md={1}>
                    <Label></Label>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={(e) => toggleCambiaPrecio()}
                    >
                      Cambiar Precio <i className="fas fa-dollar-sign"></i>
                    </Button>
                  </Col>
                </Row>
                <br />
                {/* Agregar mas articulos */}
                {shouldBlockAddingItems() && (
                  (() => {
                    const pedidoEnEdicion = idEdit
                      ? comments.find((p) => p._id === idEdit)
                      : null;
                    // Bloqueo manual: mensaje distinto al de los 8 días
                    if (pedidoEnEdicion?.bloqueado === "Si") {
                      return (
                        <div className="alert alert-danger" role="alert">
                          <i className="fas fa-ban"></i>
                          <strong> BLOQUEADO:</strong> Este pedido fue bloqueado manualmente.
                          No se pueden agregar más artículos. Las prendas siguen apartadas.
                        </div>
                      );
                    }
                    return (
                      <div className="alert alert-danger" role="alert">
                        <i className="fas fa-ban"></i>
                        <strong> BLOQUEADO:</strong> Este pedido tiene 8 días o más con saldo pendiente de ${parseFloat(pedidoEnEdicion?.saldo ?? saldo ?? 0).toFixed(2)}.
                        No se pueden agregar más artículos hasta que se liquide completamente el pedido.
                      </div>
                    );
                  })()
                )}
                <h4 className="text-dark">
                  <b>Agregar Caja</b>
                </h4>
                <Row className="">
                  <Col md={1}>
                    <Label className="mr-sm-2">Escanea el QR</Label>
                  </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">Selecciona</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Foto</Label>
                  </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">Articulo</Label>
                  </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">Disponible</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Cajas</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Precio</Label>
                  </Col>
                  <Col md={1}>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={1}>
                    <Input
                      name="scannerInput"
                      type="text"
                      placeholder="Escanear código"
                      value={scannerInput}
                      onChange={(e) => handleScannerInputChange(e.target.value)}
                      onKeyDown={handleScannerKeyDown}
                    />
                  </Col>
                  <Col md={2}>
                    <Autocomplete
                      size="small"
                      value={inputArticulos[0]?.articulosNombre || ""}
                      onChange={(event, selectedArticulo) => {
                        BuscaArticuloProporcion2(
                          inputArticulos[0]?.id || "template",
                          selectedArticulo
                        );
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option?.junta || ""}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props} key={option._id}>
                          {option.codigo} {option.nombre}
                        </li>
                      )}
                    />
                  </Col>
                  <Col md={1}>
                    {/* Contenedor de foto del producto */}
                    {inputArticulos[0]?.articulos && (
                      <div style={{
                        minHeight: '30px',
                        border: '1px solid #ccc',
                        height: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '10px',
                        width: '60px'
                      }}>
                        {loadingPhotos[inputArticulos[0].articulos] ? (
                          <div style={{ fontSize: '10px', color: '#666' }}>Cargando...</div>
                        ) : (
                          <img
                            src={productPhotos[inputArticulos[0].articulos]
                              ? productPhotos[inputArticulos[0].articulos]
                              : "/sinImagen.png"
                            }
                            alt="Producto"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              transformOrigin: 'center'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.transform = 'scale(5)';
                              e.target.style.zIndex = '9999';
                              e.target.style.position = 'relative';
                              e.target.style.boxShadow = '0 4px 15px rgba(0,123,255,0.4)';
                              e.target.style.objectFit = 'contain';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.transform = 'scale(1)';
                              e.target.style.zIndex = '1';
                              e.target.style.position = 'static';
                              e.target.style.boxShadow = 'none';
                              e.target.style.objectFit = 'cover';
                            }}
                          />
                        )}
                      </div>
                    )}
                  </Col>
                  <Col md={2}>
                    <Input
                      name="articulosNombre"
                      type="string"
                      placeholder="Articulo"
                      value={inputArticulos[0]?.articulosNombre || ""}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      type="text"
                      disabled
                      style={{ fontSize: "11px", padding: "4px" }}
                      value={
                        inputArticulos[0]?.articulos
                          ? (() => {
                              // Get all inventory items for this article
                              const inventoryItems = inventarios.filter((a) =>
                                String(a.idArticulo) === String(inputArticulos[0].articulos)
                              );

                              if (inventoryItems.length === 0) return "Sin stock";

                              // Group by color and create color: size|quantity pairs
                              const colorGroups = inventoryItems.reduce((acc, item) => {
                                if (item.disponible > 0) {
                                  if (!acc[item.color]) {
                                    acc[item.color] = [];
                                  }
                                  acc[item.color].push(`${item.talla}|${item.disponible}`);
                                }
                                return acc;
                              }, {});

                              // Format as "Color1: S|3,M|6; Color2: S|2,M|4"
                              const colorStrings = Object.entries(colorGroups)
                                .map(([color, sizes]) => `${color}: ${sizes.join(',')}`)
                                .join('; ');

                              return colorStrings || "Sin stock";
                            })()
                          : ""
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      name="cajas"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cajas"
                      value={inputArticulos[0]?.cajas || ""}
                      onChange={(event) =>
                        handleChangeInputProporcion(
                          inputArticulos[0]?.id || "template",
                          event
                        )
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <PriceSelector
                      articulo={articulos.find(a => a._id === inputArticulos[0]?.articulos)}
                      currentPrice={inputArticulos[0]?.precio || 0}
                      onPriceChange={(newPrice) => {
                        const event = { target: { name: 'precio', value: newPrice } };
                        handleChangeInputProporcion(
                          inputArticulos[0]?.id || "template",
                          event
                        );
                      }}
                      disabled={!user.cambiaPrecios && !cambiarPrecio && inputArticulos[0]?.precioEsp !== "Si"}
                      itemId={inputArticulos[0]?.id}
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="success"
                      disabled={
                        !inputArticulos[0]?.articulos ||
                        !inputArticulos[0]?.cajas ||
                        !inputArticulos[0]?.precio ||
                        shouldBlockAddingItems()
                      }
                      title={
                        shouldBlockAddingItems()
                          ? "No se pueden agregar piezas: pedido vencido con saldo pendiente"
                          : ""
                      }
                      onClick={() =>
                        agregarProporcion(
                          inputArticulos[0]?.articulos,
                          inputArticulos[0]?.articulosNombre,
                          inputArticulos[0]?.precio,
                          inputArticulos[0]?.cajas,
                          inputArticulos[0]?.colores,
                          inputArticulos[0]?.tallas,
                          inputArticulos[0]?.precioEsp
                        )
                      }
                      tabindex="-1"
                    >
                      Agregar
                    </Button>
                  </Col>
                </Row>
                <h4 className="text-dark">
                  <b>Agregar Pieza</b>
                </h4>
                <Row className="">
                  <Col md={1}>
                    <Label className="mr-sm-2">QR</Label>
                  </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">Selecciona</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Foto</Label>
                  </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">Articulo</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Color</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Talla</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Disponible</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Cantidad</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Precio</Label>
                  </Col>
                  <Col md={1}>
                  </Col>
                </Row>
                <Row>
                  <Col md={1}>
                    <Input
                      name="articulos"
                      type="string"
                      value={manualInput.articulos}
                      onChange={(event) => {
                        buscarArticuloSingular(manualInput.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={2}>
                    <Autocomplete
                      size="small"
                      value={manualInput?.articulosNombre || ""}
                      onChange={(event, selectedArticulo) => {
                        handleManualArticuloChange(selectedArticulo);
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option?.junta || ""}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props} key={option._id}>
                          {option.codigo} {option.nombre}
                        </li>
                      )}
                    />
                  </Col>
                  <Col md={1}>
                    {/* Contenedor de foto del producto */}
                    {manualInput?.articulos && (
                      <div style={{
                        minHeight: '30px',
                        border: '1px solid #ccc',
                        height: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '10px',
                        width: '60px'
                      }}>
                        {loadingPhotos[manualInput.articulos] ? (
                          <div style={{ fontSize: '10px', color: '#666' }}>Cargando...</div>
                        ) : (
                          <img
                            src={productPhotos[manualInput.articulos]
                              ? productPhotos[manualInput.articulos]
                              : "/sinImagen.png"
                            }
                            alt="Producto"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              transformOrigin: 'center'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.transform = 'scale(5)';
                              e.target.style.zIndex = '9999';
                              e.target.style.position = 'relative';
                              e.target.style.boxShadow = '0 4px 15px rgba(0,123,255,0.4)';
                              e.target.style.objectFit = 'contain';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.transform = 'scale(1)';
                              e.target.style.zIndex = '1';
                              e.target.style.position = 'static';
                              e.target.style.boxShadow = 'none';
                              e.target.style.objectFit = 'cover';
                            }}
                          />
                        )}
                      </div>
                    )}
                  </Col>
                  <Col md={2}>
                    <Input
                      type="text"
                      value={manualInput?.articulosNombre || ""}
                      disabled
                      style={{ fontSize: "10px" }}
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      name="idColor"
                      type="select"
                      value={manualInput?.idColor || ""}
                      onChange={handleManualInputChange}
                    >
                      <option value="">Selecciona Color</option>
                      {manualInput?.colores?.map((color) => (
                        <option key={color._id} value={color._id}>
                          {color.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      name="idTalla"
                      type="select"
                      value={manualInput.idTalla || ""}
                      onChange={handleManualInputChange}
                    >
                      <option value="">Selecciona Talla</option>
                      {manualInput.tallas &&
                        manualInput.tallas.map((talla) => (
                          <option key={talla._id} value={talla._id}>
                            {talla.name}
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      type="text"
                      disabled
                      style={{ fontSize: "9px", padding: "2px" }}
                      value={
                        manualInput?.articulos && manualInput?.idColor
                          ? (() => {
                              // Get all inventory items for this article and color
                              const inventoryItems = inventarios.filter((a) =>
                                String(a.idArticulo) === String(manualInput.articulos) &&
                                String(a.idColor) === String(manualInput.idColor)
                              );

                              if (inventoryItems.length === 0) return "Sin stock";

                              // Create size|quantity pairs
                              const sizeQuantities = inventoryItems
                                .filter(item => item.disponible > 0) // Only show sizes with stock
                                .map(item => `${item.talla}|${item.disponible}`)
                                .join(', ');

                              return sizeQuantities || "Sin stock";
                            })()
                          : ""
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={manualInput?.cantidad || 0}
                      disabled={!manualInput?.idColor || !manualInput?.idTalla}
                      onChange={handleManualInputChange}
                    />
                  </Col>
                  <Col md={1}>
                    <PriceSelector
                      articulo={articulos.find(a => a._id === manualInput?.articulos)}
                      currentPrice={manualInput?.precio || 0}
                      onPriceChange={(newPrice) => {
                        setManualInput((prev) => ({
                          ...prev,
                          precio: newPrice,
                          total: newPrice * (prev.cantidad || 0),
                        }));
                      }}
                      disabled={!user.cambiaPrecios && !cambiarPrecio && manualInput?.precioEsp !== "Si"}
                      itemId="manual-input"
                    />
                  </Col>
                  <Col md={1}>
                    <Button
                      size="sm"
                      className="btn"
                      color="success"
                      onClick={handleManualAdd}
                      disabled={
                        !manualInput?.articulosNombre ||
                        !manualInput?.idColor ||
                        !manualInput?.idTalla ||
                        !manualInput?.cantidad ||
                        cargandoArticulosPedido ||
                        cargandoInventarios ||
                        (!inventarios || inventarios.length === 0) ||
                        shouldBlockAddingItems()
                      }
                      title={
                        shouldBlockAddingItems()
                          ? "No se pueden agregar piezas: pedido vencido con saldo pendiente"
                          : ""
                      }
                      tabindex="-1"
                    >
                      Agregar
                    </Button>
                  </Col>
                </Row>
                {/* Individual Items Table - Each input field as separate row */}
                <div className="mb-4">
                  <h4 className="text-dark mb-3">
                    <b>Artículos del Pedido </b>
                  </h4>
                  <Table striped bordered responsive size="sm">
                    <thead>
                      <tr>
                        <th>Artículo</th>
                        <th>Color</th>
                        <th>Talla</th>
                        <th>Cantidad</th>
                        <th>Disponible</th>
                        <th>Surtido</th>
                        <th>Pendiente</th>
                        <th>Precio</th>
                        <th>Total</th>
                        <th>Foto</th>
                        <th>Fecha Creación</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Existing articles from database */}
                      {articulosPedido.map((item) => (
                        <tr
                          key={item.id}
                          className={
                            item.is_active === "No" ? "row-cancelled" : ""
                          }
                        >
                          <td>
                            <Input
                              type="text"
                              value={item.codigo}
                              disabled
                              size="sm"
                            />
                          </td>
                          <td>
                            <Input
                              name="idColor"
                              type="select"
                              value={item.idColor}
                              onChange={(event) =>
                                handleChangeInputExistentes(item.id, event)
                              }
                              disabled={
                                item.surtido > 0 || item.is_active === "No" || !canCancelItem(item.createdAt)
                              }
                              size="sm"
                            >
                              <option value="">Selecciona</option>
                              {item.colores?.map((color) => (
                                <option key={color._id} value={color._id}>
                                  {color.name}
                                </option>
                              ))}
                            </Input>
                          </td>
                          <td>
                            <Input
                              name="idTalla"
                              type="select"
                              value={item.idTalla}
                              onChange={(event) =>
                                handleChangeInputExistentes(item.id, event)
                              }
                              disabled={
                                item.surtido > 0 || item.is_active === "No" || !canCancelItem(item.createdAt)
                              }
                              size="sm"
                            >
                              <option value="">Selecciona</option>
                              {item.tallas?.map((talla) => (
                                <option key={talla._id} value={talla._id}>
                                  {talla.name}
                                </option>
                              ))}
                            </Input>
                          </td>
                          <td>
                            <Input
                              name="cantidad"
                              type="number"
                              min={item.surtido || 0}
                              value={item.cantidad}
                              disabled={
                                item.is_active === "No" ||
                                !canEditItem(item.createdAt) ||
                                cargandoArticulosPedido ||
                                cargandoInventarios ||
                                (!inventarios || inventarios.length === 0)
                              }
                              onChange={(event) =>
                                handleChangeInputCantidadExistentes(
                                  item.id,
                                  event
                                )
                              }
                              size="sm"
                              style={{ width: "80px" }}
                            />
                          </td>
                          <td>
                            <div
                              style={{
                                padding: "5px",
                                textAlign: "center",
                                backgroundColor: getInventoryAvailable(item.articulos, item.idColor, item.idTalla, item.id) > 0 ? "#d4edda" : "#f8d7da",
                                color: getInventoryAvailable(item.articulos, item.idColor, item.idTalla, item.id) > 0 ? "#155724" : "#721c24",
                                borderRadius: "3px",
                                fontSize: "12px",
                                fontWeight: "bold"
                              }}
                            >
                              {getInventoryAvailable(item.articulos, item.idColor, item.idTalla, item.id)}
                            </div>
                          </td>
                          <td>
                            <Input
                              type="number"
                              value={item.surtido || 0}
                              disabled
                              size="sm"
                              style={{ width: "70px" }}
                            />
                          </td>
                          <td>
                            <Input
                              type="number"
                              value={item.pendiente_surtir || 0}
                              disabled
                              size="sm"
                              style={{ width: "70px" }}
                            />
                          </td>
                          <td>
                            <PriceSelector
                              articulo={articulos.find(a => a._id === item.articulos)}
                              currentPrice={item.precio}
                              onPriceChange={(newPrice) =>
                                handleChangeInputExistentesPrecio(item.id, newPrice)
                              }
                              disabled={
                                item.surtido > 0 ||
                                (!user.cambiaPrecios && !cambiarPrecio && item.precioEsp !== "Si") ||
                                item.is_active == "No" ||
                                !canEditItem(item.createdAt)
                              }
                              itemId={item.id}
                            />
                          </td>
                          <td>
                            <Input
                              type="number"
                              value={item.total}
                              disabled
                              size="sm"
                              style={{ width: "100px" }}
                            />
                          </td>
                          <td>
                            {/* Columna de foto del producto */}
                            <div style={{
                              minHeight: '30px',
                              border: '1px solid #ccc',
                              height: '40px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '60px'
                            }}>
                              {loadingPhotos[item.articulos] ? (
                                <div style={{ fontSize: '10px', color: '#666' }}>Cargando...</div>
                              ) : (
                                <img
                                  src={productPhotos[item.articulos]
                                    ? productPhotos[item.articulos]
                                    : "/sinImagen.png"
                                  }
                                  alt="Producto"
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    transformOrigin: 'center'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.transform = 'scale(5)';
                                    e.target.style.zIndex = '9999';
                                    e.target.style.position = 'relative';
                                    e.target.style.boxShadow = '0 4px 15px rgba(0,123,255,0.4)';
                                    e.target.style.objectFit = 'contain';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.transform = 'scale(1)';
                                    e.target.style.zIndex = '1';
                                    e.target.style.position = 'static';
                                    e.target.style.boxShadow = 'none';
                                    e.target.style.objectFit = 'cover';
                                  }}
                                />
                              )}
                            </div>
                          </td>
                          <td>
                            <small>{formatCreatedDate(item.createdAt)}</small>
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                item.is_active === "Si"
                                  ? "badge-success"
                                  : "badge-danger"
                              }`}
                            >
                              {item.is_active === "Si" ? "Activo" : "Inactivo"}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex">

                              {/* Cancel button - show if within 24 hours OR can be authorized */}
                              {item.surtido === 0 && item.is_active === "Si" && (
                                <Button
                                  size="sm"
                                  color={needsAuthorizationToCancel(item.createdAt) ? "danger" : "warning"}
                                  onClick={() => handleCancelarArticulo(item.id)}
                                  title={
                                    needsAuthorizationToCancel(item.createdAt)
                                      ? "Cancelar (requiere autorización)"
                                      : "Cancelar (disponible por 24h)"
                                  }
                                >
                                  <i className="fas fa-times"></i>
                                  {needsAuthorizationToCancel(item.createdAt) && (
                                    <i className="fas fa-lock" style={{ marginLeft: "2px", fontSize: "8px" }}></i>
                                  )}
                                </Button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}

                      {/* New articles being added */}
                      {inputFields.map((item) => (
                        <tr key={item.id} className="table-info">
                          <td>
                            <Input
                              type="text"
                              value={item.articulosNombre}
                              disabled
                              size="sm"
                            />
                          </td>
                          <td>
                            <Input
                              type="text"
                              value={item.colorNombre}
                              disabled
                              size="sm"
                            />
                          </td>
                          <td>
                            <Input
                              type="text"
                              value={item.tallaNombre}
                              disabled
                              size="sm"
                            />
                          </td>
                          <td>
                            <Input
                              name="cantidad"
                              type="number"
                              min="0"
                              value={item.cantidad}
                              onChange={(event) =>
                                handleChangeInputCantidad(item.id, event)
                              }
                              size="sm"
                              style={{ width: "80px" }}
                            />
                          </td>
                          <td>
                            <div
                              style={{
                                padding: "5px",
                                textAlign: "center",
                                backgroundColor: getInventoryAvailable(item.articulos, item.idColor, item.idTalla) > 0 ? "#d4edda" : "#f8d7da",
                                color: getInventoryAvailable(item.articulos, item.idColor, item.idTalla) > 0 ? "#155724" : "#721c24",
                                borderRadius: "3px",
                                fontSize: "12px",
                                fontWeight: "bold"
                              }}
                            >
                              {getInventoryAvailable(item.articulos, item.idColor, item.idTalla)}
                            </div>
                          </td>
                          <td>
                            <Input
                              type="number"
                              value={0}
                              disabled
                              size="sm"
                              style={{ width: "70px" }}
                            />
                          </td>
                          <td>
                            <Input
                              type="number"
                              value={item.cantidad}
                              disabled
                              size="sm"
                              style={{ width: "70px" }}
                            />
                          </td>
                          <td>
                            <PriceSelector
                              articulo={articulos.find(a => a._id === item.articulos)}
                              currentPrice={item.precio}
                              onPriceChange={(newPrice) =>
                                handleChangeInputPrecio(item.id, newPrice)
                              }
                              disabled={false}
                              itemId={item.id}
                            />
                          </td>
                          <td>
                            <Input
                              type="number"
                              value={item.total}
                              disabled
                              size="sm"
                              style={{ width: "100px" }}
                            />
                          </td>
                          <td>
                            {/* Columna de foto del producto para artículos nuevos */}
                            <div style={{
                              minHeight: '30px',
                              border: '1px solid #ccc',
                              height: '40px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '60px'
                            }}>
                              {loadingPhotos[item.articulos] ? (
                                <div style={{ fontSize: '10px', color: '#666' }}>Cargando...</div>
                              ) : (
                                <img
                                  src={productPhotos[item.articulos]
                                    ? productPhotos[item.articulos]
                                    : "/sinImagen.png"
                                  }
                                  alt="Producto"
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    transformOrigin: 'center'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.transform = 'scale(5)';
                                    e.target.style.zIndex = '9999';
                                    e.target.style.position = 'relative';
                                    e.target.style.boxShadow = '0 4px 15px rgba(0,123,255,0.4)';
                                    e.target.style.objectFit = 'contain';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.transform = 'scale(1)';
                                    e.target.style.zIndex = '1';
                                    e.target.style.position = 'static';
                                    e.target.style.boxShadow = 'none';
                                    e.target.style.objectFit = 'cover';
                                  }}
                                />
                              )}
                            </div>
                          </td>
                          <td>
                            <small className="text-info">Nuevo</small>
                          </td>
                          <td>
                            <span className="badge badge-info">Nuevo</span>
                          </td>
                          <td>
                            <Button
                              size="sm"
                              color="danger"
                              onClick={() => removeInputField(item.id)}
                              title="Eliminar"
                            >
                              <i className="fas fa-trash"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                {validaBoton && !cargandoInventarios && !cargandoArticulosPedido && inventarios && inventarios.length > 0 ? (
                  <Button type="button" className="btn btn-success" onClick={savePedido}>
                    Guardar
                  </Button>
                ) : (
                  <Button type="button" className="btn btn-success" disabled>
                    {cargandoArticulosPedido ? "Cargando artículos..." : cargandoInventarios ? "Cargando inventarios..." : "Guardar"}
                  </Button>
                )}
                <Button
                  onClick={(e) => setAbrirEditar(false)}
                  className="btn btn-danger"
                  id="botonListado"
                >
                  Regresar
                </Button>
              </Form>
            </div>
          )}
        </div>
      ) : undefined}
      <br />


      <Modal size="sm" isOpen={modalCambiaPrecio} toggle={toggleCambiaPrecio}>
        <ModalHeader toggle={toggleCambiaPrecio}>
          <h4>Autorizar Cambio de Precio</h4>
        </ModalHeader>
        <ModalBody>
          <Input
            bsSize="sm"
            type="password"
            placeholder="Password"
            value={password}
            required
            onChange={(event) => setPassword(event.target.value)}
          />
          <br />
          <Row>
            <Col>
              <Button
                type="submit"
                className="btn btn-success"
                onClick={(e) => autorizaCambio()}
              >
                Autorizar
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      {/* Modal para autorizar cancelar prendas */}
      <Modal size="sm" isOpen={modalCancelarPrendas} toggle={toggleCancelarPrendas}>
        <ModalHeader toggle={toggleCancelarPrendas}>
          <h4>Autorizar Cancelar Prendas</h4>
        </ModalHeader>
        <ModalBody>
          <p className="text-warning">
            <i className="fas fa-exclamation-triangle"></i> Esta prenda fue agregada hace más de 24 horas.
            Se requiere autorización para cancelarla.
          </p>
          <Input
            bsSize="sm"
            type="password"
            placeholder="Password"
            value={passwordCancelar}
            required
            onChange={(event) => setPasswordCancelar(event.target.value)}
          />
          <br />
          <Row>
            <Col>
              <Button
                type="submit"
                className="btn btn-success"
                onClick={() => autorizaCancelarPrendas()}
              >
                Autorizar
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      {/* <Modal size="sm" isOpen={modalNoDisponible} toggle={toggleNoDisponible}>
        <ModalHeader toggle={toggleNoDisponible}>
          <h4>No hay Inventario Disponible</h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <tr>
              <th>Articulo</th>
              <th>Pedido</th>
              <th>Disponible</th>
            </tr>

            {allArticulosAutorizar.map((a) => {
              if (a.disponible < a.cantidadPedido) {
                return (
                  <tr className="row-cancelled">
                    <td>{a.articuloNombre}</td>
                    <td>
                      {fmtNumber.format(a.cantidadPedido)}
                    </td>
                    <td>
                      {fmtNumber.format(a.disponible)}
                    </td>
                  </tr>
                );
              } else {
                return (
                  <tr>
                    <td>{a.articuloNombre}</td>
                    <td>
                      {fmtNumber.format(a.cantidadPedido)}
                    </td>
                    <td>
                      {fmtNumber.format(a.disponible)}
                    </td>
                  </tr>
                );
              }
            })}
          </Table>
        </ModalBody>
      </Modal> */}

      {/* Modal para gestionar abonos */}
      <Modal size="xl" isOpen={modalAbonos} toggle={toggleAbonos}>
        <ModalHeader toggle={toggleAbonos}>
          <h4>Gestión de Abonos del Pedido</h4>
        </ModalHeader>
        <ModalBody>
          {/* Tabla de abonos existentes */}
          {cargandoAbonos ? (
            <div className="text-center mb-4">
              <Spinner color="primary" />
              <p>Cargando abonos existentes...</p>
            </div>
          ) : abonosExistentes.length > 0 ? (
            <div className="mb-4">
              <h5>Abonos Existentes</h5>
              <Table size="sm" striped bordered responsive>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Importe</th>
                    <th>Forma de Pago</th>
                    <th>Banco</th>
                    <th>Validado</th>
                    <th>Imagen</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {abonosExistentes.map((abono) => (
                    <tr key={abono._id}>
                      <td>{moment(abono.fecha).format("DD/MM/YYYY")}</td>
                      <td>
                        {fmtCurrency.format(abono.importe)}
                      </td>
                      <td>{abono.formaPago}</td>
                      <td>
                        {abono.bancos?.[0]
                          ? `${abono.bancos[0].banco} / ${abono.bancos[0].cuenta}`
                          : "N/A"}
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            abono.validado === "Si"
                              ? "badge-success"
                              : "badge-warning"
                          }`}
                        >
                          {abono.validado == "Si" ? "Validado" : "No Validado"}
                        </span>
                      </td>
                      <td>
                        {abono.foto === "Si" && abono.urlFoto ? (
                          <div>
                            <img
                              src={abono.urlFoto}
                              alt="Comprobante"
                              style={{
                                width: "40px",
                                height: "40px",
                                objectFit: "cover",
                                cursor: "pointer",
                              }}
                              onClick={() => abrirPreviewImagen(abono)}
                            />
                          </div>
                        ) : abono.imagen ? (
                          <div>
                            <img
                              src={abono.imagen}
                              alt="Comprobante"
                              style={{
                                width: "40px",
                                height: "40px",
                                objectFit: "cover",
                                cursor: "pointer",
                              }}
                              onClick={() => abrirPreviewImagen(abono)}
                            />
                          </div>
                        ) : (
                          <div>
                            <Input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  subirImagenAbono(abono._id, file);
                                }
                              }}
                              style={{ fontSize: "12px", padding: "2px" }}
                            />
                          </div>
                        )}
                      </td>
                      <td>
                        {user.abonosValidar ? (
                          <div>
                            {abono.validado === "Si" ? (
                              <Button
                                size="sm"
                                color="warning"
                                onClick={() => validarAbono(abono._id, "No")}
                                title="Invalidar"
                              >
                                <i className="fas fa-times"></i>
                              </Button>
                            ) : (
                              <Button
                                size="sm"
                                color="success"
                                onClick={() => validarAbono(abono._id, "Si")}
                                title="Validar"
                              >
                                <i className="fas fa-check"></i>
                              </Button>
                            )}
                          </div>
                        ) : (
                          <span className="text-muted">Sin permisos</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <hr />
            </div>
          ) : (
            <div className="mb-4">
              <p className="text-muted">
                No se encontraron abonos existentes para este pedido.
              </p>
              <hr />
            </div>
          )}

          {/* Resumen de totales del pedido */}
          <div className="mb-4 p-3 border rounded">
            <Row>
              <Col md={4}>
                <Label><strong>Total:</strong></Label>
                <div className="h5 text-primary">
                  {fmtCurrency.format(totalGeneralAbono || 0)}
                </div>
              </Col>
              <Col md={4}>
                <Label><strong>Abonos:</strong></Label>
                <div className="h5 text-success">
                  {fmtCurrency.format(totalAbono || 0)}
                </div>
              </Col>
              <Col md={4}>
                <Label><strong>Saldo Pendiente:</strong></Label>
                <div className="h5 text-danger">
                  {fmtCurrency.format(saldoAbono || 0)}
                </div>
              </Col>
            </Row>
          </div>

          {parseFloat(saldoAbono) <= 0 ? (
            <div className="alert alert-success text-center">
              <i className="fas fa-check-circle fa-2x mb-2"></i>
              <h6 className="mb-0">¡Pedido Completamente Pagado!</h6>
              <p className="mb-0">El saldo es $0.00, no se pueden crear más abonos.</p>
            </div>
          ) : (
            <>
          {/* Formulario para crear nuevo abono */}
          <h5>Crear Nuevo Abono</h5>
              <Row>
                <Col md={6}>
                  <Label>Importe *</Label>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    placeholder="Ingresa el importe"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={abonoData.importe}
                    className="form-control"
                    onValueChange={(value) => {
                      handleAbonoChange("importe", value);
                    }}
                  />
                  {abonoData.importe > saldoAbono && (
                    <small className="text-warning">
                      <i className="fas fa-exclamation-triangle"></i>
                      El importe excede el saldo pendiente. Al validar se creará un anticipo por la diferencia.
                    </small>
                  )}
                </Col>
                <Col md={6}>
                  <Label>Forma de Pago *</Label>
                  <Input
                    type="select"
                    value={abonoData.formaPago}
                    onChange={(e) => handleAbonoChange("formaPago", e.target.value)}
                  >
                    <option value="">Selecciona forma de pago</option>
                    <option value="Efectivo">Efectivo</option>
                    <option value="Transferencia">Transferencia</option>
                    <option value="Cheque">Cheque</option>
                    <option value="Tarjeta">Tarjeta</option>
                    <option value="Deposito">Depósito</option>
                  </Input>
                </Col>
              </Row>
              <br />
              <Row>
                <Col md={4}>
                  <Label>Banco</Label>
                  <Input
                    type="select"
                    value={abonoData.banco}
                    onChange={(e) => handleAbonoChange("banco", e.target.value)}
                  >
                    <option value="">Selecciona banco</option>
                    {bancos.map((banco) => (
                      <option key={banco._id} value={banco._id}>
                        {banco.banco} / {banco.cuenta}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={4}>
                  <Label>Fecha del Pago</Label>
                  <Input
                    type="date"
                    value={abonoData.fechaPago}
                    onChange={(e) => handleAbonoChange("fechaPago", e.target.value)}
                  />
                </Col>
                <Col md={4}>
                  <Label>Concepto</Label>
                  <Input
                    type="text"
                    value={abonoData.concepto}
                    onChange={(e) => handleAbonoChange("concepto", e.target.value)}
                    onKeyDown={preventEnterSubmit}
                  />
                </Col>
              </Row>
              <br />
              <Row>
                <Col md={12}>
                  <Label>Observaciones</Label>
                  <Input
                    type="text"
                    rows="3"
                    value={abonoData.observaciones}
                    onChange={(e) =>
                      handleAbonoChange("observaciones", e.target.value)
                    }
                    placeholder="Observaciones adicionales"
                    onKeyDown={preventEnterSubmit}
                  />
                </Col>
              </Row>
              <br />
              <Row>
                <Col md={12}>
                  <Label>Imagen del Comprobante</Label>
                  <Input
                    type="file"
                    accept="image/*"
                    onChange={handleImagenChange}
                  />
                  <small className="text-muted">
                    Puedes subir la imagen ahora o después. Formatos: JPG, PNG, etc.
                  </small>
                </Col>
              </Row>
              <br />
              <div className="alert alert-info">
                <i className="fas fa-info-circle"></i> El abono será creado con
                estatus "No Validado" y deberá ser validado por un administrador.
              </div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleAbonos}>
            Cancelar
          </Button>
          <Button
            color="success"
            onClick={guardarAbono}
            disabled={!validaBoton || parseFloat(saldoAbono) === 0}
          >
            Guardar Nuevo Abono
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal para preview de imagen */}
      <Modal size="lg" isOpen={modalImagenPreview} toggle={toggleImagenPreview}>
        <ModalHeader toggle={toggleImagenPreview}>
          <h4>Vista Previa de Imagen</h4>
        </ModalHeader>
        <ModalBody className="text-center">
          {imagenPreview && (
            <div>
              <img
                src={imagenPreview}
                alt="Preview del comprobante"
                style={{
                  maxWidth: "100%",
                  maxHeight: "500px",
                  objectFit: "contain",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                }}
              />
              <div className="mt-3">
                <small className="text-muted">
                  Haz clic en "Eliminar" para quitar esta imagen del abono
                </small>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleImagenPreview}>
            Cerrar
          </Button>
          {abonoImagenSeleccionado && (
            <Button
              color="danger"
              onClick={() => {
                Swal.fire({
                  title: "¿Estás seguro?",
                  text: "Esta acción eliminará la imagen del abono",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#d33",
                  cancelButtonColor: "#3085d6",
                  confirmButtonText: "Sí, eliminar",
                  cancelButtonText: "Cancelar",
                }).then((result) => {
                  if (result.isConfirmed) {
                    eliminarImagenAbono(abonoImagenSeleccionado._id);
                  }
                });
              }}
            >
              <i className="fas fa-trash"></i> Eliminar Imagen
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoPedidos;
